"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3750],{

/***/ 90302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36713);
/* harmony import */ var _providers_AppData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3426);
/* harmony import */ var _hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75986);
/* harmony import */ var _providers_SearchReviews__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48889);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var useBuildTopStats = function(statistic) {
    var ref, ref1;
    var language = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_AppData__WEBPACK_IMPORTED_MODULE_1__/* .AppDataContext */ .R).language;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_SearchReviews__WEBPACK_IMPORTED_MODULE_3__/* .SearchReviewsContext */ .U), filters = ref2.state.filters, changeKeyword = ref2.changeKeyword;
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var translate = (0,_hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var variants = [
        "aqua",
        "coral",
        "lightBlue",
        "blue"
    ];
    var statColors = ((ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.common) === null || ref1 === void 0 ? void 0 : ref1.ratingBarChartColors) || [];
    var otherValue = translate("others");
    var statHover = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return [
            theme.palette.system.aqua,
            theme.palette.system.coral400,
            theme.palette.system.lightBlue600,
            theme.palette.blue[200]
        ];
    }, [
        theme
    ]);
    var transformedStatistic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var filtered = _toConsumableArray(statistic).filter(function(item) {
            return item.tagKeyword !== "specialty";
        });
        var sorted = _toConsumableArray(filtered).sort(function(a, b) {
            return b.tagCount - a.tagCount;
        });
        var allItems = sorted.map(function(stat, idx) {
            return _objectSpread({}, stat, {
                name: "".concat(stat.tagName[language], " (").concat(stat.tagCount, ")"),
                keyName: stat.tagName[language],
                value: stat.tagCount,
                isExpandButton: false,
                color: statColors[idx] || statColors[statColors.length - 1]
            });
        });
        var othersCount = sorted.slice(3).reduce(function(prev, curr) {
            return prev + curr.tagCount;
        }, 0);
        var topItems = allItems.slice(0, 3);
        if (othersCount) {
            var expandItems = _objectSpread({}, topItems[0], {
                name: "".concat(translate("others"), " (").concat(othersCount, ")"),
                keyName: translate("others"),
                value: othersCount,
                isExpandButton: true,
                color: statColors[statColors.length - 1]
            });
            allItems.push(expandItems);
            topItems.push(expandItems);
        }
        return {
            topItems: topItems,
            allItems: allItems
        };
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        statistic
    ]);
    var stats = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var top3Stat = (transformedStatistic.topItems.slice(0, 3) || []).map(function(stat) {
            return {
                value: stat.tagCount,
                name: stat.tagName[language]
            };
        });
        var topTotal = top3Stat.reduce(function(prev, curr) {
            return prev + curr.value;
        }, 0);
        var total = statistic.reduce(function(prev, curr) {
            return prev + curr.tagCount;
        }, 0);
        var topStatsList = transformedStatistic.topItems.map(function(item, idx) {
            return {
                value: item.value,
                name: item.keyName,
                hover: statHover[idx],
                variant: variants[idx],
                color: String(item.color)
            };
        });
        return {
            topStats: topStatsList,
            totalStatCount: total,
            topStatCount: topTotal,
            allItems: transformedStatistic.allItems
        };
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        statistic
    ]);
    var onSelectKeyword = function(value) {
        return changeKeyword(value === otherValue || value === filters.keyword ? "" : value);
    };
    return {
        stats: stats,
        onSelectKeyword: onSelectKeyword
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBuildTopStats);


/***/ }),

/***/ 82377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RatingBar; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Stack/Stack.esm.js + 1 modules
var Stack_esm = __webpack_require__(11854);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./providers/SearchReviews/index.tsx
var SearchReviews = __webpack_require__(48889);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/PhoneIconAlt/index.esm.js


const PhoneIconAlt = () => (react.createElement("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { d: "M9.00526 5.00922L6.87446 2.87842C6.48683 2.4908 5.8594 2.4875 5.46772 2.87102L4.96817 3.36017C3.02778 5.26016 2.95416 8.36687 4.85747 10.304C6.74557 12.2257 8.58644 14.0214 10.5885 15.9491C12.5527 17.8404 15.6736 17.8006 17.5959 15.8666L18.115 15.3444C18.5036 14.9535 18.5026 14.322 18.1129 13.9323L15.7413 11.5607C15.3508 11.1702 14.7176 11.1702 14.3271 11.5607L13.2758 12.612C12.912 12.9757 12.3298 13.0042 11.937 12.672C9.95574 10.9967 9.18956 10.1025 8.0588 8.78264L8.01365 8.72994C7.67205 8.33125 7.69303 7.73567 8.06428 7.36442L9.00526 6.42344C9.39578 6.03291 9.39578 5.39975 9.00526 5.00922Z", stroke: "currentColor", strokeWidth: "1.2" }),
    react.createElement("path", { d: "M6.40039 5.36523L8.03044 6.95488", stroke: "currentColor", strokeLinecap: "round" }),
    react.createElement("path", { d: "M4.98633 3.99609L5.37767 4.37774", stroke: "currentColor", strokeLinecap: "round" }),
    react.createElement("path", { d: "M15.1035 14.127L17.1236 16.147", stroke: "currentColor", strokeLinecap: "round" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/LocalPhone.esm.js
var LocalPhone_esm = __webpack_require__(91292);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/EmailOutlined/index.esm.js
var index_esm = __webpack_require__(60701);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/QuestionAnswer.esm.js
var QuestionAnswer_esm = __webpack_require__(71632);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Contact/index.esm.js



const ContactIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("rect", { x: "10.2883", y: "2.10675", width: "10.6917", height: "8.33818", rx: "1.5", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white', color: "transparent" }),
    react.createElement("path", { d: "M14.5094 6.74636L10.9185 2.67614C10.8831 2.63608 10.8636 2.58449 10.8636 2.53106C10.8636 2.40995 10.9618 2.31177 11.0829 2.31177H19.9887C20.0741 2.31177 20.1557 2.3472 20.2139 2.4096C20.3222 2.52553 20.3247 2.7047 20.2198 2.82364L16.759 6.74636C16.1619 7.42322 15.1065 7.42322 14.5094 6.74636Z", fill: (props === null || props === void 0 ? void 0 : props.color) || 'white', fillOpacity: "0.3", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white' }),
    react.createElement("path", { d: "M7.52674 6.86237L5.39594 4.73157C5.00832 4.34395 4.38088 4.34065 3.9892 4.72417L3.48966 5.21332C1.54926 7.11331 1.47564 10.22 3.37895 12.1572C5.26706 14.0788 7.10793 15.8745 9.10994 17.8022C11.0742 19.6935 14.1951 19.6537 16.1174 17.7198L16.6365 17.1975C17.025 16.8067 17.0241 16.1751 16.6344 15.7855L14.2628 13.4138C13.8722 13.0233 13.2391 13.0233 12.8486 13.4138L11.7973 14.4651C11.4335 14.8289 10.8513 14.8573 10.4585 14.5252C8.47723 12.8499 7.71104 11.9556 6.58029 10.6358L6.53513 10.5831C6.19353 10.1844 6.21452 9.58882 6.58576 9.21757L7.52674 8.27659C7.91727 7.88606 7.91727 7.2529 7.52674 6.86237Z", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white', color: "transparent", strokeWidth: "1.2" }),
    react.createElement("path", { d: "M4.92224 7.21857L6.55229 8.80821", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white', strokeLinecap: "round" }),
    react.createElement("path", { d: "M3.50745 5.84882L3.89879 6.23046", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white', strokeLinecap: "round" }),
    react.createElement("path", { d: "M13.6241 15.9801L15.6442 18.0002", stroke: (props === null || props === void 0 ? void 0 : props.color) || 'white', strokeLinecap: "round" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/CalendarOutlined/index.esm.js
var CalendarOutlined_index_esm = __webpack_require__(6736);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/EventAvailable.esm.js
var EventAvailable_esm = __webpack_require__(72396);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
;// CONCATENATED MODULE: ./components/RatingBar/constants.ts
var RATING_TYPE;
(function(RATING_TYPE) {
    RATING_TYPE["CLINIC"] = "clinic";
    RATING_TYPE["SPECIALIST"] = "specialist";
})(RATING_TYPE || (RATING_TYPE = {}));

// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(48189);
;// CONCATENATED MODULE: ./components/RatingBar/hooks/useRatingBarConfig.tsx







var useRatingBarConfig = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isUnclaimed = ref.isUnclaimed, isBasic = ref.isBasic, reviewsTotal = ref.reviewsTotal, peerRecommendationsCount = ref.peerRecommendationsCount, type = ref.type, bookingCalendarComponent = ref.bookingCalendarComponent;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isClinic = type === RATING_TYPE.CLINIC;
    var isLaptop = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("lg"));
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    var phoneIcon = (0,react.useMemo)(function() {
        if (locale === global/* TENANTS.WPA */.rk.WPA || newPersistentPanelEnabled) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIconAlt, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPhone_esm/* default */.Z, {});
        }
    }, [
        locale,
        newPersistentPanelEnabled
    ]);
    var emailIcon = (0,react.useMemo)(function() {
        if (locale === global/* TENANTS.WPA */.rk.WPA) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAnswer_esm/* default */.Z, {});
        }
    }, [
        locale
    ]);
    var contactIcon = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcon, {});
    }, []);
    var externalBookingLinkIcon = (0,react.useMemo)(function() {
        if (locale === global/* TENANTS.WPA */.rk.WPA || newPersistentPanelEnabled) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarOutlined_index_esm/* default */.Z, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventAvailable_esm/* default */.Z, {});
        }
    }, [
        locale,
        newPersistentPanelEnabled
    ]);
    var displayNewBadge = (0,react.useMemo)(function() {
        return isUnclaimed || !reviewsTotal && !peerRecommendationsCount;
    }, [
        isUnclaimed,
        reviewsTotal,
        peerRecommendationsCount
    ]);
    var displayEndorsementsChart = (0,react.useMemo)(function() {
        if (locale === global/* TENANTS.WPA */.rk.WPA) {
            return !(isBasic || isUnclaimed) && !isClinic;
        } else {
            return !(isBasic || isUnclaimed);
        }
    }, [
        locale,
        isBasic,
        isUnclaimed,
        isClinic
    ]);
    var displayRecentReview = (0,react.useMemo)(function() {
        if (locale === global/* TENANTS.WPA */.rk.WPA) {
            return !bookingCalendarComponent || isLaptop;
        } else {
            return true;
        }
    }, [
        locale,
        isLaptop,
        bookingCalendarComponent
    ]);
    return {
        phoneIcon: phoneIcon,
        emailIcon: emailIcon,
        contactIcon: contactIcon,
        externalBookingLinkIcon: externalBookingLinkIcon,
        displayNewBadge: displayNewBadge,
        displayEndorsementsChart: displayEndorsementsChart,
        displayRecentReview: displayRecentReview
    };
};
/* harmony default export */ var hooks_useRatingBarConfig = (useRatingBarConfig);

// EXTERNAL MODULE: ./components/RatingBar/hooks/useBuildTopStats.tsx
var useBuildTopStats = __webpack_require__(90302);
// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/index.tsx + 2 modules
var StarsComponent = __webpack_require__(66621);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/DonutChart/index.esm.js
var DonutChart_index_esm = __webpack_require__(37727);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Paper/Paper.esm.js + 2 modules
var Paper_esm = __webpack_require__(41212);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ./components/profiles/ProfileModal/SpecialistPracticeBookingCard/Layout.tsx + 1 modules
var Layout = __webpack_require__(2496);
;// CONCATENATED MODULE: ./components/RatingBar/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var StyledRevealsContainer = (0,styled_esm/* default */.ZP)(Layout/* RevealsContainer */.B)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        "& > button, & > a": {
            flex: 1
        },
        padding: "16px"
    }, _defineProperty(_obj, theme.breakpoints.up("lg"), {
        borderTop: "1px solid ".concat(theme.palette.grey[600])
    }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
        borderTop: "1px solid ".concat(theme.palette.grey[600]),
        position: "fixed",
        bottom: 0,
        zIndex: 9,
        left: 0,
        backgroundColor: theme.palette.common.white
    }), _obj;
});
var DonutChartContainer = (0,styled_esm/* default */.ZP)(DonutChart_index_esm/* default */.Z)({
    "&.donut": {
        minWidth: 120,
        minHeight: 120,
        padding: "10px",
        width: 100,
        height: 100,
        marginLeft: "-16px"
    }
});
var RootWrapper = (0,styled_esm/* default */.ZP)(Paper_esm/* default */.Z, {
    shouldForwardProp: function(propName) {
        return propName !== "elementOffset";
    }
})(function(param) {
    var theme = param.theme, elementOffset = param.elementOffset;
    var _obj;
    return _obj = {
        boxShadow: "0px 6px 10px rgba(2, 3, 3, 0.03), 0px 1px 18px rgba(2, 3, 3, 0.02), 0px 3px 5px rgba(2, 3, 3, 0.04)",
        maxWidth: 415,
        marginLeft: "auto",
        width: "100%",
        color: theme.palette.text.darkNavy,
        border: "1px solid ".concat(theme.palette.secondary.light)
    }, _defineProperty(_obj, theme.breakpoints.down("lg"), {
        backgroundColor: "inherit",
        border: "none",
        maxWidth: "none",
        boxShadow: "none"
    }), _defineProperty(_obj, theme.breakpoints.up("lg"), {
        position: "sticky",
        top: elementOffset,
        zIndex: 1051
    }), _obj;
});
var SectionWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderTop: "1px solid ".concat(theme.palette.secondary.light),
        padding: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
    }, theme.breakpoints.down("xs"), {
        px: 0
    });
});
var StyledChip = (0,styled_esm/* default */.ZP)(Chip_esm/* default */.Z)(function() {
    return {
        border: 1,
        color: "inherit",
        maxWidth: "100%"
    };
});
var RootContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(propName) {
        return propName !== "height";
    }
})(function(param) {
    var theme = param.theme, height = param.height;
    return _defineProperty({
        width: "calc(100% - 32px)"
    }, theme.breakpoints.up("lg"), {
        position: "absolute",
        top: 0,
        right: 0,
        height: height,
        maxWidth: 415
    });
});
var StarsContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        justifyContent: "center"
    };
});

// EXTERNAL MODULE: ./components/profiles/ProfileModal/SpecialistPracticeBookingCard/ContactDescription.tsx
var ContactDescription = __webpack_require__(59604);
// EXTERNAL MODULE: ./components/RevealLink.tsx + 1 modules
var RevealLink = __webpack_require__(22840);
// EXTERNAL MODULE: ./constants/profile.ts
var profile = __webpack_require__(50081);
// EXTERNAL MODULE: ./providers/AppData/Profile/index.tsx
var Profile = __webpack_require__(33228);
;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/variants/default/index.tsx












var revealBookKey = "bookAppointment.reveal.book";
var ActionPanel = function(param1) {
    var isClinic = param1.isClinic, contacts = param1.contacts, onClickReveal = param1.onClickReveal, onClickBookAppointment = param1.onClickBookAppointment;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var locale = (0,router.useRouter)().locale;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref10 = hooks_useRatingBarConfig(), phoneIcon = ref10.phoneIcon, emailIcon = ref10.emailIcon, externalBookingLinkIcon = ref10.externalBookingLinkIcon;
    var ref11 = (0,react.useContext)(Profile/* ProfileContext */.J), specialist = ref11.specialist, practice = ref11.practice;
    var hasExtraStyles = locale === global/* TENANTS.WPA */.rk.WPA;
    var emailHref = isMobile ? "mailto:".concat(contacts === null || contacts === void 0 ? void 0 : (ref = contacts[0]) === null || ref === void 0 ? void 0 : ref.email, "?subject=").concat(translate("email.subject")) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRevealsContainer, {
        children: isClinic ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !!contacts[0].phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                    contactValue: contacts[0].phone,
                    description: translate("phone_no"),
                    href: "tel:".concat(contacts[0].phone),
                    revealName: isMobile ? translate("call") : contacts[0].phone,
                    slug: contacts[0].profileSlug,
                    active: true,
                    skipReveal: isMobile,
                    icon: phoneIcon,
                    revealTitle: translate("call"),
                    requestType: profile/* RequestTypes.PHONE */.lO.PHONE,
                    onClickLinkHandler: function() {
                        return onClickReveal(isMobile ? "prf_pg_cont_popup_reveal_tel" : "prf_pg_cont_popup_tel_link", "Call", contacts[0].contactName, contacts[0].externalId);
                    },
                    onClickRevealHandler: function() {
                        return onClickReveal("prf_pg_cont_popup_reveal_tel", "Call", contacts[0].contactName, contacts[0].externalId);
                    }
                }),
                !!contacts[0].email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                    contactValue: contacts[0].email,
                    description: translate("email"),
                    href: emailHref,
                    revealLink: emailHref,
                    revealName: isMobile ? translate("email") : contacts[0].email,
                    slug: contacts[0].profileSlug,
                    active: true,
                    skipReveal: isMobile,
                    icon: emailIcon,
                    revealTitle: translate("bookAppointment.reveal.email"),
                    requestType: profile/* RequestTypes.EMAIL */.lO.EMAIL,
                    onClickLinkHandler: function() {
                        !isMobile && navigator.clipboard.writeText(contacts[0].email || "");
                        onClickReveal("prf_pg_cont_popup_reveal_email", "Email", contacts[0].contactName, contacts[0].externalId);
                    },
                    onClickRevealHandler: function() {
                        return onClickReveal("prf_pg_cont_popup_reveal_email", "Email", contacts[0].contactName, contacts[0].externalId);
                    }
                }),
                !!contacts[0].externalBookingLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                    contactValue: contacts[0].externalBookingLink,
                    active: true,
                    description: translate("book"),
                    href: contacts[0].externalBookingLink,
                    specialistId: specialist === null || specialist === void 0 ? void 0 : specialist.id,
                    practiceId: practice === null || practice === void 0 ? void 0 : practice.id,
                    bookingButton: true,
                    skipReveal: true,
                    revealName: "",
                    slug: practice === null || practice === void 0 ? void 0 : practice.slug,
                    revealLink: contacts[0].externalBookingLink,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            externalBookingLinkIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: translate(revealBookKey)
                            })
                        ]
                    }),
                    revealTitle: translate(revealBookKey),
                    requestType: profile/* RequestTypes.EXTERNAL_BOOKING_LINK */.lO.EXTERNAL_BOOKING_LINK,
                    onClickLinkHandler: function() {
                        return onClickReveal("prf_pg_book_popup_booking_link", "Book", contacts[0].contactName, contacts[0].externalId);
                    }
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                contacts.some(function(param) {
                    var phone = param.phone;
                    return !!phone;
                }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevealLink/* DetailsLink */.ZC, {
                    color: (ref1 = theme.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.SpecialistPage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.trustScore) === null || ref3 === void 0 ? void 0 : ref3.textColor,
                    type: "primary",
                    sx: {
                        flex: 1
                    },
                    onClick: function() {
                        return onClickBookAppointment("call", "Call");
                    },
                    isWPA: hasExtraStyles,
                    children: [
                        phoneIcon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translate("call")
                        })
                    ]
                }),
                contacts.some(function(param) {
                    var email = param.email;
                    return !!email;
                }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevealLink/* DetailsLink */.ZC, {
                    color: (ref4 = theme.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.SpecialistPage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.trustScore) === null || ref6 === void 0 ? void 0 : ref6.textColor,
                    type: "primary",
                    sx: {
                        flex: 1
                    },
                    onClick: function() {
                        return onClickBookAppointment("email", "Email");
                    },
                    isWPA: hasExtraStyles,
                    children: [
                        emailIcon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translate("email")
                        })
                    ]
                }),
                contacts.some(function(param) {
                    var externalBookingLink = param.externalBookingLink;
                    return !!externalBookingLink;
                }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevealLink/* DetailsLink */.ZC, {
                    color: (ref7 = theme.custom) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.SpecialistPage) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.trustScore) === null || ref9 === void 0 ? void 0 : ref9.textColor,
                    type: "primary",
                    sx: {
                        flex: 1
                    },
                    onClick: function() {
                        return onClickBookAppointment("book", "Book");
                    },
                    isWPA: hasExtraStyles,
                    children: [
                        externalBookingLinkIcon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translate(revealBookKey)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var variants_default = (ActionPanel);

;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/variants/minimal/SpecialistPanel.tsx








var SpecialistPanel = function(param1) {
    var contacts = param1.contacts, onClickBookAppointment = param1.onClickBookAppointment, onlineBookingAvailable = param1.onlineBookingAvailable;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var locale = (0,router.useRouter)().locale;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref6 = hooks_useRatingBarConfig(), contactIcon = ref6.contactIcon, externalBookingLinkIcon = ref6.externalBookingLinkIcon;
    var phoneAvailable = (0,react.useMemo)(function() {
        return contacts.some(function(param) {
            var phone = param.phone;
            return !!phone;
        });
    }, [
        contacts
    ]);
    var emailAvailable = (0,react.useMemo)(function() {
        return contacts.some(function(param) {
            var email = param.email;
            return !!email;
        });
    }, [
        contacts
    ]);
    var externalBookingAvailable = (0,react.useMemo)(function() {
        return contacts.some(function(param) {
            var externalBookingLink = param.externalBookingLink;
            return !!externalBookingLink;
        });
    }, [
        contacts
    ]);
    var hasExtraStyles = locale === global/* TENANTS.WPA */.rk.WPA;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            phoneAvailable || emailAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevealLink/* DetailsLink */.ZC, {
                color: (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SpecialistPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.trustScore) === null || ref2 === void 0 ? void 0 : ref2.textColor,
                type: "primary",
                sx: {
                    flex: 1
                },
                onClick: function() {
                    return onClickBookAppointment("contact", "Contact");
                },
                isWPA: hasExtraStyles,
                children: [
                    contactIcon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translate("contact")
                    })
                ]
            }) : null,
            externalBookingAvailable || onlineBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevealLink/* DetailsLink */.ZC, {
                color: (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SpecialistPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.trustScore) === null || ref5 === void 0 ? void 0 : ref5.textColor,
                type: "primary",
                sx: {
                    flex: 1
                },
                onClick: function() {
                    return onClickBookAppointment("book", "Book");
                },
                isWPA: hasExtraStyles,
                children: [
                    externalBookingLinkIcon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translate(onlineBookingAvailable ? "bookAppointment.book_online" : "bookAppointment.reveal.book")
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var minimal_SpecialistPanel = (SpecialistPanel);

;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/variants/minimal/PracticePanel.tsx








var PracticePanel = function(param) {
    var contacts = param.contacts, onClickReveal = param.onClickReveal;
    var ref;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref1 = (0,react.useContext)(Profile/* ProfileContext */.J), specialist = ref1.specialist, practice = ref1.practice;
    var ref2 = hooks_useRatingBarConfig(), phoneIcon = ref2.phoneIcon, emailIcon = ref2.emailIcon, externalBookingLinkIcon = ref2.externalBookingLinkIcon;
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var firstContact = (0,react.useMemo)(function() {
        return contacts[0];
    }, [
        contacts
    ]);
    var emailHref = isMobile ? "mailto:".concat(contacts === null || contacts === void 0 ? void 0 : (ref = contacts[0]) === null || ref === void 0 ? void 0 : ref.email, "?subject=").concat(translate("email.subject")) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!firstContact.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                contactValue: firstContact.phone,
                description: translate("phone_no"),
                href: "tel:".concat(firstContact.phone),
                revealName: isMobile ? translate("call") : firstContact.phone,
                slug: firstContact.profileSlug,
                active: true,
                skipReveal: isMobile,
                icon: phoneIcon,
                revealTitle: translate("call"),
                requestType: profile/* RequestTypes.PHONE */.lO.PHONE,
                onClickLinkHandler: function() {
                    return onClickReveal(isMobile ? "prf_pg_cont_popup_reveal_tel" : "prf_pg_cont_popup_tel_link", "Call", firstContact.contactName, firstContact.externalId);
                },
                onClickRevealHandler: function() {
                    return onClickReveal("prf_pg_cont_popup_reveal_tel", "Call", firstContact.contactName, firstContact.externalId);
                }
            }),
            !!firstContact.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                contactValue: firstContact.email,
                description: translate("email"),
                href: emailHref,
                revealLink: emailHref,
                revealName: isMobile ? translate("email") : firstContact.email,
                slug: firstContact.profileSlug,
                active: true,
                skipReveal: isMobile,
                icon: emailIcon,
                revealTitle: translate("bookAppointment.reveal.email"),
                requestType: profile/* RequestTypes.EMAIL */.lO.EMAIL,
                onClickLinkHandler: function() {
                    !isMobile && navigator.clipboard.writeText(firstContact.email || "");
                    onClickReveal("prf_pg_cont_popup_reveal_email", "Email", firstContact.contactName, firstContact.externalId);
                },
                onClickRevealHandler: function() {
                    return onClickReveal("prf_pg_cont_popup_reveal_email", "Email", firstContact.contactName, firstContact.externalId);
                }
            }),
            !!firstContact.externalBookingLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactDescription/* default */.Z, {
                contactValue: firstContact.externalBookingLink,
                active: true,
                description: translate("book"),
                href: firstContact.externalBookingLink,
                specialistId: specialist === null || specialist === void 0 ? void 0 : specialist.id,
                practiceId: practice === null || practice === void 0 ? void 0 : practice.id,
                bookingButton: true,
                skipReveal: true,
                revealName: "",
                slug: practice === null || practice === void 0 ? void 0 : practice.slug,
                revealLink: firstContact.externalBookingLink,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        externalBookingLinkIcon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translate("bookAppointment.reveal.book")
                        })
                    ]
                }),
                revealTitle: translate("bookAppointment.reveal.book"),
                requestType: profile/* RequestTypes.EXTERNAL_BOOKING_LINK */.lO.EXTERNAL_BOOKING_LINK,
                onClickLinkHandler: function() {
                    return onClickReveal("prf_pg_book_popup_booking_link", "Book", firstContact.contactName, firstContact.externalId);
                }
            })
        ]
    });
};
/* harmony default export */ var minimal_PracticePanel = (PracticePanel);

;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/variants/minimal/styles.ts
function styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var ButtonsPanelWrapper = (0,styled_esm/* default */.ZP)(StyledRevealsContainer)(function(param) {
    var theme = param.theme;
    return styles_defineProperty({
        padding: "12px 14px"
    }, theme.breakpoints.up("lg"), {
        margin: "0 -25px",
        width: "calc(100% + 50px)",
        padding: "11px 25px"
    });
});

;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/variants/minimal/index.tsx








var minimal_ActionPanel = function(param) {
    var isClinic = param.isClinic, contacts = param.contacts, onClickReveal = param.onClickReveal, onClickBookAppointment = param.onClickBookAppointment, onlineBookingAvailable = param.onlineBookingAvailable;
    var locale = (0,router.useRouter)().locale;
    // refer to an old designed container for WPA
    var Container = (0,react.useMemo)(function() {
        return locale === global/* TENANTS.WPA */.rk.WPA ? StyledRevealsContainer : ButtonsPanelWrapper;
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: isClinic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal_PracticePanel, {
            contacts: contacts,
            onClickReveal: onClickReveal
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal_SpecialistPanel, {
            contacts: contacts,
            onlineBookingAvailable: onlineBookingAvailable,
            onClickBookAppointment: onClickBookAppointment
        })
    });
};
/* harmony default export */ var minimal = (minimal_ActionPanel);

;// CONCATENATED MODULE: ./components/RatingBar/components/ActionPanel/index.tsx
function ActionPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ActionPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var ActionPanel_ActionPanel = function(props) {
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    if (newPersistentPanelEnabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_default, _objectSpread({}, props));
};
/* harmony default export */ var components_ActionPanel = (ActionPanel_ActionPanel);

// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/types.ts
var types = __webpack_require__(42038);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/CheckboxCircle/index.esm.js
var CheckboxCircle_index_esm = __webpack_require__(16697);
;// CONCATENATED MODULE: ./components/RatingBar/components/EndorsementsChart/minimal.tsx
function minimal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function minimal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            minimal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var EndorsementsChart = function(param) {
    var statistic = param.statistic;
    var ref = (0,react.useContext)(SearchReviews/* SearchReviewsContext */.U), filters = ref.state.filters;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref1 = (0,useBuildTopStats/* default */.Z)(statistic), _stats = ref1.stats, topStats = _stats.topStats, totalStatCount = _stats.totalStatCount, onSelectKeyword = ref1.onSelectKeyword;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!topStats.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            direction: "column",
            sx: {
                pt: {
                    sm: "15px"
                },
                pb: {
                    lg: "0",
                    sm: "15px"
                },
                width: "auto",
                borderTop: {
                    lg: "1px solid ".concat(theme.palette.grey[600])
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    variant: "body2",
                    component: "h3",
                    sx: {
                        color: "#11245A",
                        whiteSpace: "nowrap",
                        pb: 2
                    },
                    children: translate("reviews.total_recommendations_count_for", {
                        total: totalStatCount
                    }, {
                        bold: {
                            fontWeight: 500,
                            fontSize: "13px"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    item: true,
                    xs: true,
                    direction: "row",
                    wrap: "nowrap",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DonutChart_index_esm/* default */.Z, {
                            width: 120,
                            height: 120,
                            data: topStats,
                            thickness: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                            ml: 1,
                            container: true,
                            maxWidth: "60%",
                            item: true,
                            alignContent: "start",
                            spacing: 1,
                            children: topStats.map(function(keyword) {
                                if (!keyword) {
                                    return null;
                                }
                                var name = keyword.name, value = keyword.value, variant = keyword.variant, color = keyword.color;
                                var isKeywordSelected = filters.keyword === name;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    item: true,
                                    xs: 12,
                                    alignItems: "center",
                                    spacing: 0.5,
                                    wrap: "nowrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                            sx: {
                                                marginRight: 1,
                                                backgroundColor: color,
                                                width: 8,
                                                height: 8,
                                                flexShrink: 0,
                                                borderRadius: "50%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChip, {
                                            variant: variant,
                                            onClick: function() {
                                                onSelectKeyword(name);
                                            },
                                            clickable: true,
                                            sx: {
                                                ".MuiChip-label": minimal_objectSpread({
                                                    paddingLeft: isKeywordSelected ? 0 : "8px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "3px"
                                                }, theme.typography.caption)
                                            },
                                            component: "a",
                                            href: "#reviews",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    isKeywordSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCircle_index_esm/* default */.Z, {
                                                        sx: {
                                                            marginRight: isKeywordSelected ? "2px" : 0,
                                                            width: "18.33px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            maxWidth: "100%",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis"
                                                        },
                                                        children: name
                                                    }),
                                                    !isKeywordSelected && "(".concat(value, ")")
                                                ]
                                            })
                                        })
                                    ]
                                }, "".concat(name, "-").concat(value, "-").concat(variant));
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var EndorsementsChart_minimal = (EndorsementsChart);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var styles = __webpack_require__(8971);
;// CONCATENATED MODULE: ./components/RatingBar/components/EndorsementsChart/default.tsx
function default_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var default_EndorsementsChart = function(param) {
    var isBookingAvailable = param.isBookingAvailable, statistic = param.statistic;
    var ref6;
    var ref1 = (0,react.useContext)(SearchReviews/* SearchReviewsContext */.U), filters = ref1.state.filters;
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref2 = (0,styles/* themedColor */.St)(), chipsTextColor = ref2.chipsTextColor, endorsementsBackground = ref2.endorsementsBackground;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref3 = (0,useBuildTopStats/* default */.Z)(statistic), _stats = ref3.stats, topStats = _stats.topStats, totalStatCount = _stats.totalStatCount, onSelectKeyword = ref3.onSelectKeyword;
    var TopStats = function() {
        var ref, ref4, ref5;
        return !!topStats.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            mb: 2,
            direction: "column",
            sx: {
                px: {
                    lg: 2
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    textTransform: (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref4 = ref.RatingBar) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sectionTitle) === null || ref5 === void 0 ? void 0 : ref5.textTransform,
                    color: "text.dark",
                    variant: "body2",
                    component: "h3",
                    sx: {
                        whiteSpace: "nowrap",
                        pb: {
                            md: 1,
                            xs: 1.5
                        }
                    },
                    children: translate("reviews.total_recommendations_count_for", {
                        total: totalStatCount
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    item: true,
                    xs: true,
                    direction: "row",
                    wrap: "nowrap",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DonutChart_index_esm/* default */.Z, {
                            width: 100,
                            height: 100,
                            data: topStats,
                            thickness: 6
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                            ml: 1,
                            container: true,
                            maxWidth: "60%",
                            item: true,
                            alignContent: "start",
                            spacing: 1,
                            children: topStats.map(function(keyword) {
                                if (!keyword) {
                                    return null;
                                }
                                var name = keyword.name, value = keyword.value, variant = keyword.variant, color = keyword.color;
                                var isKeywordSelected = filters.keyword === name;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    item: true,
                                    xs: 12,
                                    alignItems: "center",
                                    spacing: 0.5,
                                    wrap: "nowrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                            sx: {
                                                marginRight: 1,
                                                backgroundColor: color,
                                                width: 8,
                                                height: 8,
                                                flexShrink: 0,
                                                borderRadius: "50%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChip, {
                                            variant: variant,
                                            onClick: function() {
                                                onSelectKeyword(name);
                                            },
                                            clickable: true,
                                            sx: {
                                                ".MuiChip-label": default_objectSpread({
                                                    paddingLeft: isKeywordSelected ? 0 : "8px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "3px"
                                                }, theme.typography.caption)
                                            },
                                            component: "a",
                                            href: "#reviews",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    isKeywordSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCircle_index_esm/* default */.Z, {
                                                        sx: {
                                                            marginRight: isKeywordSelected ? "2px" : 0,
                                                            width: "18.33px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            maxWidth: "100%",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis"
                                                        },
                                                        children: name
                                                    }),
                                                    !isKeywordSelected && "(".concat(value, ")")
                                                ]
                                            })
                                        })
                                    ]
                                }, "".concat(name, "-").concat(value, "-").concat(variant));
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isBookingAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                        lgUp: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopStats, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                        lgDown: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                            container: true,
                            py: "16px",
                            px: {
                                lg: 2
                            },
                            direction: "column",
                            sx: {
                                borderTop: "1px solid #D5DEF9",
                                borderBottom: "1px solid #D5DEF9"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                                    variant: "body2",
                                    component: "h3",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                    color: "#112971",
                                    mb: "8px",
                                    children: [
                                        totalStatCount,
                                        " recommendations for:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                    children: (ref6 = topStats === null || topStats === void 0 ? void 0 : topStats.filter(Boolean)) === null || ref6 === void 0 ? void 0 : ref6.map(function(keyword) {
                                        if (!keyword) {
                                            return null;
                                        }
                                        var name = keyword.name, value = keyword.value, variant = keyword.variant;
                                        var isKeywordSelected = filters.keyword === name;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                            component: Link_esm/* default */.Z,
                                            href: "#reviews",
                                            onClick: function() {
                                                return onSelectKeyword(name);
                                            },
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                children: [
                                                    isKeywordSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCircle_index_esm/* default */.Z, {
                                                        sx: {
                                                            width: "22px",
                                                            height: "22px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        whiteSpace: "nowrap",
                                                        textOverflow: "ellipsis",
                                                        overflow: "hidden",
                                                        variant: isKeywordSelected ? "body2" : "caption",
                                                        color: isKeywordSelected ? "#1A3586" : chipsTextColor,
                                                        fontWeight: 500,
                                                        children: keyword.name
                                                    })
                                                ]
                                            }),
                                            sx: {
                                                ":hover": {
                                                    backgroundColor: isKeywordSelected ? "rgba(0, 229, 208, 0.3)" : "#CCFAF6"
                                                },
                                                backgroundColor: isKeywordSelected ? "rgba(0, 229, 208, 0.2)" : endorsementsBackground,
                                                ".MuiChip-label": {
                                                    paddingLeft: isKeywordSelected ? "2px" : "8px"
                                                },
                                                cursor: "pointer",
                                                border: "0.5px ".concat(chipsTextColor, " solid")
                                            }
                                        }, "".concat(name, "-").concat(value, "-").concat(variant));
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !isBookingAvailable && !!topStats.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopStats, {})
        ]
    });
};
/* harmony default export */ var EndorsementsChart_default = (default_EndorsementsChart);

;// CONCATENATED MODULE: ./components/RatingBar/components/EndorsementsChart/index.tsx
function EndorsementsChart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EndorsementsChart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EndorsementsChart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var EndorsementsChart_EndorsementsChart = function(_param) {
    var variant = _param.variant, props = _objectWithoutProperties(_param, [
        "variant"
    ]);
    if (variant === types/* Variants.minimal */.t.minimal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EndorsementsChart_minimal, EndorsementsChart_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EndorsementsChart_default, EndorsementsChart_objectSpread({}, props));
};
/* harmony default export */ var components_EndorsementsChart = (EndorsementsChart_EndorsementsChart);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var Rating_index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ./hooks/useDatetimeCorrector.ts
var useDatetimeCorrector = __webpack_require__(8273);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(5892);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(16062);
;// CONCATENATED MODULE: ./components/RatingBar/components/RecentReviewComponent/minimal.tsx
function RecentReviewComponent_minimal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecentReviewComponent_minimal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecentReviewComponent_minimal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Wrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        borderTop: "1px solid ".concat(theme.palette.grey[600]),
        paddingTop: "16px"
    };
});
var SectionWrapperComponent = function(param) {
    var title = param.title, latestReview = param.latestReview, outDatedTitle = param.outDatedTitle, href = param.href, shouldShow = param.shouldShow;
    var dateTime = (0,useDatetimeCorrector/* useDateTimeCorrector */.B)(latestReview === null || latestReview === void 0 ? void 0 : latestReview.createdAt);
    var theme = (0,useTheme_esm/* default */.Z)();
    var textLatestReview = latestReview && "text" in latestReview ? latestReview.text : latestReview === null || latestReview === void 0 ? void 0 : latestReview.recommendation;
    var latestReviewCut = !!textLatestReview && (0,strings/* truncateString */.aS)(textLatestReview);
    var isOlderThanSixMonth = (0,date/* isOlderThanNMonth */.iD)(6, latestReview === null || latestReview === void 0 ? void 0 : latestReview.createdAt);
    var reviewRating = latestReview && "averageRating" in latestReview ? latestReview === null || latestReview === void 0 ? void 0 : latestReview.averageRating : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        direction: "column",
        children: [
            !!latestReview && !isOlderThanSixMonth || shouldShow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                justifyContent: "space-between",
                mb: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        sx: {
                            fontWeight: "500"
                        },
                        variant: "body2",
                        component: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "8px"
                        },
                        children: [
                            reviewRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_index_esm/* default */.Z, {
                                    value: reviewRating,
                                    size: "xxs",
                                    readOnly: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "subtitle2",
                                component: "p",
                                fontWeight: 400,
                                color: "text.secondary",
                                children: dateTime
                            })
                        ]
                    })
                ]
            }) : null,
            !!latestReview && latestReview.id && !isOlderThanSixMonth || shouldShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    component: Link_esm/* default */.Z,
                    href: href,
                    variant: "body1",
                    sx: RecentReviewComponent_minimal_objectSpread({
                        maxHeight: 45,
                        maxWidth: "100%",
                        overflow: "hidden",
                        textDecoration: "inherit"
                    }, theme.custom.SpecialistPage.ratingBar.reviewText),
                    children: latestReviewCut
                })
            }) : null,
            isOlderThanSixMonth && outDatedTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                sx: {
                    fontWeight: "500"
                },
                variant: "body2",
                component: "h3",
                children: outDatedTitle
            }) : null
        ]
    });
};
var Minimal = function(param) {
    var isUnclaimed = param.isUnclaimed, type = param.type, isBasic = param.isBasic, latestReview = param.latestReview, peerRecommendation = param.peerRecommendation;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var isSpecialist = type === RATING_TYPE.SPECIALIST;
    var showReview = !isBasic && !isUnclaimed && !!(latestReview === null || latestReview === void 0 ? void 0 : latestReview.id);
    var showEndorsement = isSpecialist && !!(peerRecommendation === null || peerRecommendation === void 0 ? void 0 : peerRecommendation.recommendation);
    return showReview || showEndorsement ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            component: Hidden_esm/* default */.Z,
            lgDown: true,
            implementation: "css",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px"
                },
                children: [
                    showReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapperComponent, {
                        title: translate("reviews.latest_patient_review", {}, {
                            bold: {
                                fontWeight: 500,
                                fontSize: "13px"
                            }
                        }),
                        latestReview: latestReview,
                        outDatedTitle: translate("no_review_over_6_month_general"),
                        href: "#reviews"
                    }) : null,
                    showEndorsement ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapperComponent, {
                        title: translate("peerRecommendations.latest_skill_endorsement", {}, {
                            bold: {
                                fontWeight: 500,
                                fontSize: "13px"
                            }
                        }),
                        latestReview: peerRecommendation,
                        outDatedTitle: "",
                        shouldShow: true,
                        href: "#endorsements"
                    }) : null
                ]
            })
        })
    }) : null;
};
/* harmony default export */ var RecentReviewComponent_minimal = (Minimal);

;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/NoReviewsImage/index.esm.js


const NoReviewsImageIcon = ({ width = '218', height = '113' }) => (react.createElement("svg", { width: width, height: height, viewBox: "0 0 218 113", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("rect", { width: "202.662", height: "112.669", rx: "6.23577", fill: "#051851" }),
    react.createElement("rect", { width: "202.662", height: "112.669", rx: "6.23577", fill: "url(#paint0_linear_3886_28276)", fillOpacity: "0.7" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.6989 34.4498C42.3186 34.2547 41.8643 34.2547 41.484 34.4498L36.2804 37.1192C35.3228 37.6104 34.2036 36.817 34.3865 35.7765L35.3803 30.1227C35.4529 29.7095 35.3125 29.2879 35.0048 28.9953L30.795 24.9913C30.0203 24.2544 30.4478 22.9705 31.5185 22.8187L37.3363 21.9939C37.7615 21.9336 38.129 21.673 38.3191 21.2971L40.9209 16.1531C41.3997 15.2064 42.7832 15.2065 43.262 16.1531L45.8638 21.2971C46.054 21.673 46.4215 21.9336 46.8467 21.9939L52.6645 22.8187C53.7351 22.9705 54.1627 24.2544 53.3879 24.9913L49.1781 28.9953C48.8705 29.2879 48.7301 29.7095 48.8027 30.1227L49.7965 35.7765C49.9794 36.817 48.8601 37.6104 47.9025 37.1192L42.6989 34.4498Z", fill: "#00E5D0" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.9008 36.4145L41.1044 33.7452C41.7224 33.4282 42.4606 33.4282 43.0785 33.7452L48.2822 36.4145C48.6413 36.5988 49.061 36.3012 48.9924 35.911L47.9986 30.2572C47.8806 29.5858 48.1087 28.9008 48.6086 28.4253L52.8185 24.4212C53.109 24.1449 52.9487 23.6634 52.5472 23.6065L46.7293 22.7816C46.0385 22.6837 45.4412 22.2603 45.1322 21.6494L42.5304 16.5054C42.3509 16.1504 41.8321 16.1504 41.6525 16.5054L39.0507 21.6494C38.7417 22.2603 38.1445 22.6837 37.4536 22.7816L31.6358 23.6065C31.2343 23.6634 31.074 24.1449 31.3645 24.4212L35.5743 28.4253C36.0742 28.9008 36.3024 29.5858 36.1844 30.2572L35.1906 35.911C35.122 36.3012 35.5417 36.5988 35.9008 36.4145ZM41.484 34.4498C41.8643 34.2547 42.3186 34.2547 42.6989 34.4498L47.9025 37.1192C48.8601 37.6104 49.9794 36.817 49.7965 35.7765L48.8027 30.1227C48.7301 29.7095 48.8705 29.2879 49.1781 28.9953L53.3879 24.9913C54.1627 24.2544 53.7351 22.9705 52.6645 22.8187L46.8467 21.9939C46.4215 21.9336 46.054 21.673 45.8638 21.2971L43.262 16.1531C42.7832 15.2065 41.3997 15.2064 40.9209 16.1531L38.3191 21.2971C38.129 21.673 37.7615 21.9336 37.3363 21.9939L31.5185 22.8187C30.4478 22.9705 30.0203 24.2544 30.795 24.9913L35.0048 28.9953C35.3125 29.2879 35.4529 29.7095 35.3803 30.1227L34.3865 35.7765C34.2036 36.817 35.3228 37.6104 36.2804 37.1192L41.484 34.4498Z", fill: "#008579", fillOpacity: "0.6" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M72.3188 34.4498C71.9385 34.2547 71.4842 34.2547 71.1039 34.4498L65.9003 37.1192C64.9427 37.6104 63.8234 36.817 64.0063 35.7765L65.0001 30.1227C65.0728 29.7095 64.9324 29.2879 64.6247 28.9953L60.4149 24.9913C59.6402 24.2544 60.0677 22.9705 61.1383 22.8187L66.9562 21.9939C67.3813 21.9336 67.7489 21.673 67.939 21.2971L70.5408 16.1531C71.0196 15.2064 72.4031 15.2065 72.8819 16.1531L75.4837 21.2971C75.6738 21.673 76.0414 21.9336 76.4665 21.9939L82.2844 22.8187C83.355 22.9705 83.7825 24.2544 83.0078 24.9913L78.798 28.9953C78.4903 29.2879 78.3499 29.7095 78.4226 30.1227L79.4164 35.7765C79.5993 36.817 78.48 37.6104 77.5224 37.1192L72.3188 34.4498Z", fill: "#00E5D0" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.5207 36.4145L70.7243 33.7452C71.3422 33.4282 72.0805 33.4282 72.6984 33.7452L77.902 36.4145C78.2611 36.5988 78.6809 36.3012 78.6123 35.911L77.6185 30.2572C77.5005 29.5858 77.7286 28.9008 78.2285 28.4253L82.4383 24.4212C82.7289 24.1449 82.5685 23.6634 82.167 23.6065L76.3492 22.7816C75.6583 22.6837 75.0611 22.2603 74.7521 21.6494L72.1503 16.5054C71.9707 16.1504 71.452 16.1504 71.2724 16.5054L68.6706 21.6494C68.3616 22.2603 67.7644 22.6837 67.0735 22.7816L61.2557 23.6065C60.8542 23.6634 60.6938 24.1449 60.9844 24.4212L65.1942 28.4253C65.6941 28.9008 65.9222 29.5858 65.8042 30.2572L64.8104 35.911C64.7418 36.3012 65.1616 36.5988 65.5207 36.4145ZM71.1039 34.4498C71.4842 34.2547 71.9385 34.2547 72.3188 34.4498L77.5224 37.1192C78.48 37.6104 79.5993 36.817 79.4164 35.7765L78.4226 30.1227C78.3499 29.7095 78.4903 29.2879 78.798 28.9953L83.0078 24.9913C83.7825 24.2544 83.355 22.9705 82.2844 22.8187L76.4665 21.9939C76.0414 21.9336 75.6738 21.673 75.4837 21.2971L72.8819 16.1531C72.4031 15.2065 71.0196 15.2064 70.5408 16.1531L67.939 21.2971C67.7489 21.673 67.3813 21.9336 66.9562 21.9939L61.1383 22.8187C60.0677 22.9705 59.6402 24.2544 60.4149 24.9913L64.6247 28.9953C64.9324 29.2879 65.0728 29.7095 65.0001 30.1227L64.0063 35.7765C63.8234 36.817 64.9427 37.6104 65.9003 37.1192L71.1039 34.4498Z", fill: "#008579", fillOpacity: "0.6" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M101.939 34.4498C101.558 34.2547 101.104 34.2547 100.724 34.4498L95.5202 37.1192C94.5626 37.6104 93.4433 36.817 93.6262 35.7765L94.62 30.1227C94.6926 29.7095 94.5522 29.2879 94.2446 28.9953L90.0348 24.9913C89.26 24.2544 89.6876 22.9705 90.7582 22.8187L96.576 21.9939C97.0012 21.9336 97.3687 21.673 97.5589 21.2971L100.161 16.1531C100.639 15.2064 102.023 15.2065 102.502 16.1531L105.104 21.2971C105.294 21.673 105.661 21.9336 106.086 21.9939L111.904 22.8187C112.975 22.9705 113.402 24.2544 112.628 24.9913L108.418 28.9953C108.11 29.2879 107.97 29.7095 108.042 30.1227L109.036 35.7765C109.219 36.817 108.1 37.6104 107.142 37.1192L101.939 34.4498Z", fill: "#00E5D0" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.1405 36.4145L100.344 33.7452C100.962 33.4282 101.7 33.4282 102.318 33.7452L107.522 36.4145C107.881 36.5988 108.301 36.3012 108.232 35.911L107.238 30.2572C107.12 29.5858 107.348 28.9008 107.848 28.4253L112.058 24.4212C112.349 24.1449 112.188 23.6634 111.787 23.6065L105.969 22.7816C105.278 22.6837 104.681 22.2603 104.372 21.6494L101.77 16.5054C101.591 16.1504 101.072 16.1504 100.892 16.5054L98.2905 21.6494C97.9815 22.2603 97.3842 22.6837 96.6933 22.7816L90.8755 23.6065C90.474 23.6634 90.3137 24.1449 90.6042 24.4212L94.8141 28.4253C95.314 28.9008 95.5421 29.5858 95.4241 30.2572L94.4303 35.911C94.3617 36.3012 94.7814 36.5988 95.1405 36.4145ZM100.724 34.4498C101.104 34.2547 101.558 34.2547 101.939 34.4498L107.142 37.1192C108.1 37.6104 109.219 36.817 109.036 35.7765L108.042 30.1227C107.97 29.7095 108.11 29.2879 108.418 28.9953L112.628 24.9913C113.402 24.2544 112.975 22.9705 111.904 22.8187L106.086 21.9939C105.661 21.9336 105.294 21.673 105.104 21.2971L102.502 16.1531C102.023 15.2065 100.639 15.2064 100.161 16.1531L97.5589 21.2971C97.3687 21.673 97.0012 21.9336 96.576 21.9939L90.7582 22.8187C89.6876 22.9705 89.26 24.2544 90.0348 24.9913L94.2446 28.9953C94.5522 29.2879 94.6926 29.7095 94.62 30.1227L93.6262 35.7765C93.4433 36.817 94.5626 37.6104 95.5202 37.1192L100.724 34.4498Z", fill: "#008579", fillOpacity: "0.6" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M131.559 34.4498C131.178 34.2547 130.724 34.2547 130.344 34.4498L125.14 37.1192C124.182 37.6104 123.063 36.817 123.246 35.7765L124.24 30.1227C124.313 29.7095 124.172 29.2879 123.864 28.9953L119.655 24.9913C118.88 24.2544 119.307 22.9705 120.378 22.8187L126.196 21.9939C126.621 21.9336 126.989 21.673 127.179 21.2971L129.781 16.1531C130.259 15.2064 131.643 15.2065 132.122 16.1531L134.723 21.2971C134.914 21.673 135.281 21.9336 135.706 21.9939L141.524 22.8187C142.595 22.9705 143.022 24.2544 142.248 24.9913L138.038 28.9953C137.73 29.2879 137.59 29.7095 137.662 30.1227L138.656 35.7765C138.839 36.817 137.72 37.6104 136.762 37.1192L131.559 34.4498Z", fill: "#00E5D0" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M124.76 36.4145L129.964 33.7452C130.582 33.4282 131.32 33.4282 131.938 33.7452L137.142 36.4145C137.501 36.5988 137.921 36.3012 137.852 35.911L136.858 30.2572C136.74 29.5858 136.968 28.9008 137.468 28.4253L141.678 24.4212C141.969 24.1449 141.808 23.6634 141.407 23.6065L135.589 22.7816C134.898 22.6837 134.301 22.2603 133.992 21.6494L131.39 16.5054C131.21 16.1504 130.692 16.1504 130.512 16.5054L127.91 21.6494C127.601 22.2603 127.004 22.6837 126.313 22.7816L120.495 23.6065C120.094 23.6634 119.934 24.1449 120.224 24.4212L124.434 28.4253C124.934 28.9008 125.162 29.5858 125.044 30.2572L124.05 35.911C123.982 36.3012 124.401 36.5988 124.76 36.4145ZM130.344 34.4498C130.724 34.2547 131.178 34.2547 131.559 34.4498L136.762 37.1192C137.72 37.6104 138.839 36.817 138.656 35.7765L137.662 30.1227C137.59 29.7095 137.73 29.2879 138.038 28.9953L142.248 24.9913C143.022 24.2544 142.595 22.9705 141.524 22.8187L135.706 21.9939C135.281 21.9336 134.914 21.673 134.723 21.2971L132.122 16.1531C131.643 15.2065 130.259 15.2064 129.781 16.1531L127.179 21.2971C126.989 21.673 126.621 21.9336 126.196 21.9939L120.378 22.8187C119.307 22.9705 118.88 24.2544 119.655 24.9913L123.864 28.9953C124.172 29.2879 124.313 29.7095 124.24 30.1227L123.246 35.7765C123.063 36.817 124.182 37.6104 125.14 37.1192L130.344 34.4498Z", fill: "#008579", fillOpacity: "0.6" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M161.178 34.4498C160.798 34.2547 160.344 34.2547 159.964 34.4498L154.76 37.1192C153.802 37.6104 152.683 36.817 152.866 35.7765L153.86 30.1227C153.932 29.7095 153.792 29.2879 153.484 28.9953L149.275 24.9913C148.5 24.2544 148.927 22.9705 149.998 22.8187L155.816 21.9939C156.241 21.9336 156.608 21.673 156.799 21.2971L159.4 16.1531C159.879 15.2064 161.263 15.2065 161.742 16.1531L164.343 21.2971C164.533 21.673 164.901 21.9336 165.326 21.9939L171.144 22.8187C172.215 22.9705 172.642 24.2544 171.867 24.9913L167.658 28.9953C167.35 29.2879 167.21 29.7095 167.282 30.1227L168.276 35.7765C168.459 36.817 167.34 37.6104 166.382 37.1192L161.178 34.4498Z", fill: "#8794AE" }),
    react.createElement("rect", { x: "28.2529", y: "50.0002", width: "146.157", height: "4.90706", rx: "2.45353", fill: "#406AE3" }),
    react.createElement("rect", { x: "44.1357", y: "60.8489", width: "114.391", height: "4.906", rx: "2.453", fill: "#406AE3" }),
    react.createElement("path", { d: "M0.779471 79.0055H201.883V106.58C201.883 109.593 199.44 112.036 196.427 112.036H6.23575C3.22233 112.036 0.779471 109.593 0.779471 106.58V79.0055Z", fill: "#F4F7FD" }),
    react.createElement("path", { d: "M94.2176 99.0898C95.3068 99.0898 96.2984 98.6145 96.6886 97.9492V98.963H98.4605V87.747H96.6886V91.9768C96.2009 91.3114 95.2418 90.852 94.1851 90.852C91.7141 90.852 90.2998 92.5629 90.2998 94.9709C90.2998 97.3789 91.7141 99.0898 94.2176 99.0898ZM94.4452 97.5848C93.0146 97.5848 92.0718 96.5392 92.0718 94.9709C92.0718 93.3867 93.0146 92.357 94.4452 92.357C95.8758 92.357 96.8186 93.3867 96.8186 94.9709C96.8186 96.5392 95.8758 97.5848 94.4452 97.5848Z", fill: "#112971" }),
    react.createElement("path", { d: "M103.248 99.0898C105.703 99.0898 107.475 97.363 107.475 94.9709C107.475 92.5788 105.703 90.852 103.248 90.852C100.777 90.852 99.0212 92.5788 99.0212 94.9709C99.0212 97.363 100.777 99.0898 103.248 99.0898ZM103.248 97.5848C101.785 97.5848 100.809 96.5076 100.809 94.9709C100.809 93.4342 101.785 92.357 103.248 92.357C104.695 92.357 105.686 93.4342 105.686 94.9709C105.686 96.5076 104.695 97.5848 103.248 97.5848Z", fill: "#112971" }),
    react.createElement("path", { d: "M112.136 99.0898C114.136 99.0898 115.55 98.0917 115.891 96.4283L114.152 96.0957C113.957 97.0303 113.225 97.5848 112.185 97.5848C110.787 97.5848 109.86 96.5551 109.86 94.9709C109.86 93.3867 110.771 92.357 112.185 92.357C113.225 92.357 113.989 92.9748 114.152 93.8778L115.875 93.5451C115.599 91.8976 114.152 90.852 112.136 90.852C109.681 90.852 108.023 92.5154 108.023 94.9709C108.023 97.4264 109.681 99.0898 112.136 99.0898Z", fill: "#112971" }),
    react.createElement("path", { d: "M121.367 98.8997L121.254 97.363C120.945 97.5056 120.571 97.5531 120.262 97.5531C119.595 97.5531 119.14 97.1412 119.14 96.3491V92.452H121.254V90.9787H119.14V88.6024H117.368V90.9787H115.938V92.452H117.368V96.4442C117.368 98.266 118.522 99.0898 120.067 99.0898C120.522 99.0898 120.977 99.0264 121.367 98.8997Z", fill: "#112971" }),
    react.createElement("path", { d: "M123.089 89.648C123.756 89.648 124.26 89.1569 124.26 88.5391C124.26 87.9054 123.756 87.4143 123.089 87.4143C122.439 87.4143 121.951 87.9054 121.951 88.5391C121.951 89.1569 122.439 89.648 123.089 89.648ZM122.212 98.963H123.984V90.9787H122.212V98.963Z", fill: "#112971" }),
    react.createElement("path", { d: "M126.199 98.963H127.971V92.452H129.97V90.9787H127.971V90.2658C127.971 89.4738 128.426 88.9668 129.125 88.9668C129.401 88.9668 129.678 89.0143 129.97 89.1252L130.068 87.6678C129.71 87.5569 129.304 87.4935 128.898 87.4935C127.337 87.4935 126.199 88.4916 126.199 90.2975V90.9787H124.85V92.452H126.199V98.963Z", fill: "#112971" }),
    react.createElement("path", { d: "M135.383 90.9787L133.188 96.5076L131.042 90.9787H129.124L132.311 98.7254L131.075 101.846H132.896L137.204 90.9787H135.383Z", fill: "#112971" }),
    react.createElement("path", { d: "M82.132 87.551C79.1741 87.2415 77.7609 89.6783 76.1983 90.169C76.0213 90.1843 75.8388 90.1857 75.6521 90.1815C75.6604 90.1843 75.6687 90.1885 75.677 90.1913C77.3087 90.3321 79.3511 89.4552 81.5014 91.2257C85.3595 94.4013 82.7003 100.408 75.9715 102.805C76.4113 102.959 76.869 103.099 77.3433 103.221C78.2629 103.458 79.2516 103.235 80.0315 102.69C88.345 96.8645 88.2233 88.1909 82.132 87.551Z", fill: "#A7F3D8" }),
    react.createElement("path", { d: "M82.132 87.551C79.1741 87.2415 77.7609 89.6783 76.1983 90.169C76.0213 90.1843 75.8388 90.1857 75.6521 90.1815C75.6604 90.1843 75.6687 90.1885 75.677 90.1913C77.3087 90.3321 79.3511 89.4552 81.5014 91.2257C85.3595 94.4013 82.7003 100.408 75.9715 102.805C76.4113 102.959 76.869 103.099 77.3433 103.221C78.2629 103.458 79.2516 103.235 80.0315 102.69C88.345 96.8645 88.2233 88.1909 82.132 87.551Z", fill: "url(#paint1_radial_3886_28276)" }),
    react.createElement("path", { d: "M69.8358 87.551C72.7936 87.2415 74.2069 89.6783 75.7695 90.169C75.9465 90.1843 76.129 90.1857 76.3157 90.1815C76.3074 90.1843 76.2991 90.1885 76.2908 90.1913C74.6591 90.3321 72.6166 89.4552 70.4664 91.2257C66.6083 94.4013 69.2675 100.408 75.9962 102.805C75.5565 102.959 75.0988 103.099 74.6245 103.221C73.7049 103.458 72.7162 103.235 71.9363 102.69C63.6228 96.8645 63.7445 88.1909 69.8358 87.551Z", fill: "url(#paint2_radial_3886_28276)" }),
    react.createElement("path", { d: "M75.9723 102.804C75.516 102.965 75.0375 103.114 74.5383 103.245C69.9391 101.091 67.4334 97.2212 68.6351 94.2422C68.2299 97.3523 71.0038 101.059 75.9723 102.804Z", fill: "url(#paint3_linear_3886_28276)" }),
    react.createElement("path", { d: "M81.5013 91.2255C79.3511 89.455 77.3086 90.3319 75.6769 90.1911C75.6686 90.1883 75.6603 90.1841 75.652 90.1813C74.1212 90.1479 72.2904 89.6251 70.3738 91.2045C66.5047 94.3913 69.1943 100.425 75.9701 102.804C82.7002 100.408 85.3594 94.4011 81.5013 91.2255Z", fill: "url(#paint4_radial_3886_28276)" }),
    react.createElement("path", { d: "M73.1542 86.7593C72.2547 86.2556 72.1418 85.156 73.0354 84.9784C73.7977 84.8268 74.6058 84.97 75.2804 85.408C76.4165 86.1454 76.7101 87.9939 76.1709 89.1139C76.0566 89.3514 75.7436 89.3361 75.5861 89.1247C74.917 88.2262 74.0537 87.2631 73.1542 86.7593Z", fill: "url(#paint5_radial_3886_28276)" }),
    react.createElement("path", { d: "M0.779471 79.0055H201.883V106.58C201.883 109.593 199.44 112.036 196.427 112.036H6.23575C3.22233 112.036 0.779471 109.593 0.779471 106.58V79.0055Z", stroke: "#051851", strokeWidth: "1.55894" }),
    react.createElement("path", { d: "M0.779471 79.0055H201.883V106.58C201.883 109.593 199.44 112.036 196.427 112.036H6.23575C3.22233 112.036 0.779471 109.593 0.779471 106.58V79.0055Z", stroke: "url(#paint6_linear_3886_28276)", strokeOpacity: "0.7", strokeWidth: "1.55894" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M199.457 39.3617L194.567 34.9321C193.823 34.2612 193.106 32.754 192.518 32.5335C192.013 32.3497 191.866 32.7816 192.527 33.5168C192.288 33.8201 191.443 32.9103 190.533 32.8C190 32.7356 190.239 33.8477 189.862 34.0406C189.127 34.4174 189.623 35.1894 190.395 35.5846C190.928 35.8603 191.489 36.6598 192.858 37.3491L196.608 41.2089L199.457 39.3617Z", fill: "#F1B0AB" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M182.373 43.446C182.818 43.2158 183.35 43.2158 183.795 43.446L189.885 46.5962C191.005 47.176 192.315 46.2396 192.101 45.0117L190.938 38.3395C190.853 37.8519 191.017 37.3543 191.377 37.009L196.304 32.2837C197.211 31.4141 196.71 29.899 195.457 29.7198L188.649 28.7464C188.151 28.6752 187.721 28.3677 187.499 27.9241L184.454 21.8535C183.893 20.7363 182.274 20.7363 181.714 21.8535L178.669 27.9241C178.447 28.3677 178.016 28.6752 177.519 28.7464L170.71 29.7198C169.457 29.899 168.957 31.4141 169.864 32.2837L174.79 37.009C175.15 37.3543 175.315 37.8519 175.23 38.3395L174.067 45.0117C173.853 46.2396 175.163 47.176 176.283 46.5962L182.373 43.446Z", fill: "#00E5D0" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M190.329 45.7647L184.239 42.6145C183.516 42.2404 182.652 42.2404 181.929 42.6145L175.839 45.7647C175.419 45.9821 174.927 45.631 175.008 45.1705L176.171 38.4983C176.309 37.7059 176.042 36.8974 175.457 36.3363L170.53 31.611C170.19 31.2849 170.378 30.7167 170.848 30.6495L177.656 29.6761C178.465 29.5605 179.164 29.0608 179.525 28.3399L182.57 22.2693C182.78 21.8503 183.387 21.8503 183.598 22.2693L186.642 28.3399C187.004 29.0608 187.703 29.5605 188.512 29.6761L195.32 30.6495C195.79 30.7167 195.978 31.2849 195.638 31.611L190.711 36.3363C190.126 36.8974 189.859 37.7059 189.997 38.4983L191.16 45.1705C191.24 45.631 190.749 45.9821 190.329 45.7647ZM183.795 43.446C183.35 43.2158 182.818 43.2158 182.373 43.446L176.283 46.5962C175.163 47.176 173.853 46.2396 174.067 45.0117L175.23 38.3395C175.315 37.8519 175.15 37.3543 174.79 37.009L169.864 32.2837C168.957 31.4141 169.457 29.899 170.71 29.7198L177.519 28.7464C178.016 28.6752 178.447 28.3677 178.669 27.9241L181.714 21.8535C182.274 20.7363 183.893 20.7363 184.454 21.8535L187.499 27.9241C187.721 28.3677 188.151 28.6752 188.649 28.7464L195.457 29.7198C196.71 29.899 197.211 31.4141 196.304 32.2837L191.377 37.009C191.017 37.3543 190.853 37.8519 190.938 38.3395L192.101 45.0117C192.315 46.2396 191.005 47.176 189.885 46.5962L183.795 43.446Z", fill: "#008579", fillOpacity: "0.6" }),
    react.createElement("path", { d: "M199.567 75.3503C199.567 75.3503 199.19 78.2452 200.026 80.8001C200.026 80.8001 203.041 97.3606 200.495 98.8678C198.501 100.375 197.288 100.54 197.251 101.303C197.214 102.066 203.895 99.3916 203.895 99.3916C203.895 99.3916 204.355 98.1694 204.042 96.5887C203.73 95.008 205.246 81.6915 205.246 81.6915L207.001 76.3521L199.567 75.3503Z", fill: "#F9B995" }),
    react.createElement("path", { d: "M197.94 100.43C198.023 100.403 198.528 100.375 199.015 100.357C199.631 100.329 200.219 100.127 200.716 99.7595C201.846 98.9324 203.877 97.5079 204.245 97.7653C204.245 97.7653 204.741 97.9491 204.392 99.1162L204.649 101.478L203.877 101.515L203.767 100.458C203.767 100.458 202.673 99.7963 201.791 100.476C201.276 100.872 200.89 101.221 200.67 101.441C200.504 101.607 200.284 101.699 200.054 101.708L197.444 101.846C197.435 101.864 195.523 101.368 197.94 100.43Z", fill: "#232021" }),
    react.createElement("path", { d: "M200.402 73.375C200.402 73.375 213.903 95.1004 211.568 97.4715C210.649 99.6679 209.85 100.274 210.41 101.01C210.971 101.736 215.566 95.5324 215.566 95.5324C215.18 96.1573 214.748 95.1004 214.068 94.0068C214.068 94.0068 210.732 86.572 209.739 82.2711C208.747 77.9701 206.881 72.4009 206.881 72.4009L200.402 73.375Z", fill: "#F9B995" }),
    react.createElement("path", { d: "M210.475 100.1C210.521 100.044 210.879 99.879 211.256 99.6952C211.927 99.3827 212.46 98.8497 212.763 98.1788C213.333 96.9382 214.289 95.0358 214.757 95.1277C214.757 95.1277 215.336 95.1185 215.713 96.3684L217.395 98.5373L216.696 98.8773L215.952 97.9123C215.952 97.9123 214.527 97.6918 214.114 98.6843C213.866 99.2817 213.719 99.7687 213.645 100.063C213.59 100.265 213.452 100.43 213.268 100.522L210.879 101.671C210.87 101.662 208.774 101.919 210.475 100.1Z", fill: "#232021" }),
    react.createElement("path", { d: "M209.814 63.8906C210.329 65.0394 210.402 65.9676 210.365 66.5925C210.319 67.5207 210.044 67.8975 209.888 69.5885C209.805 70.434 209.823 70.9211 209.823 71.0865C209.86 72.0422 210.016 72.7591 210.126 73.1818C210.889 76.3248 211.606 76.8487 211.386 78.0985C211.183 79.2932 210.31 80.056 209.888 80.442C208.491 81.6827 206.855 81.747 204.07 81.8205C201.506 81.8848 200.091 81.9032 199.273 80.9199C198.859 80.4236 198.758 79.6884 198.556 78.218C198.363 76.7935 198.391 75.8653 198.372 74.6155C198.363 73.9446 198.354 74.2663 198.133 70.241C198.06 68.8717 197.95 66.905 197.83 64.4788L209.814 63.8906Z", fill: "#A4556B" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M189.137 46.1906L184.248 41.7609C183.504 41.0901 182.787 39.5829 182.199 39.3623C181.693 39.1785 181.546 39.6104 182.208 40.3457C181.969 40.6489 181.123 39.7391 180.214 39.6288C179.681 39.5645 179.92 40.6765 179.543 40.8695C178.808 41.2463 179.304 42.0183 180.076 42.4134C180.609 42.6891 181.169 43.4887 182.539 44.1779L186.288 48.0378L189.137 46.1906Z", fill: "#F9B995" }),
    react.createElement("path", { d: "M200.697 45.7581C200.44 44.591 199.87 44.1866 199.87 44.1866L193.979 38.7185L196.341 36.4578L208.242 46.3187H208.224C209.317 47.1458 208.968 50.3348 208.968 50.3348C208.968 50.3348 209.281 56.1522 209.584 57.3561C209.887 58.56 210.181 63.6513 210.181 63.6513C209.611 64.0281 206.367 66.1142 203.105 65.9304C202.673 65.9028 201.754 65.7099 199.925 65.3331C199.585 65.2595 199.3 65.2044 199.061 65.1401C198.445 64.9838 198.105 64.8184 197.83 64.4968C197.692 64.3405 197.444 63.9913 197.232 62.6404C197.058 61.5559 197.058 60.7472 197.048 60.3612C197.012 58.4772 196.672 57.0068 196.451 56.0419C196.424 55.904 196.387 55.757 196.341 55.6099C196.139 54.8196 195.817 53.7903 195.312 52.6232C195.312 52.6232 201.055 47.3664 200.697 45.7581Z", fill: "#FAFAEF" }),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M199.871 44.1869C199.871 44.1869 200.44 44.6004 200.698 45.7584C201.056 47.3667 195.312 52.6142 195.312 52.6142C195.312 52.6142 193.915 54.1214 192.362 54.1214C190.818 54.1214 182.327 44.5637 182.327 44.1869C182.327 43.8101 183.907 41.7791 184.569 42.018C185.231 42.257 192.362 48.543 192.362 48.543C192.362 48.543 197.251 42.8911 199.871 44.1869Z", fill: "#FAFAEF" }),
    react.createElement("path", { d: "M195.835 51.7682L197.618 50.2702L199.401 48.7722L197.618 50.261L195.835 51.7682Z", fill: "white" }),
    react.createElement("path", { d: "M204.804 45.2256L206.128 45.7678L207.451 46.3008L206.128 45.7586L204.804 45.2256Z", fill: "white" }),
    react.createElement("path", { d: "M198.307 44.8208C198.546 44.83 198.794 44.8943 199.006 44.9954C199.226 45.0965 199.419 45.2527 199.566 45.4457C199.713 45.6387 199.823 45.8593 199.888 46.0982C199.952 46.3372 199.97 46.5761 199.952 46.8242C199.97 46.5853 199.952 46.3372 199.897 46.0982C199.833 45.8593 199.732 45.6387 199.584 45.4457C199.428 45.2527 199.235 45.0965 199.015 44.9954C198.794 44.8851 198.555 44.83 198.307 44.8208Z", fill: "white" }),
    react.createElement("path", { d: "M192.277 49.398C192.35 49.1682 192.369 48.9201 192.323 48.6812C192.35 48.9201 192.341 49.1682 192.277 49.398Z", fill: "white" }),
    react.createElement("path", { d: "M205.238 81.7929C205.238 81.7929 207.104 78.5212 207.003 77.2806C206.901 76.0399 208.087 79.0451 205.238 81.7929Z", fill: "#844457" }),
    react.createElement("path", { d: "M199.31 37.4503C199.338 37.4411 199.356 37.4319 199.384 37.4227L200.799 34.9873C201.461 33.8477 203.097 33.5537 204.439 34.3256L204.494 34.3624C205.835 35.1435 206.387 36.7059 205.725 37.8454L204.972 39.1412C205.073 39.178 205.174 39.224 205.256 39.3067C205.523 39.5824 205.404 39.9867 205.312 40.29C205.256 40.483 205.146 40.8506 204.76 41.0804C204.622 41.1631 204.264 41.3744 203.86 41.2182C203.832 41.209 203.814 41.1906 203.786 41.1814C203.124 42.321 201.489 42.6151 200.147 41.8431L200.092 41.8064C198.75 41.0252 198.198 39.4629 198.86 38.3233L199.053 37.9925C199.044 37.9833 199.035 37.9833 199.035 37.9741C199.016 37.9557 198.86 37.7995 198.897 37.6708C198.934 37.5238 199.127 37.5054 199.31 37.4503Z", fill: "#F9B995" }),
    react.createElement("path", { d: "M201.994 42.2476L201.057 44.2143C201.057 44.2143 202.417 46.0982 204.043 45.4549L205.192 42.7438C205.192 42.7438 204.558 40.6669 204.429 40.768C204.301 40.8599 201.994 42.2476 201.994 42.2476Z", fill: "#F9B995" }),
    react.createElement("path", { d: "M204.973 39.1326C204.789 39.004 205.01 38.4066 205.065 38.1768C205.267 37.3314 204.44 36.4123 203.98 35.9069C202.924 34.7397 202.198 35.0154 201.784 34.1056C201.517 33.5267 201.527 32.7914 201.839 32.1757C201.876 32.093 202.299 31.3118 203.144 31.0913C204.1 30.8431 205.23 31.4037 205.828 31.6978C205.901 31.7346 206.067 31.8173 206.306 31.8908C206.82 32.0379 207.234 31.9919 207.362 31.9827C208.281 31.9276 209.375 33.1131 209.632 33.3888C210.772 34.6203 210.974 36.0815 211.038 36.6145C211.084 36.9821 211.323 39.2245 209.825 41.2096C209.347 41.8437 208.465 42.3767 206.701 43.4428C206.223 43.7277 205.671 44.0401 205.01 43.9207C204.863 43.8931 204.311 43.8104 204.017 43.3784C203.549 42.6708 204.054 41.4669 204.651 41.1361C204.716 41.0993 204.808 41.0625 204.918 40.9706C205.194 40.7409 205.276 40.4468 205.387 40.07C205.414 39.9689 205.46 39.8219 205.432 39.6381C205.423 39.6013 205.423 39.5462 205.387 39.4726C205.313 39.298 205.175 39.2061 205.129 39.1786C205.037 39.151 205.01 39.1602 204.973 39.1326Z", fill: "#402840" }),
    react.createElement("path", { d: "M210.487 35.447C211.268 35.1805 212.132 35.7043 212.491 35.9157C212.776 36.0903 213.695 36.6417 213.98 37.7905C214.007 37.9099 214.356 39.4171 213.253 40.474C212.592 41.1081 211.673 41.3195 210.873 41.154C210.708 41.1173 210.129 40.9978 209.679 40.5567C208.401 39.2701 208.971 35.9708 210.487 35.447Z", fill: "#402840" }),
    react.createElement("path", { d: "M201.995 42.2476C201.995 42.2476 202.464 42.2017 202.721 42.073C202.978 41.9535 201.811 42.6428 201.811 42.6428L201.995 42.2476Z", fill: "#D99873" }),
    react.createElement("path", { d: "M204.926 39.3523C204.972 39.4074 205.028 39.4993 205.055 39.6096C205.138 39.8761 205.046 40.1151 205.009 40.1978", fill: "#D99873" }),
    react.createElement("path", { d: "M195.331 51.8054C195.331 51.8054 197.196 48.5337 197.095 47.293C196.994 46.0523 198.179 49.0575 195.331 51.8054Z", fill: "#D1D1D1" }),
    react.createElement("defs", null,
        react.createElement("linearGradient", { id: "paint0_linear_3886_28276", x1: "-1.50995e-06", y1: "56.3346", x2: "202.662", y2: "56.3346", gradientUnits: "userSpaceOnUse" },
            react.createElement("stop", { stopColor: "#051851" }),
            react.createElement("stop", { offset: "1", stopColor: "#2B59E0" })),
        react.createElement("radialGradient", { id: "paint1_radial_3886_28276", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(77.1313 93.1867) rotate(-33.658) scale(13.6699 13.7808)" },
            react.createElement("stop", { offset: "0.536654", stopColor: "#1CDFCD" }),
            react.createElement("stop", { offset: "1", stopColor: "#00AA9C" })),
        react.createElement("radialGradient", { id: "paint2_radial_3886_28276", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(76.3035 91.1529) rotate(178.58) scale(10.8482 10.9362)" },
            react.createElement("stop", { stopColor: "#1DDFCE" }),
            react.createElement("stop", { offset: "0.992249", stopColor: "#2B5AE0" })),
        react.createElement("linearGradient", { id: "paint3_linear_3886_28276", x1: "74.6641", y1: "102.916", x2: "68.9016", y2: "97.228", gradientUnits: "userSpaceOnUse" },
            react.createElement("stop", { stopColor: "#2B59E0" }),
            react.createElement("stop", { offset: "1", stopColor: "#071037", stopOpacity: "0" })),
        react.createElement("radialGradient", { id: "paint4_radial_3886_28276", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(83.4295 99.1851) rotate(-151.073) scale(15.3802 15.505)" },
            react.createElement("stop", { offset: "0.08836", stopColor: "#2B59E0" }),
            react.createElement("stop", { offset: "0.796792", stopColor: "#1DDFCE" })),
        react.createElement("radialGradient", { id: "paint5_radial_3886_28276", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(73.5069 86.5468) rotate(33.1769) scale(4.91672 4.7559)" },
            react.createElement("stop", { offset: "0.192111", stopColor: "#2B59E0" }),
            react.createElement("stop", { offset: "0.793069", stopColor: "#1DDFCE" })),
        react.createElement("linearGradient", { id: "paint6_linear_3886_28276", x1: "-1.50995e-06", y1: "95.5208", x2: "202.662", y2: "95.5208", gradientUnits: "userSpaceOnUse" },
            react.createElement("stop", { stopColor: "#051851" }),
            react.createElement("stop", { offset: "1", stopColor: "#2B59E0" })))));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/NoReviews/index.esm.js



const NoReviewsIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "48", height: "49", viewBox: "0 0 48 49" }, props),
    react.createElement("g", { clipPath: "url(#clip0_3103_15238)" },
        react.createElement("g", { clipPath: "url(#clip1_3103_15238)" },
            react.createElement("path", { d: "M11.4588 41.9319L15.1628 44.2399C16.9145 45.3296 18.932 45.9452 21.0083 46.0234C23.0846 46.1016 25.1448 45.6396 26.9775 44.6849L44.7573 35.4092C45.3825 35.0795 45.8913 34.5738 46.2173 33.958C46.5433 33.3422 46.6714 32.6449 46.5849 31.957C46.5168 31.4335 46.3257 30.9324 46.0264 30.4928C45.7271 30.0532 45.3277 29.6869 44.8593 29.4226C44.391 29.1582 43.8663 29.0029 43.3263 28.9689C42.7863 28.9348 42.2455 29.0228 41.7461 29.226L26.3889 35.4744C26.4641 35.1065 26.4776 34.7293 26.429 34.3572C26.3716 33.9067 26.2231 33.4718 25.9922 33.0776C25.7613 32.6835 25.4525 32.3378 25.0837 32.0608L18.9791 27.4483C18.0733 26.7597 17.0365 26.2532 15.9285 25.9581C14.8206 25.663 13.6636 25.5852 12.5246 25.7292L6.49561 26.4742L6.29907 24.9627C6.273 24.7623 6.16635 24.5801 6.00256 24.4564C5.83878 24.3326 5.63128 24.2773 5.42572 24.3028L0.775325 24.8777C0.569765 24.9031 0.382976 25.0071 0.256053 25.1668C0.12913 25.3265 0.0724714 25.5289 0.0985353 25.7293L2.45711 43.8679C2.48317 44.0684 2.58983 44.2505 2.75361 44.3743C2.91739 44.498 3.12489 44.5533 3.33045 44.5279L7.98085 43.9529C8.18641 43.9275 8.3732 43.8235 8.50012 43.6638C8.62704 43.5041 8.68371 43.3017 8.65764 43.1013L8.46124 41.5909L9.38357 41.4768C10.1086 41.3876 10.8428 41.5486 11.4588 41.9319ZM3.90897 42.9205L1.74694 26.2934L4.8472 25.9101L7.00923 42.5372L3.90897 42.9205ZM6.69216 27.9858L12.7209 27.2408C13.6563 27.1226 14.6065 27.1865 15.5165 27.4288C16.4264 27.6711 17.278 28.0871 18.0219 28.6526L24.1265 33.265C24.5311 33.5861 24.7934 34.0467 24.859 34.5513C24.9246 35.0559 24.7885 35.5658 24.4789 35.9752C24.1567 36.3797 23.6832 36.643 23.1621 36.7074C22.6411 36.7719 22.1151 36.6321 21.6996 36.3188L15.6085 31.7166C15.4444 31.5971 15.2387 31.5451 15.0357 31.572C14.8327 31.5988 14.6486 31.7024 14.5232 31.8603C14.3977 32.0182 14.3409 32.2178 14.3649 32.4162C14.3889 32.6146 14.4918 32.7958 14.6516 32.9209L20.7427 37.523C21.1506 37.8313 21.6227 38.0489 22.126 38.1605C22.6293 38.272 23.1515 38.2749 23.6561 38.1688C23.7632 38.1705 23.8696 38.1505 23.9683 38.1099L42.3473 30.632C42.6247 30.5192 42.925 30.4703 43.2249 30.4893C43.5248 30.5082 43.8162 30.5945 44.0763 30.7413C44.3364 30.8881 44.5582 31.0914 44.7244 31.3356C44.8907 31.5797 44.9969 31.8579 45.0347 32.1487C45.0828 32.5307 45.0117 32.918 44.8306 33.26C44.6495 33.6019 44.3669 33.8828 44.0197 34.0657L26.2398 43.3415C24.6521 44.1686 22.8674 44.5688 21.0687 44.501C19.2701 44.4332 17.5223 43.9 16.0049 42.9559L12.2999 40.6483C11.3759 40.0731 10.2746 39.8315 9.18702 39.9653L8.26469 40.0793L6.69216 27.9858Z", fill: "#051851" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.6083 18.5868C37.3991 18.4821 37.1491 18.4821 36.9399 18.5868L34.0772 20.0188C33.5504 20.2823 32.9346 19.8566 33.0352 19.2985L33.582 16.2655C33.6219 16.0438 33.5447 15.8177 33.3754 15.6607L31.0594 13.5127C30.6332 13.1174 30.8684 12.4287 31.4574 12.3473L34.6581 11.9048C34.892 11.8724 35.0942 11.7327 35.1988 11.531L36.6301 8.7715C36.8936 8.26367 37.6547 8.26367 37.9181 8.7715L39.3494 11.531C39.454 11.7327 39.6562 11.8724 39.8901 11.9048L43.0908 12.3473C43.6798 12.4287 43.915 13.1174 43.4888 13.5127L41.1728 15.6607C41.0035 15.8177 40.9263 16.0438 40.9662 16.2655L41.513 19.2985C41.6136 19.8566 40.9978 20.2823 40.471 20.0188L37.6083 18.5868Z", fill: "#00E5D0" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.6083 18.5868C37.3991 18.4821 37.1491 18.4821 36.9399 18.5868L34.0772 20.0188C33.5504 20.2823 32.9346 19.8566 33.0352 19.2985L33.582 16.2655C33.6219 16.0438 33.5447 15.8177 33.3754 15.6607L31.0594 13.5127C30.6332 13.1174 30.8684 12.4287 31.4574 12.3473L34.6581 11.9048C34.892 11.8724 35.0942 11.7327 35.1988 11.531L36.6301 8.7715C36.8936 8.26367 37.6547 8.26367 37.9181 8.7715L39.3494 11.531C39.454 11.7327 39.6562 11.8724 39.8901 11.9048L43.0908 12.3473C43.6798 12.4287 43.915 13.1174 43.4888 13.5127L41.1728 15.6607C41.0035 15.8177 40.9263 16.0438 40.9662 16.2655L41.513 19.2985C41.6136 19.8566 40.9978 20.2823 40.471 20.0188L37.6083 18.5868Z", fill: "#008579", fillOpacity: "0.6" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.8683 19.6408L36.7311 18.2088C37.071 18.0387 37.4772 18.0387 37.8171 18.2088L40.6799 19.6408C40.8774 19.7396 41.1083 19.58 41.0706 19.3707L40.5239 16.3377C40.4589 15.9775 40.5845 15.61 40.8595 15.3549L43.1755 13.2069C43.3353 13.0587 43.2471 12.8004 43.0262 12.7699L39.8256 12.3274C39.4455 12.2748 39.1169 12.0477 38.947 11.72L37.5156 8.9605C37.4168 8.77006 37.1314 8.77006 37.0326 8.9605L35.6013 11.72C35.4313 12.0477 35.1027 12.2748 34.7226 12.3274L31.522 12.7699C31.3011 12.8004 31.2129 13.0587 31.3727 13.2069L33.6887 15.3549C33.9638 15.61 34.0893 15.9775 34.0243 16.3377L33.4776 19.3707C33.4399 19.58 33.6708 19.7396 33.8683 19.6408ZM36.9399 18.5868C37.1491 18.4821 37.3991 18.4821 37.6083 18.5868L40.471 20.0188C40.9978 20.2823 41.6136 19.8566 41.513 19.2985L40.9662 16.2655C40.9263 16.0438 41.0035 15.8177 41.1728 15.6607L43.4888 13.5127C43.915 13.1174 43.6798 12.4287 43.0908 12.3473L39.8901 11.9048C39.6562 11.8724 39.454 11.7327 39.3494 11.531L37.9181 8.7715C37.6547 8.26367 36.8936 8.26367 36.6301 8.7715L35.1988 11.531C35.0942 11.7327 34.892 11.8724 34.6581 11.9048L31.4574 12.3473C30.8684 12.4287 30.6332 13.1174 31.0594 13.5127L33.3754 15.6607C33.5447 15.8177 33.6219 16.0438 33.582 16.2655L33.0352 19.2985C32.9346 19.8566 33.5504 20.2823 34.0772 20.0188L36.9399 18.5868Z", fill: "#008579", fillOpacity: "0.6" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0614 18.5868C10.8522 18.4821 10.6023 18.4821 10.3931 18.5868L7.53033 20.0188C7.00349 20.2823 6.38775 19.8566 6.48837 19.2985L7.0351 16.2655C7.07506 16.0438 6.99782 15.8177 6.82857 15.6607L4.51257 13.5127C4.08635 13.1174 4.32155 12.4287 4.91057 12.3473L8.1112 11.9048C8.3451 11.8724 8.5473 11.7327 8.6519 11.531L10.0833 8.7715C10.3467 8.26367 11.1078 8.26367 11.3712 8.7715L12.8026 11.531C12.9072 11.7327 13.1094 11.8724 13.3433 11.9048L16.5439 12.3473C17.1329 12.4287 17.3681 13.1174 16.9419 13.5127L14.6259 15.6607C14.4566 15.8177 14.3794 16.0438 14.4194 16.2655L14.9661 19.2985C15.0667 19.8566 14.451 20.2823 13.9241 20.0188L11.0614 18.5868Z", fill: "#00E5D0" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0614 18.5868C10.8522 18.4821 10.6023 18.4821 10.3931 18.5868L7.53033 20.0188C7.00349 20.2823 6.38775 19.8566 6.48837 19.2985L7.0351 16.2655C7.07506 16.0438 6.99782 15.8177 6.82857 15.6607L4.51257 13.5127C4.08635 13.1174 4.32155 12.4287 4.91057 12.3473L8.1112 11.9048C8.3451 11.8724 8.5473 11.7327 8.6519 11.531L10.0833 8.7715C10.3467 8.26367 11.1078 8.26367 11.3712 8.7715L12.8026 11.531C12.9072 11.7327 13.1094 11.8724 13.3433 11.9048L16.5439 12.3473C17.1329 12.4287 17.3681 13.1174 16.9419 13.5127L14.6259 15.6607C14.4566 15.8177 14.3794 16.0438 14.4194 16.2655L14.9661 19.2985C15.0667 19.8566 14.451 20.2823 13.9241 20.0188L11.0614 18.5868Z", fill: "#008579", fillOpacity: "0.6" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.32147 19.6408L10.1842 18.2088C10.5242 18.0387 10.9303 18.0387 11.2703 18.2088L14.133 19.6408C14.3306 19.7396 14.5615 19.58 14.5237 19.3707L13.977 16.3377C13.9121 15.9775 14.0376 15.61 14.3126 15.3549L16.6286 13.2069C16.7884 13.0587 16.7002 12.8004 16.4794 12.7699L13.2787 12.3274C12.8986 12.2748 12.5701 12.0477 12.4001 11.72L10.9687 8.9605C10.8699 8.77006 10.5845 8.77006 10.4857 8.9605L9.05438 11.72C8.8844 12.0477 8.55583 12.2748 8.17574 12.3274L4.97511 12.7699C4.75422 12.8004 4.66603 13.0587 4.82586 13.2069L7.14186 15.3549C7.41689 15.61 7.5424 15.9775 7.47747 16.3377L6.93074 19.3707C6.893 19.58 7.12391 19.7396 7.32147 19.6408ZM10.3931 18.5868C10.6023 18.4821 10.8522 18.4821 11.0614 18.5868L13.9241 20.0188C14.451 20.2823 15.0667 19.8566 14.9661 19.2985L14.4194 16.2655C14.3794 16.0438 14.4566 15.8177 14.6259 15.6607L16.9419 13.5127C17.3681 13.1174 17.1329 12.4287 16.5439 12.3473L13.3433 11.9048C13.1094 11.8724 12.9072 11.7327 12.8026 11.531L11.3712 8.7715C11.1078 8.26367 10.3467 8.26367 10.0833 8.7715L8.6519 11.531C8.5473 11.7327 8.3451 11.8724 8.1112 11.9048L4.91057 12.3473C4.32155 12.4287 4.08635 13.1174 4.51257 13.5127L6.82857 15.6607C6.99782 15.8177 7.07506 16.0438 7.0351 16.2655L6.48837 19.2985C6.38775 19.8566 7.00349 20.2823 7.53033 20.0188L10.3931 18.5868Z", fill: "#008579", fillOpacity: "0.6" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.4904 15.9496C24.183 15.7959 23.8158 15.7959 23.5084 15.9496L19.3019 18.0538C18.5278 18.441 17.623 17.8155 17.7709 16.9954L18.5742 12.5388C18.6329 12.2131 18.5195 11.8807 18.2708 11.6501L14.8677 8.49389C14.2414 7.91305 14.587 6.90106 15.4525 6.7814L20.1554 6.13118C20.4991 6.08367 20.7962 5.87828 20.9499 5.58196L23.0532 1.52719C23.4402 0.780976 24.5586 0.780978 24.9457 1.52719L27.0489 5.58196C27.2026 5.87828 27.4997 6.08367 27.8434 6.13118L32.5464 6.7814C33.4119 6.90106 33.7574 7.91305 33.1312 8.49389L29.7281 11.6501C29.4794 11.8807 29.3659 12.2131 29.4246 12.5388L30.228 16.9954C30.3758 17.8155 29.471 18.441 28.6969 18.0538L24.4904 15.9496Z", fill: "#00E5D0" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.4904 15.9496C24.183 15.7959 23.8158 15.7959 23.5084 15.9496L19.3019 18.0538C18.5278 18.441 17.623 17.8155 17.7709 16.9954L18.5742 12.5388C18.6329 12.2131 18.5195 11.8807 18.2708 11.6501L14.8677 8.49389C14.2414 7.91305 14.587 6.90106 15.4525 6.7814L20.1554 6.13118C20.4991 6.08367 20.7962 5.87828 20.9499 5.58196L23.0532 1.52719C23.4402 0.780976 24.5586 0.780978 24.9457 1.52719L27.0489 5.58196C27.2026 5.87828 27.4997 6.08367 27.8434 6.13118L32.5464 6.7814C33.4119 6.90106 33.7574 7.91305 33.1312 8.49389L29.7281 11.6501C29.4794 11.8807 29.3659 12.2131 29.4246 12.5388L30.228 16.9954C30.3758 17.8155 29.471 18.441 28.6969 18.0538L24.4904 15.9496Z", fill: "#008579", fillOpacity: "0.35" }),
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.995 17.4983L23.2015 15.3942C23.701 15.1443 24.2978 15.1443 24.7973 15.3942L29.0038 17.4983C29.2941 17.6436 29.6334 17.409 29.5779 17.1015L28.7746 12.6448C28.6792 12.1156 28.8636 11.5756 29.2677 11.2008L32.6708 8.04455C32.9057 7.82673 32.7761 7.44724 32.4515 7.40237L27.7486 6.75215C27.1901 6.67494 26.7073 6.34119 26.4575 5.85967L24.3543 1.80489C24.2091 1.52506 23.7897 1.52507 23.6446 1.80489L21.5413 5.85967C21.2916 6.34119 20.8088 6.67494 20.2503 6.75215L15.5473 7.40237C15.2227 7.44724 15.0931 7.82674 15.328 8.04455L18.7311 11.2008C19.1352 11.5756 19.3197 12.1156 19.2242 12.6448L18.4209 17.1015C18.3654 17.409 18.7047 17.6436 18.995 17.4983ZM23.5084 15.9496C23.8158 15.7959 24.183 15.7959 24.4904 15.9496L28.6969 18.0538C29.471 18.441 30.3758 17.8155 30.228 16.9954L29.4246 12.5388C29.3659 12.2131 29.4794 11.8807 29.7281 11.6501L33.1312 8.49389C33.7574 7.91305 33.4119 6.90106 32.5464 6.7814L27.8434 6.13118C27.4997 6.08367 27.2026 5.87828 27.0489 5.58196L24.9457 1.52719C24.5586 0.780978 23.4402 0.780976 23.0532 1.52719L20.9499 5.58196C20.7962 5.87828 20.4991 6.08367 20.1554 6.13118L15.4525 6.7814C14.587 6.90106 14.2414 7.91305 14.8677 8.49389L18.2708 11.6501C18.5195 11.8807 18.6329 12.2131 18.5742 12.5388L17.7709 16.9954C17.623 17.8155 18.5278 18.441 19.3019 18.0538L23.5084 15.9496Z", fill: "#008579", fillOpacity: "0.6" }))),
    react.createElement("defs", null,
        react.createElement("clipPath", { id: "clip0_3103_15238" },
            react.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(0 0.399902)" })),
        react.createElement("clipPath", { id: "clip1_3103_15238" },
            react.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(0 0.399902)" })))));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/NoEndorsements/index.esm.js



const NoEndorsementsIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "48", height: "49", viewBox: "0 0 48 49" }, props),
    react.createElement("g", { clipPath: "url(#clip0_3103_8660)" },
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48 12.499C48 19.1811 42.6273 24.5981 36 24.5981C34.6609 24.5981 33.3727 24.3768 32.1703 23.9687C31.7078 24.3323 31.0188 24.8057 30.3734 25.0156C29.6078 25.2649 27.593 25.7462 27.307 25.3232C26.9578 24.807 27.5007 24.0078 27.9501 23.3462C28.1502 23.0517 28.3318 22.7845 28.4078 22.5816C28.5688 22.1239 28.5672 22.0002 28.4078 21.8687C25.7172 19.6498 24 16.2768 24 12.499C24 5.81693 29.3727 0.399902 36 0.399902C42.6273 0.399902 48 5.81693 48 12.499ZM32.7216 12.3481L34.4404 14.0669L39.007 9.50031C39.5042 9.00273 40.3124 9.00273 40.8095 9.50031C41.3071 9.99789 41.3071 10.8057 40.8095 11.3028L35.3416 16.7711C34.8436 17.2687 34.0367 17.2687 33.5387 16.7711L30.9186 14.1506C30.4211 13.6535 30.4211 12.8453 30.9186 12.3481C31.4162 11.8505 32.224 11.8505 32.7216 12.3481Z", fill: "#00E5D0" }),
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48 12.499C48 19.1811 42.6273 24.5981 36 24.5981C34.6609 24.5981 33.3727 24.3768 32.1703 23.9687C31.7078 24.3323 31.0188 24.8057 30.3734 25.0156C29.6078 25.2649 27.593 25.7462 27.307 25.3232C26.9578 24.807 27.5007 24.0078 27.9501 23.3462C28.1502 23.0517 28.3318 22.7845 28.4078 22.5816C28.5688 22.1239 28.5672 22.0002 28.4078 21.8687C25.7172 19.6498 24 16.2768 24 12.499C24 5.81693 29.3727 0.399902 36 0.399902C42.6273 0.399902 48 5.81693 48 12.499ZM32.7216 12.3481L34.4404 14.0669L39.007 9.50031C39.5042 9.00273 40.3124 9.00273 40.8095 9.50031C41.3071 9.99789 41.3071 10.8057 40.8095 11.3028L35.3416 16.7711C34.8436 17.2687 34.0367 17.2687 33.5387 16.7711L30.9186 14.1506C30.4211 13.6535 30.4211 12.8453 30.9186 12.3481C31.4162 11.8505 32.224 11.8505 32.7216 12.3481Z", fill: "#008579", fillOpacity: "0.35" }),
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.827 19.7021H19.8269H19.8269C19.753 19.7025 19.6785 19.7029 19.6036 19.7029C18.8669 19.7029 18.3589 20.2186 18.3293 20.7305C18.1671 23.7184 16.7562 25.31 15.3296 26.1219C14.6335 26.5181 13.9524 26.719 13.4476 26.8216C13.1941 26.8731 12.9819 26.9004 12.8299 26.915C12.7539 26.9223 12.6926 26.9264 12.6485 26.9287L12.61 26.9305C9.39012 27.3287 7.23579 29.141 6.29031 30.1155C6.03138 30.3867 5.90032 30.7196 5.90032 31.0541V43.1374C5.90032 43.2661 5.95506 43.412 6.07431 43.535L6.07561 43.5363C6.9511 44.4443 8.25597 45.0767 9.79124 45.499C11.3193 45.9194 13.019 46.1163 14.6243 46.1934C16.1855 46.2685 17.6382 46.2295 18.7293 46.1799C18.53 45.8424 18.4148 45.4512 18.4148 45.0249V44.0107C18.4148 43.2955 18.7391 42.6792 19.2406 42.2491C18.7391 41.8189 18.4148 41.2026 18.4148 40.4874V39.4732C18.4148 38.7595 18.7378 38.1442 19.2375 37.7142C18.7378 37.2842 18.4148 36.6689 18.4148 35.9552V34.9409C18.4148 34.6804 18.4578 34.4329 18.5368 34.2028C18.2241 34.5565 17.8554 34.9054 17.4416 35.24C16.0434 36.3704 14.065 37.3896 11.789 37.8862C11.4383 37.9627 11.0919 37.7404 11.0154 37.3897C10.9389 37.0389 11.1612 36.6926 11.5119 36.616C13.5893 36.1628 15.3829 35.2327 16.6243 34.229C17.2455 33.7268 17.712 33.2194 18.0081 32.7623C18.3127 32.292 18.3943 31.9427 18.3723 31.731L18.3722 31.7301C18.2266 30.3086 18.3293 29.3704 18.8889 28.7905C19.1658 28.5033 19.4989 28.366 19.7754 28.2753C19.798 28.2679 19.8208 28.2606 19.8438 28.2534C20.0733 28.1461 20.3204 28.0697 20.5773 28.0288C21.5758 27.6622 22.0768 26.975 22.3721 26.212C22.5238 25.8199 22.6193 25.4105 22.6938 25.0132C22.7189 24.8798 22.7434 24.7356 22.7678 24.5917L22.7678 24.5916C22.8094 24.3465 22.8509 24.1022 22.8947 23.914L22.8944 23.9152L23.5281 24.0598L22.8951 23.9122L22.8947 23.914C23.0932 23.0428 23.0309 22.1358 22.7123 21.2939C22.3699 20.3892 21.8717 20.0308 21.3768 19.8625C20.8875 19.6961 20.3713 19.699 19.827 19.7021ZM5.86469 45.084C6.8786 45.8628 8.13375 46.3914 9.44646 46.7525C11.1008 47.2076 12.9045 47.4123 14.5619 47.4919C16.2223 47.5717 17.7561 47.5269 18.8752 47.4746C19.2058 47.4591 19.519 47.442 19.7797 47.4277C19.9458 47.4186 20.0905 47.4107 20.2048 47.4051C20.3621 47.3975 20.4718 47.3936 20.5411 47.3936C20.5756 47.4017 20.6107 47.4069 20.6462 47.4093C20.7671 47.4255 20.89 47.4338 21.0141 47.4338H25.6923C27.0634 47.4338 28.2916 46.4166 28.2916 45.0249V44.0107C28.2916 43.5513 28.1578 43.1328 27.9292 42.7781C28.9436 42.4721 29.7276 41.5992 29.7276 40.4874V39.4732C29.7276 38.9406 29.5477 38.4628 29.2487 38.0759C30.0467 37.6789 30.6178 36.9041 30.6178 35.9552V34.9409C30.6178 34.39 30.4252 33.8977 30.1075 33.5039C30.8708 33.0977 31.4105 32.3398 31.4105 31.4173V30.403C31.4105 29.0114 30.1823 27.9942 28.8112 27.9942H22.8301C23.1697 27.5838 23.4103 27.1312 23.5844 26.6813C23.7779 26.1815 23.8908 25.6833 23.9715 25.253C24.0083 25.0573 24.0364 24.8898 24.0613 24.7411L24.0613 24.741C24.0958 24.5354 24.1243 24.3657 24.1612 24.2073L24.1618 24.2044C24.4178 23.0826 24.3371 21.9146 23.9281 20.8338C23.4518 19.5751 22.6667 18.9281 21.7954 18.6317C21.0815 18.3889 20.3301 18.3963 19.8038 18.4015C19.7327 18.4022 19.6658 18.4029 19.6036 18.4029C18.3004 18.4029 17.1062 19.3406 17.0313 20.6576L17.0312 20.6593C16.8942 23.1878 15.7453 24.3896 14.6866 24.992C14.1401 25.3031 13.5972 25.4646 13.1887 25.5476C12.9855 25.5889 12.8187 25.6101 12.7058 25.6209C12.6495 25.6263 12.6069 25.6291 12.5802 25.6305C12.5669 25.6312 12.5576 25.6316 12.5525 25.6317L12.5487 25.6319L12.5486 25.6319L12.5483 25.6319L12.5163 25.6323L12.4821 25.6365C8.83191 26.0777 6.40934 28.1254 5.35548 29.2121L5.35547 29.2121L5.35254 29.2152C5.33751 29.2309 5.3227 29.2467 5.30809 29.2627C4.82042 28.7189 4.08402 28.3871 3.30103 28.3871H2.59929C1.22822 28.3871 0 29.4044 0 30.796V44.6792C0 46.0708 1.22822 47.088 2.59929 47.088H3.30103C4.53526 47.088 5.65372 46.2637 5.86469 45.084ZM4.60032 31.0541V30.796C4.60032 30.2448 4.08308 29.6872 3.30103 29.6872H2.59929C1.81723 29.6872 1.3 30.2448 1.3 30.796V44.6792C1.3 45.2303 1.81723 45.788 2.59929 45.788H3.30103C4.08308 45.788 4.60032 45.2303 4.60032 44.6792V43.1374V31.0541ZM20.7215 46.102C20.7456 46.1048 20.7898 46.1106 20.8418 46.1245C20.8977 46.1306 20.9551 46.1338 21.0141 46.1338H25.6923C26.4744 46.1338 26.9916 45.5761 26.9916 45.0249V44.0107C26.9916 43.4595 26.4744 42.9018 25.6923 42.9018H21.0141C20.232 42.9018 19.7148 43.4595 19.7148 44.0107V45.0249C19.7148 45.4936 20.0888 45.967 20.6816 46.0982C20.6949 46.0992 20.7083 46.1005 20.7215 46.102ZM20.4603 29.4269C20.4055 29.4426 20.3554 29.4569 20.3081 29.4709C19.9361 29.6791 19.7148 30.0425 19.7148 30.403V31.4173C19.7148 31.9684 20.232 32.5261 21.0141 32.5261H28.8112C29.5933 32.5261 30.1105 31.9684 30.1105 31.4173V30.403C30.1105 29.8519 29.5933 29.2942 28.8112 29.2942H21.0141C20.9688 29.2942 20.9244 29.296 20.8809 29.2997C20.7607 29.3398 20.6468 29.3734 20.544 29.403L20.4604 29.4269L20.4603 29.4269ZM19.7148 34.9409C19.7148 34.3898 20.232 33.8321 21.0141 33.8321H28.0185C28.8005 33.8321 29.3178 34.3898 29.3178 34.9409V35.9552C29.3178 36.5064 28.8005 37.0641 28.0185 37.0641H21.0141C20.232 37.0641 19.7148 36.5064 19.7148 35.9552V34.9409ZM21.0141 38.3643C20.232 38.3643 19.7148 38.922 19.7148 39.4732V40.4874C19.7148 41.0386 20.232 41.5963 21.0141 41.5963H27.1283C27.9104 41.5963 28.4276 41.0386 28.4276 40.4874V39.4732C28.4276 38.922 27.9104 38.3643 27.1283 38.3643H21.0141Z", fill: "#051851" })),
    react.createElement("defs", null,
        react.createElement("clipPath", { id: "clip0_3103_8660" },
            react.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(0 0.399902)" })))));



// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
// EXTERNAL MODULE: ./components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(80292);
// EXTERNAL MODULE: ./utils/getImageWithWWW.ts
var getImageWithWWW = __webpack_require__(62400);
;// CONCATENATED MODULE: ./components/RatingBar/components/Recommender.tsx




var RecommenderComponent = function(param) {
    var recommender = param.recommender, language = param.language;
    var ref;
    var title = recommender.title, firstName = recommender.firstName, lastName = recommender.lastName;
    var userTitle = "".concat(title[language] || title.en || "", " ").concat(firstName[language], " ").concat(lastName[language]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        mt: 1,
        container: true,
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: userTitle,
                width: 24,
                height: 24,
                src: (0,getImageWithWWW/* default */.Z)((ref = recommender.images) === null || ref === void 0 ? void 0 : ref.logo),
                withDoctifyCDNLoader: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                ml: 1,
                variant: "body2",
                fontWeight: "500",
                color: "text.primary",
                children: userTitle
            })
        ]
    });
};
/* harmony default export */ var Recommender = (RecommenderComponent);

;// CONCATENATED MODULE: ./components/RatingBar/components/RecentReviewComponent/default.tsx
function RecentReviewComponent_default_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecentReviewComponent_default_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecentReviewComponent_default_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var default_SectionWrapperComponent = function(param) {
    var title = param.title, latestReview = param.latestReview, recommender = param.recommender, language = param.language, noReviewIcon = param.noReviewIcon, noReviewTitle = param.noReviewTitle, outDatedTitle = param.outDatedTitle, href = param.href;
    var ref, ref1;
    var dateTime = (0,useDatetimeCorrector/* useDateTimeCorrector */.B)(latestReview === null || latestReview === void 0 ? void 0 : latestReview.createdAt);
    var theme = (0,useTheme_esm/* default */.Z)();
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var textLatestReview = latestReview && "text" in latestReview ? latestReview.text : latestReview === null || latestReview === void 0 ? void 0 : latestReview.recommendation;
    var cuttedLatestReview = !!textLatestReview && (0,strings/* truncateString */.aS)(textLatestReview);
    var isOlderThanSixMonth = (0,date/* isOlderThanNMonth */.iD)(6, latestReview === null || latestReview === void 0 ? void 0 : latestReview.createdAt);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        container: true,
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                justifyContent: "space-between",
                mb: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        sx: RecentReviewComponent_default_objectSpread({}, theme === null || theme === void 0 ? void 0 : (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.RatingBar) === null || ref1 === void 0 ? void 0 : ref1.sectionTitle),
                        variant: "body2",
                        component: "h3",
                        children: title
                    }),
                    !!latestReview && !(isOlderThanSixMonth && outDatedTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        variant: "subtitle2",
                        component: "p",
                        fontWeight: 400,
                        color: "text.secondary",
                        children: dateTime
                    })
                ]
            }),
            !!latestReview && latestReview.id && !(isOlderThanSixMonth && outDatedTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        component: Link_esm/* default */.Z,
                        href: href,
                        variant: "body1",
                        sx: RecentReviewComponent_default_objectSpread({
                            maxHeight: 45,
                            maxWidth: "100%",
                            overflow: "hidden",
                            textDecoration: "inherit"
                        }, theme.custom.SpecialistPage.ratingBar.reviewText),
                        children: cuttedLatestReview
                    }),
                    !!recommender && /*#__PURE__*/ (0,jsx_runtime.jsx)(Recommender, {
                        recommender: recommender,
                        language: language
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                display: "flex",
                children: [
                    !isWPA && noReviewIcon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        children: isOlderThanSixMonth && outDatedTitle ? outDatedTitle : noReviewTitle
                    })
                ]
            })
        ]
    });
};
var Default = function(param) {
    var isUnclaimed = param.isUnclaimed, type = param.type, isBasic = param.isBasic, latestReview = param.latestReview, peerRecommendation = param.peerRecommendation;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var isClinic = type === RATING_TYPE.CLINIC;
    var isSpecialist = type === RATING_TYPE.SPECIALIST;
    return isUnclaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper, {
        sx: {
            pt: 4.5,
            pb: 3,
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            direction: "column",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoReviewsImageIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        color: "text.black900",
                        children: translate(isClinic ? "reviews.no_reviews_practice" : "reviews.no_reviews_specialist")
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
        lgDown: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(default_SectionWrapperComponent, {
                title: translate("reviews.recent_patient_review"),
                latestReview: !isBasic ? latestReview : undefined,
                language: language,
                noReviewIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoReviewsIcon, {
                    sx: {
                        width: 48,
                        height: 48,
                        mr: 2
                    }
                }),
                noReviewTitle: translate(isClinic ? "reviews.no_reviews_practice" : "reviews.not_collecting_specialist"),
                outDatedTitle: translate(isClinic ? "no_review_over_6_month_clinic" : "no_review_over_6_month"),
                href: "#reviews"
            }),
            isSpecialist && /*#__PURE__*/ (0,jsx_runtime.jsx)(default_SectionWrapperComponent, {
                title: translate("peerRecommendations.latest_recommendation"),
                latestReview: peerRecommendation,
                recommender: peerRecommendation === null || peerRecommendation === void 0 ? void 0 : peerRecommendation.recommender,
                language: language,
                noReviewIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoEndorsementsIcon, {
                    sx: {
                        width: 48,
                        height: 48,
                        mr: 2
                    }
                }),
                noReviewTitle: translate("peerRecommendations.not_collecting_specialist"),
                href: "#endorsements"
            })
        ]
    });
};
/* harmony default export */ var RecentReviewComponent_default = (Default);

;// CONCATENATED MODULE: ./components/RatingBar/components/RecentReviewComponent/index.tsx
function RecentReviewComponent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecentReviewComponent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecentReviewComponent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RecentReviewComponent_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = RecentReviewComponent_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RecentReviewComponent_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var RecentReviewComponent = function(_param) {
    var variant = _param.variant, props = RecentReviewComponent_objectWithoutProperties(_param, [
        "variant"
    ]);
    if (variant === types/* Variants.minimal */.t.minimal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentReviewComponent_minimal, RecentReviewComponent_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentReviewComponent_default, RecentReviewComponent_objectSpread({}, props));
};
/* harmony default export */ var components_RecentReviewComponent = (RecentReviewComponent);

;// CONCATENATED MODULE: ./components/RatingBar/components/ReviewStats.tsx



var ReviewStats = function(param) {
    var reviewsTotal = param.reviewsTotal, averageRating = param.averageRating, peerRecommendationsCount = param.peerRecommendationsCount, _hideRealData = param.hideRealData, hideRealData = _hideRealData === void 0 ? false : _hideRealData;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        sx: {
            py: 2,
            px: {
                xs: 0,
                lg: 2
            },
            pb: 0,
            pt: 1
        },
        wrap: "nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                variant: "h1",
                component: "p",
                sx: {
                    lineHeight: 1
                },
                children: hideRealData || !averageRating ? "--" : averageRating.toFixed(2)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                width: "max-content",
                container: true,
                flexDirection: "column",
                justifyContent: "end",
                children: [
                    !!reviewsTotal && !hideRealData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_esm/* default */.Z, {
                        underline: "none",
                        color: "#051851",
                        href: "#reviews",
                        variant: "body2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                component: "span",
                                sx: theme.custom.SpecialistPage.ratingBar.trustScoreInfo.count,
                                children: reviewsTotal
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                component: "span",
                                sx: theme.custom.SpecialistPage.ratingBar.trustScoreInfo.infoText,
                                children: translate("patient_reviews", {
                                    count: reviewsTotal
                                })
                            })
                        ]
                    }),
                    !!peerRecommendationsCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_esm/* default */.Z, {
                        underline: "none",
                        color: "#051851",
                        href: "#endorsements",
                        variant: "body2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                component: "span",
                                sx: theme.custom.SpecialistPage.ratingBar.trustScoreInfo.count,
                                children: peerRecommendationsCount
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                component: "span",
                                sx: theme.custom.SpecialistPage.ratingBar.trustScoreInfo.infoText,
                                children: translate("peer_endorsements", {
                                    count: peerRecommendationsCount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ReviewStats = (ReviewStats);

;// CONCATENATED MODULE: ./components/RatingBar/variants/default/index.tsx














function default_Default(props) {
    var profileName = props.profileName, _isBasic = props.isBasic, isBasic = _isBasic === void 0 ? false : _isBasic, averageRating = props.averageRating, reviewsTotal = props.reviewsTotal, externalIdProfile = props.externalIdProfile, peerRecommendation = props.peerRecommendation, peerRecommendationsCount = props.peerRecommendationsCount, type = props.type, onBookAppointment = props.onBookAppointment, _statistic = props.statistic, statistic = _statistic === void 0 ? [] : _statistic, latestReview = props.latestReview, review = props.review, _hideBookAppointment = props.hideBookAppointment, hideBookAppointment = _hideBookAppointment === void 0 ? false : _hideBookAppointment, _isUnclaimed = props.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _contacts = props.contacts, contacts = _contacts === void 0 ? [] : _contacts, slug = props.slug, _bookingCalendarComponent = props.bookingCalendarComponent, bookingCalendarComponent = _bookingCalendarComponent === void 0 ? null : _bookingCalendarComponent, onlineBookingAvailable = props.onlineBookingAvailable;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref = (0,react.useContext)(SearchReviews/* SearchReviewsContext */.U), keywordNames = ref.state.keywordNames;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref1 = hooks_useRatingBarConfig(props), displayNewBadge = ref1.displayNewBadge, displayEndorsementsChart = ref1.displayEndorsementsChart, displayRecentReview = ref1.displayRecentReview;
    var onSelectKeyword = (0,useBuildTopStats/* default */.Z)(statistic).onSelectKeyword;
    var isClinic = type === RATING_TYPE.CLINIC;
    var isOnlineBookingAvailable = !!bookingCalendarComponent;
    var displayStarsComponent = !(isBasic || isUnclaimed || !averageRating);
    var contactsAvailable = !hideBookAppointment && (contacts === null || contacts === void 0 ? void 0 : contacts.length) >= 1;
    var showPanel = contactsAvailable && !isOnlineBookingAvailable;
    var showCalendar = isOnlineBookingAvailable;
    var ref2 = (0,react.useState)(true), expanded = ref2[0], setExpanded = ref2[1];
    var toggleExpandedContent = function() {
        return setExpanded(function(prev) {
            return !prev;
        });
    };
    var ref3 = (0,react.useState)(null), activeKeyword = ref3[0], setActiveKeyword = ref3[1];
    var onClickBookAppointment = (0,react.useCallback)(function(button, label) {
        if (onBookAppointment) {
            onBookAppointment(button);
        }
        window.dataLayer.push({
            event: "prf_pg_cont_button",
            cont_prf_name: profileName,
            cont_prf_type: type === RATING_TYPE.CLINIC ? "Practice" : "Specialist",
            cont_interaction_label: label,
            cont_prf_uuid: externalIdProfile
        });
    }, [
        externalIdProfile,
        onBookAppointment,
        profileName,
        type
    ]);
    var onClickReveal = (0,react.useCallback)(function(event, label, targetName, targetUuid) {
        window.dataLayer.push({
            event: event,
            cont_prf_name: profileName,
            cont_prf_type: type === RATING_TYPE.CLINIC ? "Practice" : "Specialist",
            cont_enquired_at_name: targetName,
            cont_enquired_at_uuid: targetUuid,
            cont_interaction_label: label,
            cont_prf_uuid: externalIdProfile
        });
    }, [
        externalIdProfile,
        profileName,
        type
    ]);
    (0,react.useEffect)(function() {
        var activeKeywordFromStorage = localStorage.getItem("activeKeyword-".concat(slug));
        if ((statistic === null || statistic === void 0 ? void 0 : statistic.length) && activeKeywordFromStorage && (activeKeywordFromStorage === null || activeKeywordFromStorage === void 0 ? void 0 : activeKeywordFromStorage.length)) {
            var activeKeywordFromStatistic = statistic.find(function(x) {
                return x.tagName[language] === activeKeywordFromStorage;
            });
            var activeKeywordFromKeywordNames = keywordNames === null || keywordNames === void 0 ? void 0 : keywordNames.some(function(keyword) {
                return keyword.name === activeKeywordFromStorage;
            });
            if (activeKeywordFromStatistic && activeKeywordFromKeywordNames) {
                setActiveKeyword({
                    name: activeKeywordFromStatistic.tagName[language],
                    variant: "aqua",
                    value: activeKeywordFromStatistic.tagCount,
                    color: "rgba(0, 229, 208, 0.6)",
                    hover: "#00E5D0"
                });
            }
        }
        localStorage.removeItem("activeKeyword-".concat(slug));
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        statistic
    ]);
    (0,react.useEffect)(function() {
        if (activeKeyword) {
            onSelectKeyword(activeKeyword.name);
        }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeKeyword
    ]);
    var actionPanelComponent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionPanel, {
            isClinic: isClinic,
            onlineBookingAvailable: onlineBookingAvailable,
            onClickBookAppointment: onClickBookAppointment,
            onClickReveal: onClickReveal,
            contacts: contacts
        });
    }, [
        contacts,
        isClinic,
        onClickBookAppointment,
        onClickReveal,
        onlineBookingAvailable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                sx: {
                    py: 2,
                    px: {
                        xs: 0,
                        lg: 2
                    },
                    pb: 0
                },
                container: true,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        variant: "body2",
                        component: "h3",
                        sx: theme.custom.SpecialistPage.ratingBar.title,
                        children: translate("reviews.trust_rating")
                    }),
                    displayNewBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_esm/* default */.Z, {
                        direction: "row",
                        sx: {
                            backgroundColor: "#FFEFEF",
                            p: 0.5,
                            px: 1,
                            borderRadius: 16
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            variant: "body2",
                            sx: {
                                ml: 0.5
                            },
                            children: translate("new")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReviewStats, {
                hideRealData: isBasic || isUnclaimed,
                reviewsTotal: reviewsTotal,
                averageRating: averageRating,
                peerRecommendationsCount: peerRecommendationsCount
            }),
            displayStarsComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                expanded: expanded,
                averageRating: averageRating,
                review: review,
                toggleExpandedContent: toggleExpandedContent
            }),
            displayEndorsementsChart && !!(statistic === null || statistic === void 0 ? void 0 : statistic.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EndorsementsChart, {
                activeKeyword: activeKeyword,
                statistic: statistic,
                isBookingAvailable: isOnlineBookingAvailable
            }) : null,
            displayRecentReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RecentReviewComponent, {
                isUnclaimed: isUnclaimed,
                isBasic: isBasic,
                type: type,
                latestReview: latestReview,
                peerRecommendation: peerRecommendation
            }),
            showCalendar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                component: Hidden_esm/* default */.Z,
                smDown: true,
                implementation: "css",
                children: bookingCalendarComponent
            }) : null,
            contactsAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                component: Hidden_esm/* default */.Z,
                xsmUp: true,
                implementation: "css",
                children: actionPanelComponent
            }) : null,
            showPanel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                component: Hidden_esm/* default */.Z,
                xsmDown: true,
                implementation: "css",
                children: actionPanelComponent
            }) : null
        ]
    });
}
/* harmony default export */ var RatingBar_variants_default = (default_Default);

;// CONCATENATED MODULE: ./components/RatingBar/variants/minimal/index.tsx














function minimal_Minimal(props) {
    var profileName = props.profileName, _isBasic = props.isBasic, isBasic = _isBasic === void 0 ? false : _isBasic, averageRating = props.averageRating, externalIdProfile = props.externalIdProfile, peerRecommendation = props.peerRecommendation, type = props.type, onBookAppointment = props.onBookAppointment, _statistic = props.statistic, statistic = _statistic === void 0 ? [] : _statistic, latestReview = props.latestReview, review = props.review, _hideBookAppointment = props.hideBookAppointment, hideBookAppointment = _hideBookAppointment === void 0 ? false : _hideBookAppointment, _isUnclaimed = props.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _contacts = props.contacts, contacts = _contacts === void 0 ? [] : _contacts, slug = props.slug, onlineBookingAvailable = props.onlineBookingAvailable;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref = (0,react.useContext)(SearchReviews/* SearchReviewsContext */.U), keywordNames = ref.state.keywordNames;
    var ref1 = hooks_useRatingBarConfig(props), displayEndorsementsChart = ref1.displayEndorsementsChart, displayRecentReview = ref1.displayRecentReview;
    var onSelectKeyword = (0,useBuildTopStats/* default */.Z)(statistic).onSelectKeyword;
    var isClinic = type === RATING_TYPE.CLINIC;
    var displayStarsComponent = !(isBasic || isUnclaimed || !averageRating);
    var ref2 = (0,react.useState)(null), activeKeyword = ref2[0], setActiveKeyword = ref2[1];
    var onClickBookAppointment = function(button, label) {
        if (onBookAppointment) {
            onBookAppointment(button);
        }
        window.dataLayer.push({
            event: "prf_pg_cont_button",
            cont_prf_name: profileName,
            cont_prf_type: type === RATING_TYPE.CLINIC ? "Practice" : "Specialist",
            cont_interaction_label: label,
            cont_prf_uuid: externalIdProfile
        });
    };
    var onClickReveal = function(event, label, targetName, targetUuid) {
        window.dataLayer.push({
            event: event,
            cont_prf_name: profileName,
            cont_prf_type: type === RATING_TYPE.CLINIC ? "Practice" : "Specialist",
            cont_enquired_at_name: targetName,
            cont_enquired_at_uuid: targetUuid,
            cont_interaction_label: label,
            cont_prf_uuid: externalIdProfile
        });
    };
    (0,react.useEffect)(function() {
        var activeKeywordFromStorage = localStorage.getItem("activeKeyword-".concat(slug));
        if ((statistic === null || statistic === void 0 ? void 0 : statistic.length) && activeKeywordFromStorage && (activeKeywordFromStorage === null || activeKeywordFromStorage === void 0 ? void 0 : activeKeywordFromStorage.length)) {
            var activeKeywordFromStatistic = statistic.find(function(x) {
                return x.tagName[language] === activeKeywordFromStorage;
            });
            var activeKeywordFromKeywordNames = keywordNames === null || keywordNames === void 0 ? void 0 : keywordNames.some(function(keyword) {
                return keyword.name === activeKeywordFromStorage;
            });
            if (activeKeywordFromStatistic && activeKeywordFromKeywordNames) {
                setActiveKeyword({
                    name: activeKeywordFromStatistic.tagName[language],
                    variant: "aqua",
                    value: activeKeywordFromStatistic.tagCount,
                    color: "rgba(0, 229, 208, 0.6)",
                    hover: "#00E5D0"
                });
            }
        }
        localStorage.removeItem("activeKeyword-".concat(slug));
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        statistic
    ]);
    (0,react.useEffect)(function() {
        if (activeKeyword) {
            onSelectKeyword(activeKeyword.name);
        }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeKeyword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                component: Hidden_esm/* default */.Z,
                smDown: true,
                implementation: "css",
                sx: {
                    "&:only-child": {
                        paddingBottom: "20px"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsContainer, {
                    sx: {
                        paddingTop: "20px"
                    },
                    children: displayStarsComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                        averageRating: averageRating,
                        review: review,
                        variant: types/* Variants.minimal */.t.minimal
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                        averageRating: 0,
                        review: null,
                        variant: types/* Variants.minimal */.t.minimal
                    })
                })
            }),
            displayEndorsementsChart && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EndorsementsChart, {
                activeKeyword: activeKeyword,
                statistic: statistic,
                isBookingAvailable: onlineBookingAvailable,
                variant: types/* Variants.minimal */.t.minimal
            }),
            displayRecentReview && (!!latestReview || !!(peerRecommendation === null || peerRecommendation === void 0 ? void 0 : peerRecommendation.recommendation)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                component: Hidden_esm/* default */.Z,
                lgDown: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RecentReviewComponent, {
                    isUnclaimed: isUnclaimed,
                    isBasic: isBasic,
                    type: type,
                    latestReview: latestReview,
                    peerRecommendation: peerRecommendation,
                    variant: types/* Variants.minimal */.t.minimal
                })
            }) : null,
            !hideBookAppointment && (contacts === null || contacts === void 0 ? void 0 : contacts.length) >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionPanel, {
                isClinic: isClinic,
                onlineBookingAvailable: onlineBookingAvailable,
                onClickBookAppointment: onClickBookAppointment,
                onClickReveal: onClickReveal,
                contacts: contacts
            }) : null
        ]
    });
}
/* harmony default export */ var variants_minimal = (minimal_Minimal);

// EXTERNAL MODULE: ../../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(43404);
;// CONCATENATED MODULE: ./hooks/useTrackWindowHeight.ts


function useTrackWindowHeight() {
    var disabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react.useState)("100vh"), height = ref[0], setHeight = ref[1];
    (0,react.useEffect)(function() {
        if (lib/* isMobile */.tq) {
            return;
        }
        var resizeObserver = new ResizeObserver(function(entries) {
            var footer = window.document.querySelector("footer");
            var footerHeight = (footer === null || footer === void 0 ? void 0 : footer.offsetHeight) || 0;
            entries.forEach(function(el) {
                return setHeight("".concat(el.contentRect.height - 104 - footerHeight, "px"));
            });
        });
        resizeObserver.observe(document.body);
    }, [
        disabled
    ]);
    return height;
};

// EXTERNAL MODULE: ./components/FullWidthContainer.tsx
var FullWidthContainer = __webpack_require__(5850);
;// CONCATENATED MODULE: ./components/RatingBar/index.tsx
function RatingBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RatingBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RatingBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











function RatingBar(props) {
    var endAnchorRef = props.endAnchorRef, styles = props.styles, omitContainerSpacing = props.omitContainerSpacing;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    var el = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(70), elementOffset = ref2[0], setElementOffset = ref2[1];
    var windowHeight = useTrackWindowHeight();
    var ratingBarWrapperHeight = (0,react.useMemo)(function() {
        if (endAnchorRef === null || endAnchorRef === void 0 ? void 0 : endAnchorRef.current) {
            return "".concat((endAnchorRef === null || endAnchorRef === void 0 ? void 0 : endAnchorRef.current.getBoundingClientRect().top) + window.pageYOffset - 200, "px");
        }
        return windowHeight;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endAnchorRef === null || endAnchorRef === void 0 ? void 0 : endAnchorRef.current,
        windowHeight
    ]);
    (0,react.useEffect)(function() {
        var calculateElementPosition = function() {
            var ref;
            var elementHeight = ((ref = el.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
            setElementOffset(Math.min(window.innerHeight - elementHeight, 70));
        };
        window.addEventListener("resize", calculateElementPosition);
        window.addEventListener("load", calculateElementPosition);
        return function() {
            window.removeEventListener("resize", calculateElementPosition);
            window.removeEventListener("load", calculateElementPosition);
        };
    }, []);
    var containerSx = (0,react.useMemo)(function() {
        return {
            backgroundColor: {
                xs: "background.default"
            }
        };
    }, []);
    if (locale === global/* TENANTS.WPA */.rk.WPA) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
            mobileOnly: true,
            sx: containerSx,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootContainer, {
                height: ratingBarWrapperHeight,
                sx: styles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootWrapper, {
                    ref: el,
                    elementOffset: elementOffset,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBar_variants_default, RatingBar_objectSpread({}, props))
                })
            })
        });
    }
    if (newPersistentPanelEnabled) {
        var ref1;
        var hideBackground = isMobile && (props.isUnclaimed || !((ref1 = props.latestReview) === null || ref1 === void 0 ? void 0 : ref1.id));
        return hideBackground ? /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_minimal, RatingBar_objectSpread({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
            mobileOnly: true,
            sx: containerSx,
            containerSx: {
                padding: "0px !important"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootContainer, {
                height: ratingBarWrapperHeight,
                sx: styles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootWrapper, {
                    sx: {
                        borderRadius: "16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        padding: omitContainerSpacing ? {} : {
                            sm: "0 25px",
                            xs: "0 0 14px 0"
                        }
                    },
                    ref: el,
                    elementOffset: elementOffset,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_minimal, RatingBar_objectSpread({}, props))
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
        mobileOnly: true,
        sx: containerSx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootContainer, {
            height: ratingBarWrapperHeight,
            sx: styles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootWrapper, {
                ref: el,
                elementOffset: elementOffset,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBar_variants_default, RatingBar_objectSpread({}, props))
            })
        })
    });
}
/* harmony default export */ var components_RatingBar = (RatingBar);


/***/ }),

/***/ 70848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/utils/lazyLoadImages.esm.js
function laztLoadImages(element, lazyAttribute = 'data-src') {
    if (!element) {
        return;
    }
    const imagesToLazy = Array.from(element.querySelectorAll(`img[${lazyAttribute}]`));
    if (!imagesToLazy.length) {
        return;
    }
    let observer;
    const load = (img) => {
        const src = img.getAttribute(lazyAttribute);
        const onload = () => {
            img.removeAttribute(lazyAttribute);
            img.removeEventListener('load', onload);
        };
        img.addEventListener('load', onload);
        img.setAttribute('src', src);
    };
    const observeHandler = (entries, self) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                load(entry.target);
                if (self) {
                    self.unobserve(entry.target);
                }
            }
        }
    };
    try {
        observer = new window.IntersectionObserver(observeHandler);
        for (const img of imagesToLazy) {
            observer.observe(img);
        }
    }
    catch (_e) {
        for (const img of imagesToLazy) {
            load(img);
        }
    }
}



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/styled.esm.js
var styled_esm = __webpack_require__(64495);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/HTMLSlot/index.esm.js





const SlotRoot = (0,styled_esm/* default */.Z)('span')(({ inline, theme }) => ({
    display: inline ? 'inline' : 'block',
    color: theme.palette.text.black900,
    fontSize: 14,
    b: {
        color: theme.palette.text.darkNavy,
        fontSize: '13.33px'
    },
    'p > a, a': {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            wordBreak: 'break-all'
        }
    }
}));
function HTMLSlot(_a) {
    var { children, className, inline, lazyImages } = _a, restProps = (0,_tslib_esm/* __rest */._)(_a, ["children", "className", "inline", "lazyImages"]);
    const wrapper = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        if (!wrapper.current) {
            return;
        }
        if (lazyImages) {
            laztLoadImages(wrapper.current);
        }
    }, [children]);
    return children ? (react.createElement(SlotRoot, Object.assign({}, restProps, { inline: inline, ref: wrapper, className: className, dangerouslySetInnerHTML: { __html: children } }))) : null;
}
HTMLSlot.defaultProps = {
    inline: false,
    lazyImages: false,
    className: '',
    classes: {}
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/MedalWithStar/index.esm.js



const MedalWithStarIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "13", height: "21", viewBox: "0 0 13 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("circle", { cx: "6.38867", cy: "7.22363", r: "5.63867", stroke: "#051851", strokeWidth: "1.5" }),
    react.createElement("path", { d: "M5.9697 9.32045L4.49528 10.0768L4.77366 8.49309C4.82588 8.19601 4.7241 7.89583 4.50791 7.69022L3.34007 6.57946L4.96563 6.34898C5.25723 6.30764 5.51508 6.12804 5.65024 5.86081L6.38866 4.4009L7.12707 5.86081C7.26224 6.12804 7.52009 6.30764 7.81169 6.34898L9.43724 6.57946L8.2694 7.69022C8.05322 7.89583 7.95144 8.19601 8.00366 8.49309L8.28203 10.0768L6.80762 9.32045C6.54493 9.1857 6.23238 9.1857 5.9697 9.32045Z", stroke: "#051851" }),
    react.createElement("path", { d: "M2.9043 11.6367V19.0217C2.9043 19.4578 3.42357 19.6849 3.74375 19.3888L6.04921 17.257C6.24084 17.0798 6.53651 17.0798 6.72813 17.257L9.03359 19.3888C9.35377 19.6849 9.87305 19.4578 9.87305 19.0217V11.6367", stroke: "#051851", strokeWidth: "1.5" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Medal/index.esm.js



const MedalIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "13", height: "21", viewBox: "0 0 13 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("circle", { cx: "6.38867", cy: "7.22363", r: "5.63867", stroke: "#051851", strokeWidth: "1.5" }),
    react.createElement("path", { d: "M2.9043 11.6367V19.0217C2.9043 19.4578 3.42357 19.6849 3.74375 19.3888L6.04921 17.257C6.24084 17.0798 6.53651 17.0798 6.72813 17.257L9.03359 19.3888C9.35377 19.6849 9.87305 19.4578 9.87305 19.0217V11.6367", stroke: "#051851", strokeWidth: "1.5" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/HeartPulseProfile/index.esm.js



const HeartPulseProfileIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "21", height: "17", viewBox: "0 0 21 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M1.11166 4.90971C1.83257 1.62558 6.1156 -0.844193 10.1866 3.52129C15.9963 -2.76661 22.2017 5.02986 17.9893 9.04824L10.1866 15.8434L5.62086 11.8384", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M1 8.50157H4.53385L6.65417 5.83154L9.48125 10.5041L11.6016 7.83406H13.7219", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Notepad/index.esm.js



const NotepadIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "15", height: "19", viewBox: "0 0 15 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M10.6429 2.82129H12.5714C12.9124 2.82129 13.2394 2.94922 13.4806 3.17695C13.7217 3.40467 13.8571 3.71353 13.8571 4.03557V16.1784C13.8571 16.5005 13.7217 16.8093 13.4806 17.0371C13.2394 17.2648 12.9124 17.3927 12.5714 17.3927H2.28571C1.94472 17.3927 1.6177 17.2648 1.37658 17.0371C1.13546 16.8093 1 16.5005 1 16.1784V4.03557C1 3.71353 1.13546 3.40467 1.37658 3.17695C1.6177 2.94922 1.94472 2.82129 2.28571 2.82129H4.21429", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M9.35715 1.60693H5.50001C4.78993 1.60693 4.21429 2.15059 4.21429 2.82122V3.42836C4.21429 4.09899 4.78993 4.64265 5.50001 4.64265H9.35715C10.0672 4.64265 10.6429 4.09899 10.6429 3.42836V2.82122C10.6429 2.15059 10.0672 1.60693 9.35715 1.60693Z", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M4.21429 7.67822H10.6429", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M4.21429 10.7139H10.6429", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M4.21429 13.75H10.6429", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/StarDocument/index.esm.js



const StarDocumentIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "18", height: "19", viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M2.21429 17.3926C1.89224 17.3926 1.58338 17.2647 1.35566 17.037C1.12793 16.8093 1 16.5004 1 16.1784V2.82122C1 2.49917 1.12793 2.19031 1.35566 1.96259C1.58338 1.73487 1.89224 1.60693 2.21429 1.60693H15.5714C15.8935 1.60693 16.2023 1.73487 16.4301 1.96259C16.6578 2.19031 16.7857 2.49917 16.7857 2.82122V16.1784C16.7857 16.5004 16.6578 16.8093 16.4301 17.037C16.2023 17.2647 15.8935 17.3926 15.5714 17.3926", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M1 5.25H16.7857", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M8.22501 9.94932C8.27728 9.81468 8.36903 9.69899 8.48821 9.61741C8.60739 9.53584 8.74844 9.49219 8.89287 9.49219C9.03729 9.49219 9.17835 9.53584 9.29753 9.61741C9.41671 9.69899 9.50845 9.81468 9.56073 9.94932L10.3379 11.9286H12.4143C12.5501 11.939 12.6802 11.9872 12.79 12.0677C12.8998 12.1483 12.9848 12.258 13.0353 12.3845C13.0859 12.5109 13.1 12.649 13.0761 12.783C13.0522 12.9171 12.9912 13.0417 12.9 13.1429L11.0664 14.7943L11.8436 16.3486C11.9139 16.4851 11.9378 16.6408 11.9115 16.792C11.8852 16.9433 11.8102 17.0818 11.6979 17.1865C11.5864 17.2925 11.4446 17.3611 11.2923 17.3829C11.1399 17.4047 10.9846 17.3784 10.8479 17.3079L8.89287 16.2393L6.93787 17.3079C6.80113 17.3784 6.6458 17.4047 6.49348 17.3829C6.34115 17.3611 6.19939 17.2925 6.08787 17.1865C5.97558 17.0818 5.90058 16.9433 5.87427 16.792C5.84797 16.6408 5.87181 16.4851 5.94215 16.3486L6.7193 14.7943L4.88573 13.1429C4.79455 13.0417 4.73355 12.9171 4.70963 12.783C4.68571 12.649 4.69984 12.5109 4.75041 12.3845C4.80099 12.258 4.88598 12.1483 4.99574 12.0677C5.10551 11.9872 5.23567 11.939 5.37144 11.9286H7.44787L8.22501 9.94932Z", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Publications/index.esm.js



const PublicationsIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "14", height: "17", viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M9.15256 16.0699L5.07628 12.5759L1 16.0699V5.58799C1 5.27911 1.1227 4.98287 1.34112 4.76446C1.55953 4.54604 1.85577 4.42334 2.16465 4.42334H7.98791C8.29679 4.42334 8.59302 4.54604 8.81144 4.76446C9.02985 4.98287 9.15256 5.27911 9.15256 5.58799V16.0699Z", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M4.49377 0.929688H11.4817C11.7906 0.929688 12.0868 1.05239 12.3052 1.27081C12.5236 1.48922 12.6463 1.78545 12.6463 2.09434V12.5762", stroke: "#051851", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styles_styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tooltip/Tooltip.esm.js
var Tooltip_esm = __webpack_require__(20085);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ArrowRight/index.esm.js
var index_esm = __webpack_require__(93716);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ShiledMan/index.esm.js
var ShiledMan_index_esm = __webpack_require__(56200);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/InfoOutlined/index.esm.js
var InfoOutlined_index_esm = __webpack_require__(62646);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Avatar/Avatar.esm.js + 2 modules
var Avatar_esm = __webpack_require__(94801);
// EXTERNAL MODULE: ./hooks/useVisibilityComponents.ts + 1 modules
var useVisibilityComponents = __webpack_require__(92422);
// EXTERNAL MODULE: ./providers/AppData/Profile/index.tsx
var Profile = __webpack_require__(33228);
// EXTERNAL MODULE: ../../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(87530);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Image/index.esm.js
var Image_index_esm = __webpack_require__(80088);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./providers/SearchReviews/index.tsx
var SearchReviews = __webpack_require__(48889);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
;// CONCATENATED MODULE: ./components/ExapndableList.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var List = (0,styled_esm/* default */.Z)("ul", {
    shouldForwardProp: function(prop) {
        return ![
            "columns",
            "noPadding",
            "largeFont",
            "darkText"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, columns = param.columns, noPadding = param.noPadding, _darkText = param.darkText, darkText = _darkText === void 0 ? false : _darkText;
    var columnSize = 12 / columns;
    var columnsTemplate = Array(columns).fill(null).map(function() {
        return "".concat(columnSize, "fr");
    }).join(" ");
    return _objectSpread({}, theme.typography.body1, _defineProperty({
        paddingLeft: noPadding ? 0 : theme.spacing(2),
        color: darkText ? theme.palette.text.primary : theme.palette.grey[800],
        textTransform: "capitalize",
        display: "block",
        columnCount: columns,
        gridTemplateColumns: columnsTemplate
    }, theme.breakpoints.down("sm"), {
        gridTemplateColumns: "12fr",
        columnCount: 1
    }));
});
var ToggleButton = (0,styled_esm/* default */.Z)("button", {
    shouldForwardProp: function(prop) {
        return ![
            "noSpacing",
            "isWPA"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, noSpacing = param.noSpacing, isWPA = param.isWPA;
    return _objectSpread(_defineProperty({
        position: "relative",
        border: "none",
        textDecoration: "underline",
        fontSize: "14px",
        background: "none",
        cursor: "pointer",
        color: theme.palette.text.black900,
        marginTop: theme.spacing(1),
        width: "max-content",
        height: "fit-content"
    }, theme.breakpoints.down("sm"), {
        fontSize: theme.typography.body1.fontSize
    }), (noSpacing || isWPA) && {
        padding: 0
    });
});
var StyledLi = (0,styled_esm/* default */.Z)("li", {
    shouldForwardProp: function(prop) {
        return ![
            "color",
            "largeSpacing",
            "withImage",
            "isExpandButton",
            "itemGutterBottom",
            "isActive"
        ].includes(prop);
    }
})(function(param) {
    var color = param.color, theme = param.theme, withImage = param.withImage, largeSpacing = param.largeSpacing, isExpandButton = param.isExpandButton, itemGutterBottom = param.itemGutterBottom, isActive = param.isActive;
    return _objectSpread({
        listStyle: color || withImage ? "none" : "initial",
        // TODO: broke dots
        display: withImage || color ? "flex" : "list-item",
        margin: largeSpacing ? theme.spacing(0.5) : 0,
        alignItems: color ? "baseline" : undefined,
        color: theme.palette.text.black900,
        fontWeight: isActive ? 600 : 400,
        lineHeight: "19.6px",
        "&:before": color ? {
            content: '""',
            display: "inline-block",
            minWidth: 16,
            height: 8,
            backgroundColor: color,
            marginRight: theme.spacing(2)
        } : {}
    }, isExpandButton && {
        color: theme.palette.primary.main,
        cursor: "pointer"
    }, itemGutterBottom && {
        marginBottom: "6px"
    });
});
// todo: fix complexity
// eslint-disable-next-line complexity
var ExpandableList = function(param) {
    var items = param.items, valueKey = param.valueKey, imageKey = param.imageKey, locale = param.locale, _sx = param.sx, sx = _sx === void 0 ? {} : _sx, _columns = param.columns, columns = _columns === void 0 ? 1 : _columns, _limit = param.limit, limit = _limit === void 0 ? 5 : _limit, _displayAll = param.displayAll, displayAll = _displayAll === void 0 ? false : _displayAll, _largeSpacing = param.largeSpacing, largeSpacing = _largeSpacing === void 0 ? false : _largeSpacing, _largeFont = param.largeFont, largeFont = _largeFont === void 0 ? false : _largeFont, _darkText = param.darkText, darkText = _darkText === void 0 ? false : _darkText, _noSpacing = param.noSpacing, noSpacing = _noSpacing === void 0 ? false : _noSpacing, _hideBullets = param.hideBullets, hideBullets = _hideBullets === void 0 ? false : _hideBullets, _itemGutterBottom = param.itemGutterBottom, itemGutterBottom = _itemGutterBottom === void 0 ? false : _itemGutterBottom, mt = param.mt, mb = param.mb, subtitle = param.subtitle;
    var ref = (0,react.useContext)(SearchReviews/* SearchReviewsContext */.U), filters = ref.state.filters;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var toggleOpen = function() {
        return setOpen(function(prev) {
            return !prev;
        });
    };
    var renderItem = function(item, index) {
        var value = locale ? item[valueKey][locale] : item[valueKey];
        var image = imageKey ? item[imageKey] : null;
        var isExpandButton = item.isExpandButton;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLi, {
            itemGutterBottom: itemGutterBottom,
            color: item.color,
            withImage: !!image,
            isActive: filters.keyword === item.keyName,
            largeSpacing: largeSpacing,
            isExpandButton: isExpandButton,
            onClick: isExpandButton ? toggleOpen : function() {},
            children: [
                !!image && displayAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar_esm/* default */.Z, {
                    sx: {
                        width: 24,
                        height: 24,
                        mr: 2,
                        background: "none",
                        "& img": {
                            objectFit: "contain"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_index_esm/* default */.Z, {
                        lazy: true,
                        width: "24px",
                        height: "24px",
                        src: image,
                        alt: "".concat(value, " Logo")
                    })
                }),
                value
            ]
        }, "list-item-".concat(value, "-").concat(item.color, "-").concat(index));
    };
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    var expandItems = items.filter(function(el) {
        return el.isExpandButton;
    });
    var filteredItems = items.filter(function(el) {
        return !el.isExpandButton;
    }).sort(function(a, b) {
        if (filters.keyword === a.keyName) {
            return -1;
        }
        if (filters.keyword !== b.keyName) {
            return 1;
        }
        return 0;
    });
    var itemsSize = filteredItems.length;
    var visibleItems = displayAll ? filteredItems : filteredItems.slice(0, limit).filter(function(el) {
        return !el.isExpandButton;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                sx: _objectSpread({}, hideBullets ? {
                    padding: 0,
                    margin: 0,
                    li: {
                        listStyleType: "none",
                        margin: hideBullets ? "4px 0" : "4px"
                    }
                } : {}, {
                    marginTop: mt,
                    marginBottom: mb
                }, sx),
                columns: columns,
                noPadding: !!imageKey || noSpacing,
                largeFont: largeFont,
                darkText: darkText,
                children: [
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        variant: "body1",
                        fontWeight: 600,
                        color: "text.black900",
                        mb: 1,
                        children: subtitle
                    }),
                    visibleItems.map(renderItem),
                    itemsSize > limit && !!open && filteredItems.slice(limit).map(renderItem),
                    !!expandItems.length && !open && expandItems.map(renderItem),
                    columns <= 1 && !expandItems.length && !displayAll && itemsSize > limit && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        style: {
                            listStyleType: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                            onClick: toggleOpen,
                            isWPA: isWPA,
                            noSpacing: !!imageKey || hideBullets,
                            children: open ? translate("show_less") : translate("show_more")
                        })
                    })
                ]
            }),
            columns > 1 && !expandItems.length && !displayAll && itemsSize > limit && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                onClick: toggleOpen,
                isWPA: isWPA,
                noSpacing: !!imageKey || hideBullets,
                children: open ? translate("show_less") : translate("show_more")
            })
        ]
    });
};
/* harmony default export */ var ExapndableList = (ExpandableList);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/DonutChart/index.esm.js
var DonutChart_index_esm = __webpack_require__(37727);
// EXTERNAL MODULE: ./components/RatingBar/hooks/useBuildTopStats.tsx
var useBuildTopStats = __webpack_require__(90302);
;// CONCATENATED MODULE: ./components/AreasOfExpertiseChart.tsx
function AreasOfExpertiseChart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var AreasOfExpertiseChart = function(param) {
    var _statistic = param.statistic, statistic = _statistic === void 0 ? [] : _statistic, title = param.title;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref = (0,useBuildTopStats/* default */.Z)(statistic), _stats = ref.stats, topStats = _stats.topStats, allItems = _stats.allItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        sx: function(theme) {
            return AreasOfExpertiseChart_defineProperty({
                gap: "94px",
                flexWrap: "nowrap"
            }, theme.breakpoints.down("sm"), {
                gap: "40px",
                flexDirection: "column"
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                item: true,
                sm: 7,
                xs: 12,
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        marginTop: "4px",
                        variant: "body2",
                        color: "text.black900",
                        children: translate("profile.based_on_peer_recommendations_and_reviews")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                        noSpacing: true,
                        largeFont: true,
                        largeSpacing: true,
                        limit: 3,
                        items: allItems,
                        valueKey: "name"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                item: true,
                sx: function(theme) {
                    return AreasOfExpertiseChart_defineProperty({
                        marginRight: "24px"
                    }, theme.breakpoints.down("sm"), {
                        display: "flex",
                        justifyContent: "center"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonutChart_index_esm/* default */.Z, {
                    width: 246,
                    height: 246,
                    thickness: 9,
                    data: topStats
                })
            })
        ]
    });
};
/* harmony default export */ var components_AreasOfExpertiseChart = (AreasOfExpertiseChart);

// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./utils/price.ts
var price = __webpack_require__(98171);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Accordion/Accordion.esm.js + 3 modules
var Accordion_esm = __webpack_require__(75552);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/AccordionSummary/AccordionSummary.esm.js + 1 modules
var AccordionSummary_esm = __webpack_require__(36756);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/ExpandMore.esm.js + 1 modules
var ExpandMore_esm = __webpack_require__(39591);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/AccordionDetails/AccordionDetails.esm.js + 1 modules
var AccordionDetails_esm = __webpack_require__(41602);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Divider/Divider.esm.js
var Divider_esm = __webpack_require__(15819);
;// CONCATENATED MODULE: ./components/profiles/practice/PracticeHealthChecks.tsx
function PracticeHealthChecks_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PracticeHealthChecks_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PracticeHealthChecks_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var PracticeHealthChecks_List = (0,styled_esm/* default */.Z)("ul")(function(param) {
    var theme = param.theme;
    return PracticeHealthChecks_objectSpread({}, theme.typography.body2, {
        paddingLeft: theme.spacing(2),
        color: theme.palette.grey[800],
        textTransform: "capitalize",
        margin: 0
    });
});
var groupByKeywordId = function(groupedHealthChecks) {
    return groupedHealthChecks.reduce(function(acc, healthCheck) {
        var key = healthCheck.keywordId;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(healthCheck);
        return acc;
    }, {});
};
var PracticeHealthChecks = function(param) {
    var healthChecks = param.healthChecks;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var groupedHealthChecks = react.useMemo(function() {
        return Object.values(groupByKeywordId(healthChecks));
    }, [
        healthChecks
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: groupedHealthChecks.map(function(healthCheckGroup, idx) {
            var currencyLabel = (0,price/* currencySymbol */.N)(healthCheckGroup[0].packageCurrency, language);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion_esm/* default */.Z, {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary_esm/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore_esm/* default */.Z, {}),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            variant: "body2",
                            children: healthCheckGroup[0].name[language]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails_esm/* default */.Z, {
                        children: healthCheckGroup.map(function(healthCheckItem, index) {
                            var ref, ref1, ref2, ref3;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        sx: {
                                            mt: "9px",
                                            mb: "9px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                md: 10,
                                                xs: 10,
                                                container: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.primary",
                                                    children: healthCheckItem.packageName[language]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                xs: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.primary",
                                                    children: "".concat(currencyLabel).concat(healthCheckItem.packagePrice[0], " - ").concat(currencyLabel).concat(healthCheckItem.packagePrice[1])
                                                })
                                            })
                                        ]
                                    }),
                                    ((ref = healthCheckItem.packageIncludedFeatures[language]) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                variant: "body2",
                                                color: "text.secondary",
                                                children: translate("included")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PracticeHealthChecks_List, {
                                                children: (ref1 = healthCheckItem.packageIncludedFeatures[language]) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, liIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: item
                                                    }, "li-".concat(item, "-").concat(liIndex));
                                                })
                                            })
                                        ]
                                    }) : null,
                                    ((ref2 = healthCheckItem.packageExcludedFeatures[language]) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                variant: "body2",
                                                color: "text.secondary",
                                                children: translate("excluded")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PracticeHealthChecks_List, {
                                                children: (ref3 = healthCheckItem.packageExcludedFeatures[language]) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, liIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: item
                                                    }, "li-".concat(item, "-").concat(liIndex));
                                                })
                                            })
                                        ]
                                    }) : null,
                                    healthCheckGroup.length - 1 > index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_esm/* default */.Z, {
                                        sx: {
                                            pt: 1
                                        }
                                    }) : null
                                ]
                            }, "box-".concat(index));
                        })
                    })
                ]
            }, "accordion-".concat(idx));
        })
    });
};
/* harmony default export */ var practice_PracticeHealthChecks = (PracticeHealthChecks);

// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(46311);
;// CONCATENATED MODULE: ./components/Icons/EducationIcon.tsx


var EducationIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.21429 16.8929C1.89224 16.8929 1.58338 16.7649 1.35566 16.5372C1.12793 16.3095 1 16.0006 1 15.6786V2.32143C1 1.99938 1.12793 1.69053 1.35566 1.4628C1.58338 1.23508 1.89224 1.10715 2.21429 1.10715H15.5714C15.8935 1.10715 16.2023 1.23508 16.4301 1.4628C16.6578 1.69053 16.7857 1.99938 16.7857 2.32143V15.6786C16.7857 16.0006 16.6578 16.3095 16.4301 16.5372C16.2023 16.7649 15.8935 16.8929 15.5714 16.8929",
                stroke: "#051851",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 4.75H16.7857",
                stroke: "#051851",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.22495 9.44928C8.27722 9.31465 8.36897 9.19896 8.48815 9.11738C8.60733 9.03581 8.74838 8.99216 8.89281 8.99216C9.03723 8.99216 9.17829 9.03581 9.29747 9.11738C9.41665 9.19896 9.50839 9.31465 9.56067 9.44928L10.3378 11.4286H12.4142C12.55 11.4389 12.6802 11.4871 12.7899 11.5677C12.8997 11.6483 12.9847 11.758 13.0353 11.8844C13.0858 12.0109 13.1 12.1489 13.076 12.283C13.0521 12.4171 12.9911 12.5417 12.9 12.6429L11.0664 14.2943L11.8435 15.8486C11.9139 15.985 11.9377 16.1407 11.9114 16.292C11.8851 16.4432 11.8101 16.5817 11.6978 16.6864C11.5863 16.7924 11.4445 16.8611 11.2922 16.8829C11.1399 16.9046 10.9846 16.8784 10.8478 16.8079L8.89281 15.7393L6.93781 16.8079C6.80106 16.8784 6.64574 16.9046 6.49342 16.8829C6.34109 16.8611 6.19933 16.7924 6.08781 16.6864C5.97552 16.5817 5.90052 16.4432 5.87421 16.292C5.84791 16.1407 5.87175 15.985 5.94209 15.8486L6.71924 14.2943L4.88567 12.6429C4.79449 12.5417 4.73349 12.4171 4.70957 12.283C4.68565 12.1489 4.69978 12.0109 4.75035 11.8844C4.80092 11.758 4.88591 11.6483 4.99568 11.5677C5.10545 11.4871 5.23561 11.4389 5.37138 11.4286H7.44781L8.22495 9.44928Z",
                stroke: "#051851",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_EducationIcon = (EducationIcon);

;// CONCATENATED MODULE: ./components/Icons/FacilitiesAtGlanceIcon.tsx


var FacilitiesAtGlanceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "15",
        viewBox: "0 0 18 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_10439_4322",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2.45508",
                    y: "0.295898",
                    width: "13.0909",
                    height: "5.93939",
                    rx: "1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.45508",
                y: "0.295898",
                width: "13.0909",
                height: "5.93939",
                rx: "1",
                stroke: "#051851",
                strokeWidth: "2.4",
                mask: "url(#path-1-inside-1_10439_4322)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.4 14.2957C0.4 14.6271 0.668629 14.8957 1 14.8957C1.33137 14.8957 1.6 14.6271 1.6 14.2957H0.4ZM1.13789 8.6167L0.620616 8.31267L1.13789 8.6167ZM2.76845 4.65837L0.620616 8.31267L1.65515 8.92072L3.80298 5.26643L2.76845 4.65837ZM0.4 9.12341V14.2957H1.6V9.12341H0.4ZM0.620616 8.31267C0.476165 8.55843 0.4 8.83833 0.4 9.12341H1.6C1.6 9.05214 1.61904 8.98216 1.65515 8.92072L0.620616 8.31267Z",
                fill: "#051851"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4006 14.2957C16.4006 14.6271 16.6692 14.8957 17.0006 14.8957C17.3319 14.8957 17.6006 14.6271 17.6006 14.2957H16.4006ZM16.8718 8.79187L16.3491 9.08633L16.8718 8.79187ZM14.1921 5.25686L16.3491 9.08633L17.3946 8.49741L15.2376 4.66794L14.1921 5.25686ZM16.4006 9.28264V14.2957H17.6006V9.28264H16.4006ZM16.3491 9.08633C16.3828 9.14625 16.4006 9.21386 16.4006 9.28264H17.6006C17.6006 9.00754 17.5296 8.73709 17.3946 8.49741L16.3491 9.08633Z",
                fill: "#051851"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.36328 5.4929V3.76563C5.36328 3.48948 5.58714 3.26562 5.86328 3.26562H8.99964M12.636 5.4929V3.76562C12.636 3.48948 12.4122 3.26562 12.136 3.26562H8.99964M8.99964 3.26562V5.4929",
                stroke: "#051851",
                strokeWidth: "1.2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 9.62939H17M1 13.1294H17",
                stroke: "#051851",
                strokeWidth: "1.2"
            })
        ]
    });
};
/* harmony default export */ var Icons_FacilitiesAtGlanceIcon = (FacilitiesAtGlanceIcon);

// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/profiles/specialist/OtherTopRated.tsx + 1 modules
var OtherTopRated = __webpack_require__(25954);
// EXTERNAL MODULE: ./components/profiles/Media/Posts/Card/index.tsx + 1 modules
var Card = __webpack_require__(2079);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var styles = __webpack_require__(8971);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
;// CONCATENATED MODULE: ./components/profiles/CollapsibleComponent/index.tsx



var ReadMore = function(param) {
    var text = param.text, maxLength = param.maxLength;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var toggleExpanded = function() {
        return setExpanded(!expanded);
    };
    var isTextOverflowing = text.length > maxLength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLSlot, {
                children: isTextOverflowing && !expanded ? "".concat(text.slice(0, maxLength), "...") : text
            }),
            isTextOverflowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                sx: {
                    cursor: "pointer",
                    textDecoration: "underline"
                },
                onClick: toggleExpanded,
                children: expanded ? "Read less" : "Read more"
            })
        ]
    });
};
/* harmony default export */ var CollapsibleComponent = (ReadMore);

;// CONCATENATED MODULE: ./components/profiles/About/index.tsx
function About_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function About_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            About_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
























var ImproveListingForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8297).then(__webpack_require__.bind(__webpack_require__, 98297));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98297)
            ];
        }
    }
});
var flexAlign = "flex-start";
var CustomTooltip = (0,styles_styled_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip_esm/* default */.Z, About_objectSpread({}, props, {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return {
        "& .MuiTooltip-tooltip": theme.custom.SpecialistPage.tooltip
    };
});
// todo: fix complexity
// eslint-disable-next-line complexity
function ProfileAbout(param1) {
    var about = param1.about, keywords = param1.keywords, registrationBodies = param1.registrationBodies, insurers = param1.insurers, languages = param1.languages, consultationFees = param1.consultationFees, statistic = param1.statistic, _isBasic = param1.isBasic, isBasic = _isBasic === void 0 ? false : _isBasic, _name = param1.name, name = _name === void 0 ? "" : _name, _isUnclaimed = param1.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, qualifications = param1.qualifications, _isClinic = param1.isClinic, isClinic = _isClinic === void 0 ? false : _isClinic, otherSpecialistsButtonText = param1.otherSpecialistsButtonText, otherSpecialistSearchUrl = param1.otherSpecialistSearchUrl, healthChecks = param1.healthChecks, nearBy = param1.nearBy, _isEntry = param1.isEntry, isEntry = _isEntry === void 0 ? false : _isEntry, publications = param1.publications, pinnedFacilities = param1.pinnedFacilities, _isImproveListingVisible = param1.isImproveListingVisible, isImproveListingVisible = _isImproveListingVisible === void 0 ? false : _isImproveListingVisible;
    var ref13, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref5.language, isRtl = ref5.isRtl;
    var ref6 = (0,react.useContext)(Profile/* ProfileContext */.J), practice = ref6.practice, specialist = ref6.specialist;
    var ref7 = (0,styles/* themedColor */.St)(), titleTextTransform = ref7.titleTextTransform, aboutSectionTitleColor = ref7.aboutSectionTitleColor, aboutSectionTitleFontWeight = ref7.aboutSectionTitleFontWeight;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var translate = (0,useTranslateMessage/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var ref8 = (0,useKeywordsMapper/* useKeywordsMapper */._)(keywords, isClinic), subSpecialties = ref8.subSpecialties, conditionAndTreatments = ref8.conditionAndTreatments, specialties = ref8.specialties;
    var visibilityComponents = (0,useVisibilityComponents/* useVisibilityComponents */.c)({
        practice: practice,
        specialist: specialist
    });
    var ref9 = (0,react.useState)(false), showMorePublications = ref9[0], setShowMorePublications = ref9[1];
    var ref10 = (0,react.useState)([]), conditionKeywords = ref10[0], setConditionKeywords = ref10[1];
    var ref11 = (0,react.useState)([]), procedureKeywords = ref11[0], setProcedureKeywords = ref11[1];
    var isUniversitySectionVisible = (0,react.useMemo)(function() {
        var ref, ref12;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.education) === null || ref === void 0 ? void 0 : (ref12 = ref.universities) === null || ref12 === void 0 ? void 0 : ref12.some(function(param) {
            var enabled = param.enabled;
            return enabled;
        }));
    }, [
        specialist === null || specialist === void 0 ? void 0 : (ref13 = specialist.education) === null || ref13 === void 0 ? void 0 : ref13.universities
    ]);
    var sortedUniversities = (0,react.useMemo)(function() {
        var ref, ref14;
        return specialist === null || specialist === void 0 ? void 0 : (ref = specialist.education) === null || ref === void 0 ? void 0 : (ref14 = ref.universities) === null || ref14 === void 0 ? void 0 : ref14.sort(function(a, b) {
            return a.sortOrder - b.sortOrder;
        });
    }, [
        specialist === null || specialist === void 0 ? void 0 : (ref1 = specialist.education) === null || ref1 === void 0 ? void 0 : ref1.universities
    ]);
    (0,react.useEffect)(function() {
        var cks = [];
        var pks = [];
        conditionAndTreatments.sort(function(a, b) {
            return a.sortOrder - b.sortOrder;
        }).forEach(function(item) {
            if (item.keywordType === "condition") {
                return cks.push(item);
            }
            if (item.keywordType === "procedure") {
                return pks.push(item);
            }
        });
        setConditionKeywords(cks);
        setProcedureKeywords(pks);
    }, [
        conditionAndTreatments
    ]);
    var handleShowMorePublications = function() {
        return setShowMorePublications(true);
    };
    var pinnedFacilitiesItemsLength = (0,react.useMemo)(function() {
        return (pinnedFacilities === null || pinnedFacilities === void 0 ? void 0 : pinnedFacilities.length) || 0;
    }, [
        pinnedFacilities === null || pinnedFacilities === void 0 ? void 0 : pinnedFacilities.length
    ]);
    var SectionHeader = function(param) {
        var children = param.children, _fontWeight = param.fontWeight, fontWeight = _fontWeight === void 0 ? "600" : _fontWeight, _gutterBottom = param.gutterBottom, gutterBottom = _gutterBottom === void 0 ? false : _gutterBottom, icon = param.icon, label = param.label, ml = param.ml, mr = param.mr, mb = param.mb, sx = param.sx, onClickChip = param.onClickChip;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledSectionHeaderWrapper */.xD, {
            container: true,
            sx: About_objectSpread({
                marginLeft: ml,
                marginRight: mr,
                marginBottom: mb
            }, gutterBottom ? {
                marginBottom: "0.35rem"
            } : {}, sx),
            children: [
                icon,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    textTransform: titleTextTransform,
                    color: aboutSectionTitleColor,
                    variant: "subtitle1",
                    component: "h3",
                    fontWeight: fontWeight,
                    sx: theme.custom.SpecialistPage.about.subHeader,
                    children: children
                }),
                label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                    onClick: onClickChip,
                    sx: {
                        fontSize: "10.53px",
                        fontWeight: "500",
                        lineHeight: "15.795px",
                        color: "text.dark",
                        padding: "1px 8px",
                        span: {
                            padding: 0
                        }
                    },
                    label: label,
                    variant: "blue"
                })
            ]
        });
    };
    var showAbout = (0,react.useMemo)(function() {
        return (about === null || about === void 0 ? void 0 : about.length) > 10;
    }, [
        about === null || about === void 0 ? void 0 : about.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                id: "about",
                sx: {
                    width: 1
                },
                children: [
                    showAbout && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                sx: (ref2 = theme.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.SpecialistPage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.about) === null || ref4 === void 0 ? void 0 : ref4.title,
                                variant: "h2",
                                component: "h2",
                                color: aboutSectionTitleColor,
                                children: translate("about.title", {
                                    name: name
                                })
                            }),
                            isWPA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleComponent, {
                                text: about,
                                maxLength: 500
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLSlot, {
                                children: about
                            })
                        ]
                    }),
                    isImproveListingVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImproveListingForm, {}),
                    !!pinnedFacilitiesItemsLength && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FacilitiesAtGlanceIcon, {}),
                                        sx: {
                                            alignItems: "center !important"
                                        },
                                        children: translate("facilities_at_glance")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        color: "text.black900",
                                        mt: "4px",
                                        children: translate("facilities-at-glance.subtitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        display: "flex",
                                        columnGap: "24px",
                                        rowGap: {
                                            xs: "24px",
                                            sm: "8px"
                                        },
                                        mt: "18px",
                                        flexDirection: {
                                            xs: "column",
                                            sm: "row"
                                        },
                                        flexWrap: "wrap",
                                        alignItems: {
                                            xs: "start",
                                            sm: "center"
                                        },
                                        children: [
                                            pinnedFacilities === null || pinnedFacilities === void 0 ? void 0 : pinnedFacilities.map(function(param, index) {
                                                var Facility = param.Facility, _value = param.value, value = _value === void 0 ? {} : _value;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                                                            sx: {
                                                                width: "24px",
                                                                height: "24px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                                                href: "#tick-icon"
                                                            })
                                                        }),
                                                        (value === null || value === void 0 ? void 0 : value.count) ? "".concat(value.count, " ") : "",
                                                        Facility.name[language],
                                                        "paid" in value && " (".concat(value.paid ? translate("paid") : translate("free"), ")")
                                                    ]
                                                }, "pinned-facility-".concat(Facility.name, "-").concat(index));
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#services-facilities",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        fontWeight: 600,
                                                        color: "#4C5870",
                                                        textDecoration: "underline"
                                                    },
                                                    children: [
                                                        translate("view_more"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                                                            style: {
                                                                width: "16px",
                                                                height: "16px"
                                                            },
                                                            color: "#11245A"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (isEntry || isUnclaimed) && !!(nearBy === null || nearBy === void 0 ? void 0 : nearBy.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        item: true,
                        sx: {
                            width: 1
                        },
                        children: [
                            showAbout || !!pinnedFacilitiesItemsLength || isImproveListingVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherTopRated/* default */.Z, {
                                specialists: nearBy,
                                headerText: translate("other.specialsts.headerText"),
                                buttonText: otherSpecialistsButtonText,
                                isRtl: isRtl,
                                shortButtonText: translate("other.specialsts.shortButtonText"),
                                buttonLink: otherSpecialistSearchUrl
                            })
                        ]
                    }),
                    !!(statistic === null || statistic === void 0 ? void 0 : statistic.length) && !isUnclaimed && !isBasic && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasOfExpertiseChart, {
                                    statistic: statistic,
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                                    fontWeight: aboutSectionTitleFontWeight,
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShiledMan_index_esm/* ShieldManIcon */.z, {
                                                        sx: {
                                                            width: "16px",
                                                            stroke: "#051851"
                                                        }
                                                    }),
                                                    children: translate("profile.areas_of_expertise")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTooltip, {
                                                    enterTouchDelay: 0,
                                                    leaveTouchDelay: 4000,
                                                    title: translate(isClinic ? "areas_of_expertise_tooltip" : "reviews.total_recommendations_hint"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined_index_esm/* default */.Z, {
                                                            sx: {
                                                                fontSize: 16,
                                                                ml: 1,
                                                                color: "#112971"
                                                            }
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    (!!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) || !!(specialties === null || specialties === void 0 ? void 0 : specialties.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                id: "specialties",
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledSpecialtiesWrapper */.T0, {
                                gap: "13px",
                                flexWrap: isMobile ? "wrap" : "nowrap",
                                container: true,
                                alignItems: "flex-start",
                                children: [
                                    isClinic && !!(specialties === null || specialties === void 0 ? void 0 : specialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        sx: {
                                            alignItems: flexAlign,
                                            maxWidth: (specialties === null || specialties === void 0 ? void 0 : specialties.length) ? "50%" : "100%"
                                        },
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                                mr: "116px",
                                                mb: isMobile ? undefined : "16px",
                                                fontWeight: aboutSectionTitleFontWeight,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedalWithStarIcon, {
                                                    sx: {
                                                        width: "12px",
                                                        fill: "none"
                                                    }
                                                }),
                                                children: translate("profile.specialties")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                                itemGutterBottom: !isMobile,
                                                hideBullets: !isMobile,
                                                items: specialties,
                                                valueKey: "name",
                                                locale: language
                                            })
                                        ]
                                    }),
                                    !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        sx: About_objectSpread({
                                            alignItems: flexAlign,
                                            // eslint-disable-next-line no-nested-ternary
                                            maxWidth: (specialties === null || specialties === void 0 ? void 0 : specialties.length) ? isClinic ? "50%" : "100%" : "100%"
                                        }, isMobile || isClinic && !!(specialties === null || specialties === void 0 ? void 0 : specialties.length) ? {} : {
                                            display: "grid",
                                            gap: "13px",
                                            gridTemplateColumns: "1fr 1fr"
                                        }),
                                        /* eslint-disable-next-line no-nested-ternary */ flexDirection: (specialties === null || specialties === void 0 ? void 0 : specialties.length) ? isClinic ? "column" : "row" : "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                                mr: "116px",
                                                mb: isMobile ? undefined : "16px",
                                                fontWeight: aboutSectionTitleFontWeight,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedalIcon, {
                                                    sx: {
                                                        width: "12px",
                                                        fill: "none"
                                                    }
                                                }),
                                                children: translate("profile.subspecialties".concat(locale === "au" ? "-au" : ""))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                                itemGutterBottom: !isMobile,
                                                hideBullets: locale !== global/* TENANTS.WPA */.rk.WPA,
                                                items: subSpecialties,
                                                valueKey: "name",
                                                locale: language
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !!conditionAndTreatments.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        fontWeight: aboutSectionTitleFontWeight,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeartPulseProfileIcon, {
                                            sx: {
                                                width: "18px",
                                                fill: "none"
                                            }
                                        }),
                                        children: translate("profile.all_conditions_and_treatments")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        mt: "16px",
                                        display: "flex",
                                        flexDirection: isMobile ? "column" : "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                                sx: {
                                                    flex: 1
                                                },
                                                items: conditionKeywords,
                                                valueKey: "name",
                                                locale: language,
                                                hideBullets: locale !== global/* TENANTS.WPA */.rk.WPA,
                                                itemGutterBottom: !isMobile,
                                                limit: isMobile ? 5 : 10,
                                                subtitle: isWPA ? translate("profile.conditions") : undefined
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                                sx: {
                                                    flex: 1
                                                },
                                                items: procedureKeywords,
                                                valueKey: "name",
                                                locale: language,
                                                hideBullets: locale !== global/* TENANTS.WPA */.rk.WPA,
                                                itemGutterBottom: !isMobile,
                                                limit: isMobile ? 5 : 10,
                                                subtitle: isWPA ? translate("profile.treatments") : undefined
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !!(registrationBodies === null || registrationBodies === void 0 ? void 0 : registrationBodies.length) && !isUnclaimed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                alignItems: "flex-start",
                                sx: About_objectSpread({}, isMobile ? {} : {
                                    display: "grid",
                                    gap: "15px",
                                    gridTemplateColumns: "1fr 1fr"
                                }),
                                mt: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotepadIcon, {
                                            sx: {
                                                width: "13px",
                                                fill: "none"
                                            }
                                        }),
                                        mr: "106px",
                                        mb: "16px",
                                        fontWeight: aboutSectionTitleFontWeight,
                                        children: translate("profile.registered_with")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                        children: registrationBodies.map(function(rb) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                sx: {
                                                    mb: {
                                                        md: 2,
                                                        xs: 1.5
                                                    },
                                                    contentVisibility: "auto",
                                                    containIntrinsicHeight: "500px"
                                                },
                                                children: [
                                                    !!rb.iconUri.trim() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                        sx: {
                                                            width: 48,
                                                            height: 48
                                                        },
                                                        item: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar_esm/* default */.Z, {
                                                            src: rb.iconUri
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        item: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                                variant: "body1",
                                                                fontWeight: 500,
                                                                color: "text.black900",
                                                                children: rb.name
                                                            }),
                                                            rb.registrationNumber.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                                                                variant: "body2",
                                                                color: "text.black900",
                                                                children: [
                                                                    "No. ",
                                                                    rb.registrationNumber
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, "registration-body-".concat(rb.id));
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isUniversitySectionVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        fontWeight: aboutSectionTitleFontWeight,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_EducationIcon, {}),
                                        children: translate("education")
                                    }),
                                    sortedUniversities === null || sortedUniversities === void 0 ? void 0 : sortedUniversities.map(function(param) {
                                        var externalId = param.externalId, endDate = param.endDate, fieldOfStudy = param.fieldOfStudy, institution = param.institution, enabled = param.enabled;
                                        if (!enabled) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                            mt: "16px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    style: {
                                                        fontWeight: 500,
                                                        color: "#051851"
                                                    },
                                                    children: institution
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    style: {
                                                        color: "#4C5870"
                                                    },
                                                    children: fieldOfStudy
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                                                    style: {
                                                        color: "#4C5870"
                                                    },
                                                    children: [
                                                        translate("graduated"),
                                                        " ",
                                                        endDate === null || endDate === void 0 ? void 0 : endDate.year
                                                    ]
                                                })
                                            ]
                                        }, externalId);
                                    })
                                ]
                            })
                        ]
                    }),
                    qualifications && qualifications.length > 10 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarDocumentIcon, {
                                            fontWeight: aboutSectionTitleFontWeight,
                                            sx: {
                                                width: "16px",
                                                fill: "none"
                                            }
                                        }),
                                        gutterBottom: true,
                                        children: translate("profile.qualifications")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                        sx: {
                                            span: {
                                                p: {
                                                    strong: {
                                                        fontSize: "16px"
                                                    },
                                                    fontSize: "14px"
                                                }
                                            },
                                            ul: theme.custom.QualificationsSection
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLSlot, {
                                            children: qualifications
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                flexDirection: "column",
                width: "100%",
                children: [
                    publications && !!publications.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationsIcon, {
                                            sx: {
                                                width: "16px",
                                                fill: "none"
                                            }
                                        }),
                                        fontWeight: "600",
                                        onClickChip: handleShowMorePublications,
                                        label: publications.length > 4 ? "+".concat(publications.length) : undefined,
                                        children: translate("profile.about.publications")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        color: "text.black900",
                                        mt: "16px",
                                        children: translate("profile.about.readPublicationsBySpecialist")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                        mt: "32px",
                                        container: true,
                                        flexDirection: "column",
                                        children: publications.slice(0, showMorePublications ? publications.length : 4).map(function(publication, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* PublicationWrapper */.Dg, {
                                                    href: publication.link,
                                                    rel: "noopener ".concat(Card/* NOFOLLOW_EXCEPTION.some */.E.some(function(exceptionPart) {
                                                        return publication.link.includes(exceptionPart);
                                                    }) ? "" : " nofollow"),
                                                    isFirst: index === 0,
                                                    isLast: index === publications.length - 1,
                                                    target: "_blank",
                                                    sx: {
                                                        textDecoration: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        direction: "column",
                                                        container: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                                color: "text.secondary",
                                                                variant: "body2",
                                                                sx: {
                                                                    fontSize: "11px",
                                                                    lineHeight: "14px",
                                                                    textTransform: "uppercase"
                                                                },
                                                                children: dayjs_min_default()(publication.date || publication.createdAt).format("DD / MM / YYYY")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                                color: "text.darkNavy",
                                                                fontWeight: 500,
                                                                my: "8px",
                                                                children: publication.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                                color: "text.secondary",
                                                                variant: "body2",
                                                                sx: {
                                                                    fontSize: "13px",
                                                                    lineHeight: "20px"
                                                                },
                                                                children: translate("profile.about.publishedIn", {
                                                                    site: publication.name || ""
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }, "publication-".concat(index))
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !showMorePublications && (publications === null || publications === void 0 ? void 0 : publications.length) > 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                        sx: {
                            fontFamily: "Poppins",
                            padding: 0,
                            marginTop: "24px"
                        },
                        onClick: handleShowMorePublications,
                        children: translate("profile.about.seeMorePublications")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                id: "fees",
                children: [
                    (!!(languages === null || languages === void 0 ? void 0 : languages.length) || visibilityComponents.fees) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    justifyContent: "space-between",
                                    spacing: 2,
                                    children: [
                                        !!(languages === null || languages === void 0 ? void 0 : languages.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                            item: true,
                                            md: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                                    fontWeight: aboutSectionTitleFontWeight,
                                                    children: translate("profile.languages_spoken")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                                    items: languages,
                                                    valueKey: "name",
                                                    hideBullets: !isWPA
                                                })
                                            ]
                                        }),
                                        visibilityComponents.fees && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                            item: true,
                                            md: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                                    children: translate("profile.consultation_fees")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* List */.aV, {
                                                    children: [
                                                        !!(consultationFees === null || consultationFees === void 0 ? void 0 : consultationFees.new) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            style: {
                                                                listStyleType: "none",
                                                                padding: 0
                                                            },
                                                            children: translate("profile.new_appointment_price", {
                                                                price: "".concat((0,price/* currencySymbol */.N)(consultationFees.currency || "", language)).concat(consultationFees.new)
                                                            })
                                                        }),
                                                        !!(consultationFees === null || consultationFees === void 0 ? void 0 : consultationFees.followUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            style: {
                                                                listStyleType: "none",
                                                                padding: 0
                                                            },
                                                            children: translate("profile.follow_up_price", {
                                                                price: "".concat((0,price/* currencySymbol */.N)(consultationFees.currency || "", language)).concat(consultationFees.followUp)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    visibilityComponents.insurers && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                        gutterBottom: true,
                                        children: translate("profile.insurers")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExapndableList, {
                                        items: insurers,
                                        valueKey: "name",
                                        displayAll: !isMobile,
                                        columns: 3,
                                        hideBullets: true,
                                        noSpacing: true,
                                        largeSpacing: true,
                                        darkText: true
                                    })
                                ]
                            })
                        ]
                    }),
                    !!(healthChecks === null || healthChecks === void 0 ? void 0 : healthChecks.length) && locale !== global/* TENANTS.WPA */.rk.WPA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledDivider */.IW, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                alignItems: "center",
                                sx: {
                                    mt: 4,
                                    mb: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        textTransform: "uppercase",
                                        variant: "body2",
                                        component: "h3",
                                        gutterBottom: true,
                                        color: "text.darkNavy",
                                        children: translate("treatments_and_fees")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(practice_PracticeHealthChecks, {
                                        healthChecks: healthChecks
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var About = (ProfileAbout);


/***/ }),

/***/ 62054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4595);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75320);
/* harmony import */ var _Icons_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2730);




var FaqItem = function(param) {
    var title = param.title, mainDescription = param.mainDescription, additionalDescription = param.additionalDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            mt: 4
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                container: true,
                alignItems: "center",
                sx: {
                    mb: 1
                },
                wrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        item: true,
                        display: "flex",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            reflectIfRtl: true,
                            sx: {
                                width: "16px",
                                height: "16px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "body2",
                            textTransform: "uppercase",
                            gutterBottom: true,
                            color: "text.darkNavy",
                            sx: {
                                ml: 1.25,
                                mb: 0
                            },
                            children: title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: "text.black900",
                variant: "body1",
                whiteSpace: "break-spaces",
                children: mainDescription
            }),
            additionalDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: "text.black900",
                variant: "body1",
                whiteSpace: "break-spaces",
                children: additionalDescription
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqItem);


/***/ }),

/***/ 2079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ NOFOLLOW_EXCEPTION; },
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Image/index.esm.js
var index_esm = __webpack_require__(80088);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ../../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(87530);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
;// CONCATENATED MODULE: ./components/profiles/Media/Posts/Card/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var PostCardWrapper = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        borderRadius: "8px",
        textAlign: "left",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        padding: "16px",
        width: "100%",
        height: "100%",
        textDecoration: "none",
        border: "1.5px solid transparent",
        contentVisibility: "auto",
        containIntrinsicHeight: "600px",
        "&:hover": {
            backgroundColor: theme.palette.system.white400,
            boxShadow: "0px 54px 82px rgba(2, 3, 3, 0.03), 0px 22px 98px rgba(2, 3, 3, 0.02), 0px 23px 28px rgba(2, 3, 3, 0.04)",
            border: "1.5px solid #EAEEFC"
        }
    };
});
var ContentWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "horizontal";
    }
})(function(param) {
    var theme = param.theme, horizontal = param.horizontal;
    return _objectSpread({
        display: "grid",
        height: "100%",
        gap: "15px"
    }, horizontal ? _defineProperty({}, theme.breakpoints.up("sm"), {
        gridTemplateColumns: "1fr 1fr",
        gap: "24px"
    }) : {});
});
var PostCardContent = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP, {
    shouldForwardProp: function(prop) {
        return prop !== "horizontal";
    }
})(function(param) {
    var theme = param.theme, horizontal = param.horizontal;
    return _objectSpread({
        h4: {
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "22.4px",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            overflow: "hidden",
            WebkitBoxOrient: "vertical"
        },
        p: {
            display: "-webkit-box",
            WebkitLineClamp: "3",
            wordBreak: "break-word",
            overflow: "hidden",
            WebkitBoxOrient: "vertical"
        }
    }, horizontal ? _defineProperty({}, theme.breakpoints.up("sm"), {
        h4: _objectSpread({}, theme.typography.h3, {
            fontWeight: 700,
            lineHeight: "32.04px",
            WebkitLineClamp: "3"
        }),
        p: {
            fontSize: "16px",
            lineHeight: "22.4px",
            WebkitLineClamp: "6"
        }
    }) : {});
});
var ImageWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "horizontal";
    }
})(function(param) {
    var theme = param.theme, horizontal = param.horizontal;
    return _objectSpread({
        height: "170px",
        position: "relative",
        img: {
            borderRadius: "4px",
            height: "170px",
            width: "100%",
            objectFit: "cover"
        }
    }, horizontal ? _defineProperty({}, theme.breakpoints.up("sm"), {
        height: "380px",
        img: {
            borderRadius: 0,
            height: "380px"
        }
    }) : {});
});

;// CONCATENATED MODULE: ./components/profiles/Media/Posts/Card/index.tsx
function Card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var NOFOLLOW_EXCEPTION = [
    "doctify.com",
    "youtube.com/@doctify"
];
function getWebsiteName(url) {
    try {
        var parsedUrl = new URL(url);
        var hostname = parsedUrl.hostname;
        return hostname.replace(/^www\./, "");
    } catch (e) {
        return "Doctify";
    }
}
var PostCard = function(param) {
    var title = param.title, description = param.description, link = param.link, image = param.image, date = param.date, createdAt = param.createdAt, keywords = param.keywords, duration = param.duration, _isLink = param.isLink, isLink = _isLink === void 0 ? true : _isLink, _horizontal = param.horizontal, horizontal = _horizontal === void 0 ? false : _horizontal, onClick = param.onClick;
    var additionalRel = NOFOLLOW_EXCEPTION.some(function(exceptionPart) {
        return link.includes(exceptionPart);
    }) ? "" : " nofollow";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCardWrapper, Card_objectSpread({
        target: "_blank"
    }, isLink ? {
        href: link,
        rel: "noopener".concat(additionalRel || "")
    } : {
        component: "button"
    }, {
        onClick: onClick,
        className: horizontal ? "first-article" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
            horizontal: horizontal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    horizontal: horizontal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                        lazy: true,
                        src: image || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                        errorSrc: global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                        alt: title || ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    alignContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostCardContent, {
                                    container: true,
                                    flexDirection: "column",
                                    gap: "7px",
                                    horizontal: horizontal,
                                    sx: {
                                        textDecoration: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                            item: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                color: "common.white",
                                                sx: {
                                                    wordBreak: "break-all"
                                                },
                                                component: "h4",
                                                fontSize: "16px",
                                                children: title
                                            })
                                        }),
                                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                            item: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                color: "common.white",
                                                children: description
                                            })
                                        })
                                    ]
                                }),
                                !!keywords && !!keywords.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    alignItems: "center",
                                    mt: "26px",
                                    gap: "8px",
                                    children: keywords.map(function(keyword, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                            sx: {
                                                contentVisibility: "auto",
                                                containIntrinsicHeight: "600px"
                                            },
                                            label: keyword.title,
                                            variant: "blue300"
                                        }, "video-card-keyword-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                            mt: "24px",
                            container: true,
                            wrap: "nowrap",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                    container: true,
                                    flexDirection: "row",
                                    wrap: "nowrap",
                                    gap: "10px",
                                    children: [
                                        duration && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            variant: "body2",
                                            lineHeight: "20px",
                                            color: "common.white",
                                            children: duration
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            variant: "body2",
                                            lineHeight: "20px",
                                            color: "common.white",
                                            children: dayjs_min_default()(date || createdAt).format("DD MMMM YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "body2",
                                        lineHeight: "20px",
                                        color: "common.white",
                                        textTransform: "capitalize",
                                        children: getWebsiteName(link) || "doctify"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Card = (PostCard);


/***/ }),

/***/ 37850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Media; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
;// CONCATENATED MODULE: ./components/profiles/Media/Header/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var MediaCenterHeader = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        padding: "140px 0 85px 0",
        position: "relative",
        zIndex: 1
    }, theme.breakpoints.down("sm"), {
        padding: "70px 0 55px 0"
    });
});
var MediaContentWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "1014px",
    paddingLeft: "16px",
    paddingRight: "16px"
});
var AvatarWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    position: "relative",
    "&::before": {
        position: "absolute",
        top: -30,
        left: -30,
        width: 48,
        height: 50,
        zIndex: 1,
        content: "url(\"data:image/svg+xml,%3Csvg width='48' height='50' viewBox='0 0 48 50' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M45.8066 15.8582L45.8066 1.99995' stroke='%23406AE3' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M20.918 24.9226L9.15889 13.1635' stroke='%23406AE3' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M16.3584 47.7322L2.5002 47.7322' stroke='%23406AE3' stroke-width='4' stroke-linecap='round'/%3E%3C/svg%3E%0A\")" // eslint-disable-line
    }
});
var GetToKnowWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP, {
    shouldForwardProp: function(prop) {
        return prop !== "nameLength";
    }
})(function(param) {
    var theme = param.theme, _nameLength = param.nameLength, nameLength = _nameLength === void 0 ? 0 : _nameLength;
    return _defineProperty({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        color: theme.palette.common.white,
        "& > span:first-of-type": {
            fontSize: "25px",
            lineHeight: "27.5px"
        },
        "& > span:last-of-type": {
            fontSize: "45px",
            fontWeight: 600,
            lineHeight: "49.5px"
        }
    }, theme.breakpoints.down("sm"), {
        justifyContent: "start",
        "& > span:first-of-type": {
            fontSize: "16px",
            lineHeight: "22.4px"
        },
        "& > span:last-of-type": {
            fontSize: nameLength > 28 ? "16px" : "24px",
            lineHeight: nameLength > 28 ? "22.03px" : "31.2px"
        }
    });
});
var NavigationButtonsWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    display: "flex",
    gap: "13px",
    "@media (min-width: 420px)": {
        alignItems: "end",
        ".MuiChip-root": {
            padding: 0,
            borderRadius: "45px",
            height: "auto",
            span: {
                padding: "8px 24px"
            }
        }
    }
});
var MediaHeader = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("sm"), {
        gap: "37px",
        flexDirection: "column"
    });
});
var HeaderSpecialistInfo = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("lg"), {
        paddingLeft: 32
    });
});

// EXTERNAL MODULE: ./components/profiles/Intro/variants/default/index.tsx + 1 modules
var variants_default = __webpack_require__(32930);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(80292);
// EXTERNAL MODULE: ./utils/getImageWithWWW.ts
var getImageWithWWW = __webpack_require__(62400);
;// CONCATENATED MODULE: ./components/profiles/Media/Header/index.tsx








var ProfileMediaHeader = function(param) {
    var _isBasic = param.isBasic, isBasic = _isBasic === void 0 ? false : _isBasic, _isUnclaimed = param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, image = param.image, name = param.name, socialsAvailable = param.socialsAvailable, videosAvailable = param.videosAvailable, articlesAvailable = param.articlesAvailable, websiteLinkAvailable = param.websiteLinkAvailable;
    var initials = (0,variants_default/* getInitialsFromFullName */.u)(name);
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var pathname = "/".concat(router.locale).concat(router.pathname.replace("[slug]", String(router.query.slug)));
    var imageWithWWW = (0,getImageWithWWW/* default */.Z)(image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCenterHeader, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContentWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaHeader, {
                container: true,
                gap: "15px",
                wrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSpecialistInfo, {
                        container: true,
                        wrap: "nowrap",
                        gap: "15px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWrapper, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    width: 84,
                                    height: 84,
                                    src: !isBasic && !isUnclaimed ? imageWithWWW : undefined,
                                    sx: {
                                        backgroundColor: "blue.200"
                                    },
                                    alt: "".concat(name, " logo"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "h2",
                                        children: initials
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GetToKnowWrapper, {
                                component: "h2",
                                nameLength: name.length,
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        component: "span",
                                        className: "media-centre-title",
                                        children: translate("media_center.title") + " "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        sx: {
                                            wordBreak: name.includes(" ") ? "normal" : "break-all"
                                        },
                                        component: "span",
                                        className: "media-centre-profile-name",
                                        children: name
                                    })
                                ]
                            })
                        ]
                    }),
                    ([
                        videosAvailable,
                        articlesAvailable,
                        socialsAvailable
                    ].filter(function(x) {
                        return x;
                    }).length > 1 || !websiteLinkAvailable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationButtonsWrapper, {
                        item: true,
                        children: [
                            videosAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(pathname, "#videos"),
                                style: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                    variant: "blue800",
                                    label: translate("media_center.videos"),
                                    clickable: true
                                })
                            }),
                            articlesAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(pathname, "#articles"),
                                style: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                    variant: "aqua800",
                                    label: translate("media_center.articles"),
                                    sx: theme.custom.SpecialistPage.profileMediaHeaderChips,
                                    clickable: true
                                })
                            }),
                            socialsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(pathname, "#socials"),
                                style: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                    variant: "coralPrimary",
                                    label: translate("media_center.socials"),
                                    sx: theme.custom.SpecialistPage.profileMediaHeaderChips,
                                    clickable: true
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Header = (ProfileMediaHeader);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Image/index.esm.js
var index_esm = __webpack_require__(80088);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
;// CONCATENATED MODULE: ./components/profiles/Media/Posts/styles.ts
function styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var ProfilePostsWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        "&.videos": {
            backgroundColor: theme.palette.primary.dark
        },
        "&.articles": {
            position: "relative",
            backgroundColor: theme.palette.blue[900],
            paddingTop: "100px",
            "&:before": {
                content: '""',
                position: "absolute",
                top: "-200px",
                width: "200px",
                height: "200px",
                zIndex: 0,
                borderBottomLeftRadius: "100px",
                boxShadow: "0 100px 0 0 ".concat(theme.palette.blue[900])
            },
            "&:after": {
                content: '""',
                position: "absolute",
                right: 0,
                top: "0",
                zIndex: 0,
                width: "200px",
                height: "200px",
                borderTopRightRadius: "100px",
                boxShadow: "0 -100px 0 0 ".concat(theme.palette.primary.dark)
            }
        }
    };
});
var PostsWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        marginBottom: "100px",
        gap: "10px",
        ".introduction-video": {
            gridColumn: "span 2"
        },
        ".first-article": {
            gridColumn: "span 3"
        }
    }, styles_defineProperty(_obj, theme.breakpoints.down("md"), {
        gridTemplateColumns: "1fr 1fr",
        justifyContent: "center",
        ".first-article": {
            gridColumn: "span 2"
        }
    }), styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        ".introduction-video": {
            gridColumn: "1"
        },
        ".first-article": {
            gridColumn: "1"
        },
        gridTemplateColumns: "1fr"
    }), _obj;
});
var PostsTitle = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return styles_defineProperty({
        fontSize: "35px",
        lineHeight: "45.5px",
        fontWeight: 600
    }, theme.breakpoints.down("sm"), {
        fontSize: "24px",
        lineHeight: "31.2px"
    });
});
var SortByDateButton = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return styles_defineProperty({
        padding: 0,
        p: {
            fontSize: "14px",
            lineHeight: "19.6px"
        }
    }, theme.breakpoints.down("sm"), {
        marginTop: "25px",
        p: _objectSpread({}, theme.typography.body2, {
            lineHeight: "20px"
        })
    });
});

// EXTERNAL MODULE: ./components/profiles/Media/Posts/Card/index.tsx + 1 modules
var Card = __webpack_require__(2079);
// EXTERNAL MODULE: ../../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(87530);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/profiles/Media/Posts/IntroductionVideo/styles.ts

var IntroductionVideoWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        position: "relative",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        height: "411px",
        overflow: "hidden",
        border: "1.5px solid transparent",
        span: {
            height: "100% !important",
            img: {
                objectFit: "cover"
            }
        },
        "&:hover": {
            backgroundColor: theme.palette.system.white400,
            boxShadow: "0px 54px 82px rgba(2, 3, 3, 0.03), 0px 22px 98px rgba(2, 3, 3, 0.02), 0px 23px 28px rgba(2, 3, 3, 0.04)",
            border: "1.5px solid #EAEEFC"
        }
    };
});
var ContentWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    flexWrap: "nowrap",
    padding: "19px 16px",
    paddingTop: "20%",
    justifyContent: "space-between",
    gap: "50px",
    background: "linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(13, 12, 14, 0.52) 76.56%)",
    "@media (max-width: 681px)": {
        flexWrap: "wrap",
        gap: "10px"
    }
});

// EXTERNAL MODULE: ../../../node_modules/next/image.js
var next_image = __webpack_require__(43875);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageLoaders.ts
var imageLoaders = __webpack_require__(32013);
;// CONCATENATED MODULE: ./components/profiles/Media/Posts/IntroductionVideo/index.tsx








var IntroductionVideo = function(param) {
    var image = param.image, description = param.description, title = param.title, date = param.date, duration = param.duration, createdAt = param.createdAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroductionVideoWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: image || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                layout: "fill",
                style: {
                    position: "absolute",
                    objectFit: "cover",
                    zIndex: 0
                },
                loading: "lazy",
                alt: title || "",
                loader: imageLoaders/* doctifyCDNLoader */.Ux
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                position: "absolute",
                zIndex: 1,
                justifyContent: "space-between",
                flexDirection: "column",
                wrap: "nowrap",
                top: 0,
                height: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                        item: true,
                        padding: "19px 16px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        container: true,
                        color: "common.white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                gap: "8px",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "h4",
                                        fontWeight: 900,
                                        fontSize: "27.03px",
                                        lineHeight: "35.14px",
                                        sx: {
                                            display: "-webkit-box",
                                            WebkitLineClamp: "3",
                                            overflow: "hidden",
                                            WebkitBoxOrient: "vertical"
                                        },
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        sx: {
                                            display: "-webkit-box",
                                            WebkitLineClamp: "2",
                                            overflow: "hidden",
                                            WebkitBoxOrient: "vertical"
                                        },
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                maxWidth: "max-content",
                                alignItems: "end",
                                gap: "10px",
                                children: [
                                    duration && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "body2",
                                        lineHeight: "20px",
                                        children: duration
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "body2",
                                        lineHeight: "20px",
                                        children: dayjs_min_default()(date || createdAt).format("DD MMMM YYYY")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Posts_IntroductionVideo = (IntroductionVideo);

;// CONCATENATED MODULE: ./components/profiles/Media/Posts/Card/skeleton.tsx


var CardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        sx: {
            contentVisibility: "auto",
            containIntrinsicHeight: "600px"
        },
        bgcolor: "blue.700",
        p: "23px 20px",
        borderRadius: "4px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                bgcolor: "blue.300",
                height: "120px",
                width: "100%",
                borderRadius: "4px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                mt: "16px",
                bgcolor: "blue.300",
                height: "15px",
                width: "100%",
                borderRadius: "4px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                mt: "8px",
                bgcolor: "blue.300",
                height: "15px",
                width: "90%",
                borderRadius: "4px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                mt: "16px",
                container: true,
                gap: "9px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        bgcolor: "blue.500",
                        height: "21px",
                        width: "84px",
                        borderRadius: "20px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        bgcolor: "blue.500",
                        height: "21px",
                        width: "84px",
                        borderRadius: "20px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                mt: "28px",
                container: true,
                wrap: "nowrap",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                bgcolor: "blue.300",
                                height: "10px",
                                width: "74px",
                                borderRadius: "4px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                bgcolor: "blue.300",
                                height: "10px",
                                width: "74px",
                                borderRadius: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        bgcolor: "blue.300",
                        height: "10px",
                        width: "74px",
                        borderRadius: "4px"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var skeleton = (CardSkeleton);

// EXTERNAL MODULE: ./providers/AppData/Profile/index.tsx
var Profile = __webpack_require__(33228);
// EXTERNAL MODULE: ./api/profile.ts
var api_profile = __webpack_require__(1259);
;// CONCATENATED MODULE: ./components/profiles/Media/Posts/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function Posts_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Posts_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Posts_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var isYouTubeOrVimeo = function(url) {
    return global/* YOUTUBE_REGEX.test */.Hf.test(url) || global/* VIMEO_REGEX.test */.Mf.test(url);
};
var ProfilePosts = function(param) {
    var posts = param.posts, introductionVideo = param.introductionVideo, _setVideoPlayerVisibility = param.setVideoPlayerVisibility, setVideoPlayerVisibility = _setVideoPlayerVisibility === void 0 ? function() {
        return null;
    } : _setVideoPlayerVisibility, className = param.className, title = param.title, subtitle = param.subtitle, sortByDateText = param.sortByDateText, loadMoreText = param.loadMoreText, onVimeoOrYouTubeClick = param.onVimeoOrYouTubeClick, triggerVideoAnalytics = param.triggerVideoAnalytics, triggerArticleAnalytics = param.triggerArticleAnalytics, triggerIntroVideoAnalytics = param.triggerIntroVideoAnalytics;
    var ref, ref1;
    var profile = (0,react.useContext)(Profile/* ProfileContext */.J);
    var practiceId = profile === null || profile === void 0 ? void 0 : (ref = profile.practice) === null || ref === void 0 ? void 0 : ref.id;
    var specialistId = profile === null || profile === void 0 ? void 0 : (ref1 = profile.specialist) === null || ref1 === void 0 ? void 0 : ref1.id;
    var handleOpenVideoPlayer = function() {
        return setVideoPlayerVisibility(true);
    };
    var amountPerLoad = 6;
    var ref2 = (0,react.useState)(posts.slice(0, className === "videos" && !introductionVideo ? 6 : 4)), sortedData = ref2[0], setSortedData = ref2[1];
    var ref3 = (0,react.useState)(false), sortByDateEnabled = ref3[0], setSortByDateEnabled = ref3[1];
    var translate = (0,useTranslateMessage/* default */.Z)();
    var postsAvailable = Boolean(!posts || !!posts.length);
    var router = (0,next_router.useRouter)();
    var locale = router.locale || router.defaultLocale;
    var sortByDate = function(videos) {
        return videos.sort(function(a, b) {
            var dateA = Date.parse(a.date || a.createdAt);
            var dateB = Date.parse(b.date || b.createdAt);
            return dateB - dateA;
        });
    };
    var handleSortByDate = function() {
        setSortedData(function(prevState) {
            return sortByDate(_toConsumableArray(prevState));
        });
        setSortByDateEnabled(true);
    };
    var loadMore = function() {
        var moreVideos = posts.slice(sortedData.length, sortedData.length + amountPerLoad);
        if (sortByDateEnabled) {
            setSortedData(function(prevState) {
                return _toConsumableArray(prevState).concat(_toConsumableArray(sortByDate(moreVideos)));
            });
        } else {
            setSortedData(function(prevState) {
                return _toConsumableArray(prevState).concat(_toConsumableArray(moreVideos));
            });
        }
    };
    var handleAnalytics = function(mediaId) {
        if (triggerVideoAnalytics) {
            triggerVideoAnalytics();
        }
        if (triggerArticleAnalytics) {
            triggerArticleAnalytics();
        }
        (0,api_profile/* sendMediaStats */._)({
            mediaId: mediaId,
            practiceId: practiceId,
            specialistId: specialistId,
            locale: locale
        });
    };
    var handleClickIntroVideo = function() {
        if (triggerIntroVideoAnalytics) {
            triggerIntroVideoAnalytics();
        }
        handleOpenVideoPlayer();
        if (introductionVideo === null || introductionVideo === void 0 ? void 0 : introductionVideo.id) {
            (0,api_profile/* sendMediaStats */._)({
                mediaId: introductionVideo === null || introductionVideo === void 0 ? void 0 : introductionVideo.id,
                practiceId: practiceId,
                specialistId: specialistId,
                locale: locale
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostsWrapper, {
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaContentWrapper, {
                display: "grid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        justifyContent: "space-between",
                        gap: "8px",
                        mb: "24px",
                        alignItems: "end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                item: true,
                                color: "common.white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsTitle, {
                                        component: "h3",
                                        children: !postsAvailable && className === "articles" ? translate("media_center.articles.unavailable_title") : title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        maxWidth: "560px",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        children: !postsAvailable && className === "articles" ? "" : subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: postsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: posts.length > 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDateButton, {
                                        onClick: handleSortByDate,
                                        variant: "ghost",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            color: "common.white",
                                            children: sortByDateText
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostsWrapper, {
                        children: [
                            introductionVideo && introductionVideo.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                className: "introduction-video",
                                onClick: handleClickIntroVideo,
                                sx: {
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Posts_IntroductionVideo, Posts_objectSpread({}, introductionVideo))
                            }),
                            sortedData.map(function(post, index) {
                                return (post === null || post === void 0 ? void 0 : post.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, Posts_objectSpread({
                                    onClick: function() {
                                        handleAnalytics(post.id);
                                        if (isYouTubeOrVimeo(post.link)) {
                                            onVimeoOrYouTubeClick === null || onVimeoOrYouTubeClick === void 0 ? void 0 : onVimeoOrYouTubeClick(post.link);
                                        }
                                    },
                                    isLink: !isYouTubeOrVimeo(post.link),
                                    horizontal: index === 0 && className === "articles" && sortedData.length > 3
                                }, post), "profile-".concat(className, "-").concat(post.id));
                            }),
                            !introductionVideo && !postsAvailable && className === "videos" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        borderRadius: "4px",
                                        maxWidth: "665px",
                                        width: "100%",
                                        className: "introduction-video",
                                        bgcolor: "blue.400",
                                        p: "37px 50px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                fontSize: "24px",
                                                fontWeight: "600",
                                                mb: "1.41",
                                                children: translate("media_center.videos.unavailable_title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                fontSize: "14px",
                                                children: translate("media_center.videos.unavailable_subtitle")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                        mdDown: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                                            sx: {
                                                borderRadius: "4px",
                                                objectFit: "cover",
                                                width: "100%",
                                                height: "100%"
                                            },
                                            lazy: true,
                                            src: global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                                            alt: title
                                        })
                                    })
                                ]
                            }),
                            !postsAvailable && className === "articles" && Array(3).fill(1).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton, {}, "card-skeleton-".concat(index));
                            })
                        ]
                    }),
                    sortedData.length !== posts.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                        container: true,
                        justifyContent: "center",
                        mb: "100px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                            sx: {
                                borderColor: "common.white",
                                color: "common.white",
                                borderRadius: "32px",
                                padding: "8px 24px",
                                position: "relative",
                                zIndex: 1
                            },
                            onClick: loadMore,
                            variant: "outlined",
                            children: loadMoreText
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Posts = (ProfilePosts);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Lazy/index.esm.js
var Lazy_index_esm = __webpack_require__(46526);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/User/index.esm.js



const UserIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "23", height: "23", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M11.5588 21.8975C17.3578 21.8975 22.0588 17.1965 22.0588 11.3975C22.0588 5.59847 17.3578 0.897461 11.5588 0.897461C5.75985 0.897461 1.05884 5.59847 1.05884 11.3975C1.05884 17.1965 5.75985 21.8975 11.5588 21.8975Z", fill: "#B4FFFB" }),
    react.createElement("path", { d: "M11.5588 21.8975C17.3578 21.8975 22.0588 17.1965 22.0588 11.3975C22.0588 5.59847 17.3578 0.897461 11.5588 0.897461C5.75985 0.897461 1.05884 5.59847 1.05884 11.3975C1.05884 17.1965 5.75985 21.8975 11.5588 21.8975Z", fill: "url(#paint0_linear_6164_3388)", fillOpacity: "0.7" }),
    react.createElement("path", { d: "M11.5588 21.8975C17.3578 21.8975 22.0588 17.1965 22.0588 11.3975C22.0588 5.59847 17.3578 0.897461 11.5588 0.897461C5.75985 0.897461 1.05884 5.59847 1.05884 11.3975C1.05884 17.1965 5.75985 21.8975 11.5588 21.8975Z", stroke: "#001552", strokeMiterlimit: "10", strokeLinecap: "round", fill: "transparent", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M11.5587 15.2156C9.45007 15.2156 7.74048 13.506 7.74048 11.3974V9.48835C7.74048 7.37976 9.45007 5.67017 11.5587 5.67017C13.6673 5.67017 15.3768 7.37976 15.3768 9.48835V11.3974C15.3768 13.506 13.6673 15.2156 11.5587 15.2156Z", fill: "white", stroke: "#001552", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M17.2863 19.9884C16.2532 18.2683 14.685 17.1248 12.9657 17.1248H10.1495C8.41563 17.1248 6.86483 18.2344 5.83174 19.9797", stroke: "#001552", fill: "transparent", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("defs", null,
        react.createElement("linearGradient", { id: "paint0_linear_6164_3388", x1: "1.05884", y1: "11.3975", x2: "22.0588", y2: "11.3975", gradientUnits: "userSpaceOnUse" },
            react.createElement("stop", { stopColor: "#B4FFFB" }),
            react.createElement("stop", { offset: "0.9999", stopColor: "#00E5D0" }),
            react.createElement("stop", { offset: "1", stopColor: "#00E5D0" })))));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/ArrowRightTop/index.esm.js


const ArrowRightTop = (props) => (react.createElement("svg", Object.assign({ width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.98709 1.99711L1.98709 2.0004L9.88547 2.00747L1.27998 10.613C0.889455 11.0035 0.889455 11.6367 1.27998 12.0272C1.6705 12.4177 2.30367 12.4177 2.69419 12.0272L11.2997 3.42169L11.3068 11.3201H11.3094C11.3005 11.5862 11.3975 11.8551 11.6007 12.0582C11.9898 12.4474 12.6207 12.4474 13.0098 12.0582C13.2146 11.8534 13.3116 11.5817 13.3008 11.3134L13.3008 0.00636038L2.03557 0.00636036C1.76022 -0.0107931 1.4791 0.0858392 1.26868 0.296257C0.879569 0.685372 0.879569 1.31625 1.26868 1.70537C1.46676 1.90345 1.72749 2.00069 1.98709 1.99711Z", fill: "#1A3586" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
;// CONCATENATED MODULE: ./components/profiles/Media/Socials/styles.ts
function Socials_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var ProfileSocialsWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "articlesAvailable";
    }
})(function(param) {
    var theme = param.theme, articlesAvailable = param.articlesAvailable;
    var _obj;
    return _obj = {
        backgroundColor: theme.palette.blue[400],
        position: "relative",
        padding: "100px 0 50px 0"
    }, Socials_styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        padding: "40px 0 10px 0"
    }), Socials_styles_defineProperty(_obj, "& > *", {
        position: "relative",
        zIndex: 1
    }), Socials_styles_defineProperty(_obj, "&:before", {
        content: '""',
        position: "absolute",
        top: "-200px",
        width: "200px",
        height: "200px",
        borderBottomLeftRadius: "100px",
        boxShadow: "0 100px 0 0 ".concat(theme.palette.blue[400]),
        zIndex: 0
    }), Socials_styles_defineProperty(_obj, "&:after", {
        content: '""',
        position: "absolute",
        right: 0,
        top: "0",
        width: "200px",
        height: "200px",
        borderTopRightRadius: "100px",
        boxShadow: "0 -100px 0 0 ".concat(articlesAvailable ? theme.palette.blue[900] : theme.palette.primary.dark),
        zIndex: 0
    }), _obj;
});
var SocialComponentWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isLightVariant";
    }
})(function(param) {
    var isLightVariant = param.isLightVariant;
    return {
        maxWidth: "311px",
        width: "100%",
        height: "114px",
        position: "relative",
        borderRadius: "16px",
        background: isLightVariant ? "#557AE6" : "#112971",
        "&:hover": {
            background: isLightVariant ? "#112971" : "#557AE6"
        }
    };
});
var SocialsTitle = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return Socials_styles_defineProperty({
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "50px"
    }, theme.breakpoints.down("sm"), {
        marginBottom: "20px"
    });
});
var WebsiteLink = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        zIndex: 1,
        textDecoration: "none",
        p: {
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "22.4px",
            color: theme.palette.text.darkNavy
        }
    };
});
var SocialsWrapper = (0,styled_esm/* default */.ZP)(PostsWrapper)(function(param) {
    var theme = param.theme;
    return Socials_styles_defineProperty({}, theme.breakpoints.down("sm"), {
        marginBottom: "50px"
    });
});

;// CONCATENATED MODULE: ./components/profiles/Media/Socials/index.tsx
function Socials_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Socials_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Socials_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var validateLinkProtocol = function(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return "http://".concat(url);
    }
    return url;
};
var SocialComponent = function(param) {
    var type = param.type, _profileName = param.profileName, profileName = _profileName === void 0 ? "" : _profileName, isUnclaimed = param.isUnclaimed, profileImage = param.profileImage, link = param.link, onClick = param.onClick;
    var initials = (0,variants_default/* getInitialsFromFullName */.u)(profileName);
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var socialLinksData = (0,react.useMemo)(function() {
        return {
            tiktok: {
                // todo: fix lint
                // eslint-disable-next-line sonarjs/no-nested-template-literals
                socialLink: "https://www.tiktok.com/".concat(!link.includes("@") ? "@".concat(link) : link),
                isLightVariant: false,
                imageWidth: "121px",
                imageHeight: "121px",
                iconPosition: {
                    top: "12.5px",
                    right: "-14px"
                }
            },
            instagram: {
                socialLink: "https://www.instagram.com/".concat(link.replace("@", "")),
                isLightVariant: false,
                imageWidth: "111px",
                imageHeight: "111px",
                iconPosition: {
                    top: "17px",
                    right: "-13px"
                }
            },
            twitter: {
                socialLink: "https://www.twitter.com/".concat(link.replace("@", "")),
                isLightVariant: true,
                imageWidth: "147px",
                imageHeight: "126px",
                iconPosition: {
                    top: "9px",
                    left: "27%"
                }
            },
            facebook: {
                socialLink: "https://www.facebook.com/".concat(link.replace("@", "")),
                isLightVariant: true,
                imageWidth: "127px",
                imageHeight: "128px",
                iconPosition: {
                    top: "-8px",
                    right: "5px"
                }
            }
        };
    }, [
        link
    ]);
    var _type = socialLinksData[type], socialLink = _type.socialLink, isLightVariant = _type.isLightVariant, imageWidth = _type.imageWidth, imageHeight = _type.imageHeight, iconPosition = _type.iconPosition;
    var handleMouseEnter = function() {
        return setIsHover(true);
    };
    var handleMouseLeave = function() {
        return setIsHover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: socialLink,
        rel: "noopener nofollow",
        onClick: onClick,
        target: "_blank",
        style: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialComponentWrapper, {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            isLightVariant: isLightVariant,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    height: "100%",
                    p: "0 11px",
                    gap: "16px",
                    alignItems: "center",
                    wrap: "nowrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            width: 86,
                            height: 86,
                            src: isUnclaimed ? undefined : profileImage,
                            alt: profileName,
                            sx: {
                                backgroundColor: "blue.200",
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "h2",
                                children: initials
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            sx: {
                                maxWidth: "60%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                zIndex: 1
                            },
                            fontWeight: "600",
                            fontSize: "16px",
                            lineHeight: "22.4px",
                            color: "common.white",
                            children: "@".concat(link.replace("@", ""))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lazy_index_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: Socials_objectSpread({
                            position: "absolute",
                            zIndex: 0,
                            height: imageHeight,
                            width: imageWidth
                        }, iconPosition),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/hermes-static/images/socials/".concat(type).concat(isHover ? "-hover" : "", ".svg"),
                            alt: "",
                            width: imageWidth,
                            height: imageHeight,
                            style: {
                                margin: "auto"
                            }
                        })
                    })
                })
            ]
        })
    });
};
var WebsiteLinkComponent = function(param) {
    var triggerWebAnalytics = param.triggerWebAnalytics, sendSocialsAnalytics = param.sendSocialsAnalytics, website = param.website, sx = param.sx;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var additionalRel = (0,react.useMemo)(function() {
        return Card/* NOFOLLOW_EXCEPTION.some */.E.some(function(exceptionPart) {
            return website.link.includes(exceptionPart);
        }) ? "" : " nofollow";
    }, [
        website.link
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WebsiteLink, {
        sx: sx,
        href: validateLinkProtocol(website.link),
        rel: "noopener".concat(additionalRel),
        target: "_blank",
        onClick: function() {
            triggerWebAnalytics();
            sendSocialsAnalytics(website.id);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {
                sx: {
                    marginRight: "10px",
                    width: "21px",
                    height: "21px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_esm/* default */.Z, {
                sx: {
                    textDecoration: "underline"
                },
                children: [
                    translate("media_center.socials.visit_website"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightTop, {
                        style: {
                            height: "20px",
                            marginLeft: "10px",
                            marginBottom: "-5px"
                        }
                    })
                ]
            })
        ]
    });
};
var ProfileSocials = function(param) {
    var socials = param.socials, isUnclaimed = param.isUnclaimed, isBasic = param.isBasic, profileImage = param.profileImage, profileName = param.profileName, triggerWebAnalytics = param.triggerWebAnalytics, triggerSocialsAnalytics = param.triggerSocialsAnalytics, articlesAvailable = param.articlesAvailable, websiteLink = param.websiteLink;
    var ref, ref1;
    var socialsWithoutWebsite = socials.filter(function(social) {
        return social.type !== "website";
    });
    var website = websiteLink;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var profile = (0,react.useContext)(Profile/* ProfileContext */.J);
    var practiceId = profile === null || profile === void 0 ? void 0 : (ref = profile.practice) === null || ref === void 0 ? void 0 : ref.id;
    var specialistId = profile === null || profile === void 0 ? void 0 : (ref1 = profile.specialist) === null || ref1 === void 0 ? void 0 : ref1.id;
    var router = (0,next_router.useRouter)();
    var locale = router.locale || router.defaultLocale;
    var sendSocialsAnalytics = function(mediaId) {
        (0,api_profile/* sendMediaStats */._)({
            mediaId: mediaId,
            practiceId: practiceId,
            specialistId: specialistId,
            locale: locale
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "socials",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSocialsWrapper, {
            articlesAvailable: articlesAvailable,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialsTitle, {
                        container: true,
                        children: [
                            !!socialsWithoutWebsite.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsTitle, {
                                component: "h3",
                                color: "text.darkNavy",
                                children: translate("media_center.socials")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                smDown: true,
                                children: (website === null || website === void 0 ? void 0 : website.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteLinkComponent, {
                                    website: website,
                                    sendSocialsAnalytics: sendSocialsAnalytics,
                                    triggerWebAnalytics: triggerWebAnalytics
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialsWrapper, {
                        children: [
                            socialsWithoutWebsite.map(function(social) {
                                return social.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialComponent, Socials_objectSpread({
                                    onClick: function() {
                                        triggerSocialsAnalytics(social.type);
                                        sendSocialsAnalytics(social.id);
                                    },
                                    profileName: profileName,
                                    isBasic: isBasic,
                                    isUnclaimed: isUnclaimed,
                                    profileImage: profileImage
                                }, social), "social-link-".concat(social.id));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                smUp: true,
                                children: (website === null || website === void 0 ? void 0 : website.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteLinkComponent, {
                                    website: website,
                                    sx: {
                                        marginTop: socialsWithoutWebsite.length ? "20px" : 0
                                    },
                                    sendSocialsAnalytics: sendSocialsAnalytics,
                                    triggerWebAnalytics: triggerWebAnalytics
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Socials = (ProfileSocials);

;// CONCATENATED MODULE: ./components/profiles/Media/styles.ts

var SocialsUnavailable = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "articlesAvailable";
    }
})(function(param) {
    var theme = param.theme, articlesAvailable = param.articlesAvailable;
    return {
        position: "relative",
        backgroundColor: theme.palette.common.white,
        paddingBottom: "100px",
        "&:before": {
            content: '""',
            position: "absolute",
            top: "-200px",
            width: "200px",
            height: "200px",
            borderBottomLeftRadius: "100px",
            boxShadow: "0 100px 0 0 ".concat(theme.palette.common.white)
        },
        "&:after": {
            content: '""',
            position: "absolute",
            right: 0,
            top: "-100",
            width: "200px",
            height: "200px",
            borderTopRightRadius: "100px",
            boxShadow: "0 -100px 0 0 ".concat(articlesAvailable ? theme.palette.blue[900] : theme.palette.primary.dark)
        }
    };
});

// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/profiles/Media/index.tsx
function Media_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Media_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Media_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var MediaVideoPlayerModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7207), __webpack_require__.e(8035)]).then(__webpack_require__.bind(__webpack_require__, 66225));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66225)
            ];
        }
    },
    ssr: false
});
var MediaCenter = function(param) {
    var profileImage = param.profileImage, profileName = param.profileName, isBasic = param.isBasic, isUnclaimed = param.isUnclaimed, posts = param.posts, setVideoPlayerVisibility = param.setVideoPlayerVisibility, profileAnalytics = param.profileAnalytics;
    var ref = (0,react.useState)(""), selectVideoUrl = ref[0], setSelectVideoUrl = ref[1];
    var videoPosts = posts.filter(function(post) {
        return post.type === "video" && post.enabled;
    });
    var introductionVideo = posts.filter(function(post) {
        return post.type === "profile" && post.enabled;
    })[0];
    var articlePosts = posts.filter(function(post) {
        return post.type === "article" && post.enabled;
    });
    var socials = posts.filter(function(post) {
        return ![
            "video",
            "profile",
            "article",
            "publication",
            "website"
        ].includes(post.type) && post.enabled;
    });
    var websiteLink = posts.filter(function(post) {
        return post.type === "website" && post.enabled;
    })[0];
    var videosAvailable = videoPosts && !!videoPosts.length || !!introductionVideo;
    var articlesAvailable = articlePosts && !!articlePosts.length;
    var socialsAvailable = socials && !!socials.length;
    var websiteLinkAvailable = posts.some(function(post) {
        return post.type === "website" && post.enabled;
    });
    var translate = (0,useTranslateMessage/* default */.Z)();
    var triggerIntroVideoAnalytics = function() {
        if (window) {
            window.dataLayer.push(Media_objectSpread({
                event: "prf_pg_prf_vid_click",
                cont_prf_name: profileName
            }, profileAnalytics));
        }
    };
    var triggerVideoAnalytics = function() {
        if (window) {
            window.dataLayer.push(Media_objectSpread({
                event: "prf_pg_mc_vid_click",
                cont_prf_name: profileName
            }, profileAnalytics));
        }
    };
    var triggerArticleAnalytics = function() {
        if (window) {
            window.dataLayer.push(Media_objectSpread({
                event: "prf_pg_mc_art_click",
                cont_prf_name: profileName
            }, profileAnalytics));
        }
    };
    var triggerSocialsAnalytics = function(type) {
        if (window) {
            window.dataLayer.push(Media_objectSpread({
                event: "prf_pg_mc_soc_click",
                sc_type: type,
                cont_prf_name: profileName
            }, profileAnalytics));
        }
    };
    var triggerWebAnalytics = function() {
        if (window) {
            window.dataLayer.push(Media_objectSpread({
                event: "prf_pg_mc_web_click",
                cont_prf_name: profileName
            }, profileAnalytics));
        }
    };
    var onVideoClick = (0,react.useCallback)(function(url) {
        return setSelectVideoUrl(url);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        bgcolor: "primary.dark",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                videosAvailable: videosAvailable,
                articlesAvailable: articlesAvailable,
                socialsAvailable: socialsAvailable,
                websiteLinkAvailable: websiteLinkAvailable,
                isBasic: isBasic,
                name: profileName,
                image: profileImage,
                isUnclaimed: isUnclaimed
            }),
            videosAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Posts, {
                sortByDateText: translate("media_center.view_latest_videos"),
                loadMoreText: translate("media_center.load_more"),
                onVimeoOrYouTubeClick: onVideoClick,
                className: "videos",
                title: translate("media_center.videos.title"),
                subtitle: translate("media_center.videos.subtitle", {
                    name: profileName
                }),
                posts: videoPosts,
                introductionVideo: introductionVideo,
                setVideoPlayerVisibility: setVideoPlayerVisibility,
                triggerIntroVideoAnalytics: triggerIntroVideoAnalytics,
                triggerVideoAnalytics: triggerVideoAnalytics
            }),
            articlesAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Posts, {
                sortByDateText: translate("media_center.view_latest_articles"),
                loadMoreText: translate("media_center.load_more_articles"),
                onVimeoOrYouTubeClick: onVideoClick,
                className: "articles",
                title: translate("media_center.articles.title"),
                subtitle: translate("media_center.articles.subtitle", {
                    name: profileName
                }),
                posts: articlePosts,
                triggerArticleAnalytics: triggerArticleAnalytics
            }),
            socialsAvailable || websiteLinkAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Socials, {
                websiteLink: websiteLink,
                socials: socials,
                articlesAvailable: articlesAvailable,
                isBasic: isBasic,
                profileName: profileName,
                profileImage: profileImage,
                isUnclaimed: isUnclaimed,
                triggerWebAnalytics: triggerWebAnalytics,
                triggerSocialsAnalytics: triggerSocialsAnalytics
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialsUnavailable, {
                articlesAvailable: articlesAvailable
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaVideoPlayerModal, {
                url: selectVideoUrl,
                isOpen: !!selectVideoUrl,
                onClose: function() {
                    return setSelectVideoUrl("");
                }
            })
        ]
    });
};
/* harmony default export */ var Media = (MediaCenter);


/***/ }),

/***/ 25954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ NavButton; },
  "Z": function() { return /* binding */ specialist_OtherTopRated; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@splidejs/react-splide/dist/css/splide.min.css
var splide_min = __webpack_require__(71762);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/theme/index.esm.js + 26 modules
var index_esm = __webpack_require__(1189);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/index.esm.js + 2 modules
var Carousel_index_esm = __webpack_require__(725);
// EXTERNAL MODULE: ../../../node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(30051);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Paper/Paper.esm.js + 2 modules
var Paper_esm = __webpack_require__(41212);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/LocationOn/index.esm.js
var LocationOn_index_esm = __webpack_require__(67227);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var Rating_index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ./utils/getAbbreviation.ts
var getAbbreviation = __webpack_require__(62954);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./utils/address.ts
var address = __webpack_require__(93953);
// EXTERNAL MODULE: ./components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(80292);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./utils/checkProfileSlugRedirect.ts
var checkProfileSlugRedirect = __webpack_require__(94826);
;// CONCATENATED MODULE: ./components/profiles/specialist/OtherSpecialists/SpecialistCard.tsx









function SpecialistCard(param) {
    var specialist = param.specialist;
    var ref14, ref1, ref2, ref3, ref4, ref5;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref6 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref6.language, tenantSettings = ref6.tenantSettings;
    var ref7 = (0,react.useMemo)(function() {
        var ref, ref8, ref9, ref10, ref11, ref12;
        var ref13;
        var specialistTitle = (ref13 = specialist === null || specialist === void 0 ? void 0 : (ref = specialist.title) === null || ref === void 0 ? void 0 : ref[language]) !== null && ref13 !== void 0 ? ref13 : specialist === null || specialist === void 0 ? void 0 : (ref8 = specialist.title) === null || ref8 === void 0 ? void 0 : ref8.en;
        var specialistFirstName = ((ref9 = specialist.firstName) === null || ref9 === void 0 ? void 0 : ref9[language]) || (specialist === null || specialist === void 0 ? void 0 : (ref10 = specialist.firstName) === null || ref10 === void 0 ? void 0 : ref10.en);
        var specialistLastName = ((ref11 = specialist.lastName) === null || ref11 === void 0 ? void 0 : ref11[language]) || (specialist === null || specialist === void 0 ? void 0 : (ref12 = specialist.lastName) === null || ref12 === void 0 ? void 0 : ref12.en);
        return {
            specialistFullName: "".concat(specialistTitle, " ").concat(specialistFirstName, " ").concat(specialistLastName).trim(),
            addressToTransform: (0,address/* getAddressFromPractices */.zz)(specialist.practices)
        };
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        specialist
    ]), specialistFullName = ref7.specialistFullName, addressToTransform = ref7.addressToTransform;
    var topLevelKeyword = (0,react.useMemo)(function() {
        var ref;
        var topKeyword = (specialist === null || specialist === void 0 ? void 0 : (ref = specialist.keywords) === null || ref === void 0 ? void 0 : ref.filter(function(k) {
            return k.isTopLevelChild;
        })) || [];
        return {
            topLevelKeyword: topKeyword.filter(function(keyword) {
                return keyword.keywordType === "specialty";
            })
        };
    }, [
        specialist.keywords
    ]).topLevelKeyword;
    var nameAbbreviation = (0,getAbbreviation/* getAbbreviation */.T)({
        specialist: specialist,
        language: language
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper_esm/* default */.Z, {
        sx: {
            border: 1,
            borderColor: index_esm/* theme.palette.background.default */.rS.palette.background["default"],
            p: 2,
            height: "100%",
            boxShadow: "0px 6px 10px rgba(2, 3, 3, 0.03), 0px 1px 18px rgba(2, 3, 3, 0.02), 0px 3px 5px rgba(2, 3, 3, 0.04)",
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
            href: (0,checkProfileSlugRedirect/* fixSlug */.j)(specialist.slug),
            underline: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                gap: "16px",
                direction: "row",
                justifyContent: "space-between",
                borderRadius: "8px",
                bgcolor: "white",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        alignItems: "flex-start",
                        item: true,
                        columnSpacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    alt: specialistFullName,
                                    width: 64,
                                    height: 64,
                                    src: specialist === null || specialist === void 0 ? void 0 : (ref14 = specialist.images) === null || ref14 === void 0 ? void 0 : ref14.logo,
                                    withDoctifyCDNLoader: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                        variant: "body2",
                                        fontSize: 24,
                                        textTransform: "uppercase",
                                        children: nameAbbreviation
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                item: true,
                                xs: true,
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            variant: "h4",
                                            component: "h4",
                                            color: "text.primary",
                                            fontWeight: 600,
                                            gutterBottom: true,
                                            p: 0,
                                            children: specialistFullName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            variant: "body2",
                                            color: "text.disabled",
                                            children: (topLevelKeyword === null || topLevelKeyword === void 0 ? void 0 : (ref1 = topLevelKeyword[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.practitioner) === null || ref2 === void 0 ? void 0 : ref2[language]) || ""
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        item: true,
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                xs: "auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    variant: "body2",
                                    color: "text.disabled",
                                    children: addressToTransform ? (0,address/* transformAddressToString */.CU)(addressToTransform, language) : tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.defaultLocations[0].name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                        alignSelf: "flex-end",
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper_esm/* default */.Z, {
                            sx: {
                                px: 2,
                                py: 1.5,
                                boxShadow: "none",
                                backgroundColor: "background.default"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                        item: true,
                                        display: "flex",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                            color: "primary.dark",
                                            variant: "h2",
                                            fontWeight: 900,
                                            children: (ref3 = specialist.review) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.averageRating) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        item: true,
                                        xs: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_index_esm/* default */.Z, {
                                                    value: (ref5 = specialist.review) === null || ref5 === void 0 ? void 0 : ref5.averageRating,
                                                    size: "small",
                                                    readOnly: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: "(".concat(translate("reviews.total_patient_reviews", {
                                                        total: specialist.reviewsTotal
                                                    }), ")")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var OtherSpecialists_SpecialistCard = (SpecialistCard);

// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
;// CONCATENATED MODULE: ./components/profiles/specialist/OtherTopRated.tsx







var NavButton = function(param) {
    var text = param.text, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
        variant: "outlined",
        component: Link_esm/* default */.Z,
        href: href,
        sx: {
            borderRadius: "24px",
            padding: "8px 24px 8px 24px"
        },
        children: text
    });
};
var OtherTopRated = function(param) {
    var specialists = param.specialists, headerText = param.headerText, buttonText = param.buttonText, shortButtonText = param.shortButtonText, buttonLink = param.buttonLink, isRtl = param.isRtl;
    var isSmDown = (0,useMediaQuery_esm/* default */.Z)(index_esm/* theme.breakpoints.down */.rS.breakpoints.down("sm"));
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var buttonTextContent = isSmDown ? shortButtonText : buttonText;
    var NavigationButton = isWPA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButton, {
        text: buttonTextContent || "",
        href: buttonLink || ""
    });
    if (!(specialists === null || specialists === void 0 ? void 0 : specialists.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                variant: "body2",
                textTransform: "uppercase",
                sx: {
                    mb: 2
                },
                color: "text.darkNavy",
                fontWeight: "700",
                children: headerText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_index_esm/* Carousel */.lr, {
                breakpoints: {
                    610: {
                        perPage: 1
                    }
                },
                spaceBetween: 16,
                navigationElement: NavigationButton,
                slidesPerView: 2,
                slidesPerGroup: 1,
                isRtl: isRtl,
                vertical: false,
                navigation: true,
                navigationPosition: "bottom",
                children: specialists.map(function(s) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                            sx: {
                                pb: 2,
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherSpecialists_SpecialistCard, {
                                specialist: s
                            })
                        })
                    }, "other-specialist-".concat(s.id));
                })
            })
        ]
    });
};
/* harmony default export */ var specialist_OtherTopRated = (OtherTopRated);


/***/ }),

/***/ 20401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustBanner; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/TrustLarge/index.esm.js


const TrustLarge = () => (react.createElement("svg", { width: "34", height: "37", viewBox: "0 0 34 37", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { d: "M6.05277 23.7369C6.05277 23.7369 3.52645 25.4211 3.52645 28.1081C3.52645 30.7951 1.00014 32.4793 1.00014 32.4793L7.28786 31.7015L9.84224 36.3685C9.84224 36.3685 11.6949 35.9475 12.0317 33.6317C12.3686 31.3159 13.6317 30.8948 13.6317 30.8948", fill: "#B4FFFB" }),
    react.createElement("path", { d: "M6.05277 23.7369C6.05277 23.7369 3.52645 25.4211 3.52645 28.1081C3.52645 30.7951 1.00014 32.4793 1.00014 32.4793L7.28786 31.7015L9.84224 36.3685C9.84224 36.3685 11.6949 35.9475 12.0317 33.6317C12.3686 31.3159 13.6317 30.8948 13.6317 30.8948", stroke: "#2B59E0", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M27.9472 23.7369C27.9472 23.7369 30.4735 25.4211 30.4735 28.1081C30.4735 30.7951 32.9999 32.4793 32.9999 32.4793L26.7121 31.7015L24.1578 36.3685C24.1578 36.3685 22.3051 35.9475 21.9683 33.6317C21.6314 31.3159 20.3683 30.8948 20.3683 30.8948", fill: "#B4FFFB" }),
    react.createElement("path", { d: "M27.9472 23.7369C27.9472 23.7369 30.4735 25.4211 30.4735 28.1081C30.4735 30.7951 32.9999 32.4793 32.9999 32.4793L26.7121 31.7015L24.1578 36.3685C24.1578 36.3685 22.3051 35.9475 21.9683 33.6317C21.6314 31.3159 20.3683 30.8948 20.3683 30.8948", stroke: "#2B59E0", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("path", { d: "M29.6314 17.6659C29.6314 27.8103 16.9999 32.1579 16.9999 32.1579C16.9999 32.1579 4.36829 27.8103 4.36829 17.6659V3.89841L16.9999 1L29.6314 3.89841V17.6659Z", fill: "url(#paint0_radial_21_1948)", stroke: "#2B59E0" }),
    react.createElement("path", { d: "M10.2631 16.9999L15.3157 22.0525L25.421 10.2631", stroke: "#2B59E0", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
    react.createElement("defs", null,
        react.createElement("radialGradient", { id: "paint0_radial_21_1948", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(46.4735 32.1579) rotate(-147.381) scale(49.9901 75.7171)" },
            react.createElement("stop", { offset: "0.197917", stopColor: "#2B59E0" }),
            react.createElement("stop", { offset: "0.802083", stopColor: "#B4FFFB" })))));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./components/Icons/ArrowRightIcon.tsx
var ArrowRightIcon = __webpack_require__(2730);
;// CONCATENATED MODULE: ./components/profiles/specialist/TrustBanner.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var getLinkPath = function(locale) {
    if (locale.includes("de")) {
        return "/vertrauen/die-doctify-bewertungen";
    }
    return "/trust/about-doctify-reviews";
};
var LearnMore = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _objectSpread({}, theme.typography.caption, {
        color: theme.palette.common.white,
        textDecoration: "underline",
        marginRight: theme.spacing(0.5),
        fontWeight: 500,
        lineHeight: "18px"
    });
});
var exceptionBuilder = function(locale) {
    var objException = {
        "ar-ae": "en-ae"
    };
    var _locale;
    return (_locale = objException[locale]) !== null && _locale !== void 0 ? _locale : locale;
};
var SpecialistTrustBanner = function() {
    var translate = (0,useTranslateMessage/* default */.Z)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var resultLocale = exceptionBuilder(locale);
    var link = "/".concat(resultLocale, "/about").concat(getLinkPath(locale));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        sx: {
            py: 2
        },
        alignItems: "center",
        wrap: "nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustLarge, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                sx: {
                    ml: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        variant: "caption",
                        color: "common.white",
                        lineHeight: "18px",
                        fontWeight: "500",
                        sx: {
                            mb: 0
                        },
                        children: translate("profile.trust_banner")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnMore, {
                                href: link,
                                children: translate("learn_more_here")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                                reflectIfRtl: true,
                                sx: {
                                    fontSize: 12
                                },
                                color: "#fff"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TrustBanner = (SpecialistTrustBanner);


/***/ }),

/***/ 85977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useScrollEndEffect = function(callback, dependencies) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isScrolled = false;
        var timeoutId = null;
        var onScroll = function() {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(function() {
                if (!isScrolled) {
                    callback();
                    isScrolled = true;
                }
            }, 100);
        };
        window.addEventListener("scroll", onScroll);
        return function() {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            isScrolled = true;
            window.removeEventListener("scroll", onScroll);
        };
    }, [
        callback,
        dependencies
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollEndEffect);


/***/ }),

/***/ 94826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ fixSlug; },
/* harmony export */   "s": function() { return /* binding */ checkProfileSlugRedirect; }
/* harmony export */ });
var replaceWithDashRegexp = /[\s_]/g;
var isValidSlug = function(slug) {
    return !/_/.test(slug);
};
var checkProfileSlugRedirect = function(slug) {
    if (isValidSlug(slug)) {
        return null;
    }
    return slug.replace(replaceWithDashRegexp, "-");
};
var fixSlug = function(slug) {
    var fixedSlug = checkProfileSlugRedirect(slug);
    return !fixedSlug ? slug : fixedSlug;
};



/***/ }),

/***/ 725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* binding */ Carousel; },
  "qs": function() { return /* binding */ CarouselSlide; }
});

// UNUSED EXPORTS: AutoScroll, CarouselNavButton

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/react-intersection-observer/index.esm.js
var index_esm = __webpack_require__(92320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@splidejs/react-splide/dist/js/react-splide.esm.esm.js
var react_splide_esm_esm = __webpack_require__(29465);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/styles.esm.js




(0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    position: 'relative'
});
const NavigationContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: (prop) => prop !== 'bottom' && prop !== 'laterally' && prop !== 'inside' && prop !== 'navigationPosition'
})(({ navigationPosition, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (navigationPosition === 'bottom' && {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px'
})), { zIndex: 3 }), (navigationPosition === 'laterally' && {
    button: {
        position: 'absolute',
        zIndex: 500,
        top: 'calc(50% - 20px)',
        '&:first-of-type': {
            left: '-25px'
        },
        '&:last-of-type': {
            right: '-25px'
        }
    }
})), (navigationPosition === 'inside' && {
    position: 'absolute',
    display: 'flex',
    marginTop: '40px',
    width: '30%',
    justifyContent: 'center',
    gap: '10px',
    bottom: '50px',
    zIndex: 1
})), { [theme.breakpoints.down('sm')]: Object.assign({}, (navigationPosition === 'laterally' && {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        gap: '25px',
        marginTop: '35px',
        button: {
            left: '0 !important',
            right: '0 !important',
            position: 'relative'
        }
    })) })));
const NavButton = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z)(({ theme }) => ({
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    padding: 0,
    minWidth: 'auto',
    border: `0.2px solid ${theme.palette.common.white}`,
    backgroundColor: theme.palette.background.paper,
    transition: '0.2s',
    '&.Mui-disabled': {
        pointerEvents: 'auto !important',
        'svg > path': {
            fill: '#D9D9D9'
        },
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            'svg > path': {
                fill: '#D9D9D9'
            }
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        'svg > path': {
            fill: theme.palette.background.default
        }
    },
    [theme.breakpoints.down('sm')]: {
        width: '40px',
        height: '40px'
    }
}));
(0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    display: 'grid',
    gap: '45px',
    width: 'inherit',
    minHeight: 'max-content',
    '&>div': {
        width: 'inherit'
    }
});



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/theme/index.esm.js + 26 modules
var theme_index_esm = __webpack_require__(1189);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/CarouselArrow/index.esm.js





const CarouselArrow = (_a) => {
    var { color, rotation } = _a, props = (0,_tslib_esm/* __rest */._)(_a, ["color", "rotation"]);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ viewBox: "0 0 17 18" }, props, { sx: {
            transform: `rotate(${rotation}deg)`
        } }),
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.59233 2.40768L7.59 2.41L13.17 8L1 8C0.447716 8 9.24263e-08 8.44772 9.90123e-08 9C1.05598e-07 9.55229 0.447716 10 1 10L13.17 10L7.59 15.59L7.59186 15.5919C7.39739 15.7737 7.27585 16.0326 7.27585 16.3198C7.27585 16.8701 7.72195 17.3162 8.27224 17.3162C8.56187 17.3162 8.82264 17.1926 9.00469 16.9953L17 9L9.03428 1.03429C8.85171 0.827455 8.5846 0.697006 8.28703 0.697006C7.73673 0.697006 7.29063 1.14311 7.29063 1.6934C7.29063 1.97352 7.40623 2.22665 7.59233 2.40768Z", fill: color || theme_index_esm/* theme.palette.primary.main */.rS.palette.primary.main })));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/index.esm.js











const CarouselSlide = (0,styled_esm/* default */.ZP)(react_splide_esm_esm/* SplideSlide */.jw)({});
const CarouselNavButton = ({ onClick, type, refObj, sx = {} }) => (react.createElement(NavButton, { ref: refObj, sx: Object.assign({ backgroundColor: theme_index_esm/* theme.palette.background.default */.rS.palette.background["default"] }, sx), onClick: onClick, "aria-label": `carousel-navigation-${type}` },
    type === 'next' && react.createElement(CarouselArrow, null),
    type === 'prev' && react.createElement(CarouselArrow, { rotation: 180 })));
const Carousel = ({ children, slidesPerView = 3, navigation = false, navigationPosition = 'laterally', navigationElement = null, pagination = false, isRtl = false, spaceBetween, slidesPerGroup = 1, updateOnMove = false, loop = false, vertical = false, currentSlide = 0, verticalHeight, trimSpace = false, centerFocus = false, slidePadding = 0, wheel = false, lazyLoad = false, sx = {}, breakpoints = {}, disableDrag = false, options = {}, navButtonStyles = {}, onRefReady, extensions = {} }) => {
    const splide = (0,react.useRef)(null);
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const [perPage, setPerPage] = react.useState(slidesPerView);
    const { ref, inView } = (0,index_esm/* useInView */.YD)({
        triggerOnce: true,
        skip: !lazyLoad,
        trackVisibility: lazyLoad,
        delay: 500,
        threshold: 0.25
    });
    (0,react.useEffect)(() => {
        var _a, _b, _c;
        const splideInstance = (_a = splide === null || splide === void 0 ? void 0 : splide.current) === null || _a === void 0 ? void 0 : _a.splide;
        if (!splideInstance) {
            return;
        }
        if (inView && lazyLoad) {
            splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoplay: !!(options === null || options === void 0 ? void 0 : options.autoplay) });
            if (splideInstance.options.autoplay) {
                (_b = splideInstance.Components.Autoplay) === null || _b === void 0 ? void 0 : _b.play();
            }
            else {
                (_c = splideInstance.Components.Autoplay) === null || _c === void 0 ? void 0 : _c.pause();
            }
            if (options === null || options === void 0 ? void 0 : options.autoScroll) {
                splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoScroll: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.autoScroll : false, extensions: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.extensions : {} });
                splideInstance.destroy();
                splideInstance.mount();
            }
        }
    }, [inView, lazyLoad, options === null || options === void 0 ? void 0 : options.autoScroll, options === null || options === void 0 ? void 0 : options.autoplay, options === null || options === void 0 ? void 0 : options.extensions]);
    (0,react.useEffect)(() => {
        if (onRefReady) {
            onRefReady(splide.current);
        }
    }, [onRefReady]);
    (0,react.useEffect)(() => {
        if (splide.current) {
            splide.current.go(currentSlide);
        }
    }, [currentSlide, splide]);
    const handleNext = () => {
        var _a;
        (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('+1');
    };
    const handlePrev = () => { var _a; return (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('-1'); };
    const directionScroll = (0,react.useMemo)(() => (isRtl ? 'rtl' : 'ltr'), [isRtl]);
    return (react.createElement(Grid_esm/* default */.ZP, { ref: ref, md: 12, lg: 12, xs: 12, sx: sx },
        react.createElement(react_splide_esm_esm/* Splide */.tv, { ref: splide, options: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (vertical
                ? {
                    direction: 'ttb',
                    height: `${verticalHeight}px`,
                    trimSpace,
                    focus: centerFocus ? 'center' : undefined
                }
                : {})), { type: loop ? 'loop' : 'slide', direction: directionScroll, paginationDirection: directionScroll, perPage: slidesPerView, perMove: slidesPerGroup, pagination, arrows: false, gap: spaceBetween, updateOnMove, padding: `${slidePadding}rem`, wheel, drag: !disableDrag, breakpoints }), (lazyLoad
                ? {
                    lazyLoad: 'nearby'
                }
                : {})), options), { autoScroll: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoScroll, autoplay: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoplay }), onMounted: (e) => {
                setPerPage((e === null || e === void 0 ? void 0 : e.options.perPage) || slidesPerView);
            }, extensions: extensions }, children),
        react.createElement(Grid_esm/* default */.ZP, { sx: { display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'space-between', width: '100%' } },
            navigationElement,
            navigation && react.Children.count(children) > perPage && (react.createElement(NavigationContainer, { navigationPosition: navigationPosition },
                react.createElement(CarouselNavButton, { refObj: prevRef, sx: navButtonStyles, onClick: handlePrev, type: isRtl ? 'next' : 'prev' }),
                react.createElement(CarouselNavButton, { refObj: nextRef, sx: navButtonStyles, onClick: handleNext, type: isRtl ? 'prev' : 'next' }))))));
};




/***/ }),

/***/ 37727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DonutChart; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);


const DonutChart = ({ data, width = 200, height = 200, thickness = 3 }) => {
    const total = data.reduce((sum, item) => sum + item.value, 0);
    const calculateOffset = (index) => {
        if (index === 0) {
            return 0;
        }
        return data.slice(0, index).reduce((sum, item) => sum + (item.value / total) * 100, 0);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: width, height: height, viewBox: "0 0 42 42", className: "donut" }, data.map((item, index) => {
        const offset = calculateOffset(index);
        const valuePercentage = (item.value / total) * 100;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { key: `donut-segment-${item.name}`, className: "donut-segment", cx: "21", cy: "21", r: "15.91549431", fill: "transparent", stroke: item.color, strokeWidth: thickness, strokeDasharray: `${valuePercentage} ${100 - valuePercentage}`, strokeDashoffset: -offset }));
    })));
};




/***/ })

}]);